var n$1, l$4, u$5, i$5, r$3, o$2, e$2, f$3, c$4, s$4, a$4, p$3 = {}, v$2 = [], y$2 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, d$2 = Array.isArray;
function w$2(n2, l2) {
  for (var u2 in l2) n2[u2] = l2[u2];
  return n2;
}
function g$1(n2) {
  n2 && n2.parentNode && n2.parentNode.removeChild(n2);
}
function _$1(l2, u2, t2) {
  var i2, r2, o2, e2 = {};
  for (o2 in u2) "key" == o2 ? i2 = u2[o2] : "ref" == o2 ? r2 = u2[o2] : e2[o2] = u2[o2];
  if (arguments.length > 2 && (e2.children = arguments.length > 3 ? n$1.call(arguments, 2) : t2), "function" == typeof l2 && null != l2.defaultProps) for (o2 in l2.defaultProps) void 0 === e2[o2] && (e2[o2] = l2.defaultProps[o2]);
  return m$2(l2, e2, i2, r2, null);
}
function m$2(n2, t2, i2, r2, o2) {
  var e2 = { type: n2, props: t2, key: i2, ref: r2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == o2 ? ++u$5 : o2, __i: -1, __u: 0 };
  return null == o2 && null != l$4.vnode && l$4.vnode(e2), e2;
}
function k$1(n2) {
  return n2.children;
}
function x(n2, l2) {
  this.props = n2, this.context = l2;
}
function S(n2, l2) {
  if (null == l2) return n2.__ ? S(n2.__, n2.__i + 1) : null;
  for (var u2; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) return u2.__e;
  return "function" == typeof n2.type ? S(n2) : null;
}
function C$1(n2) {
  if (n2.__P && n2.__d) {
    var u2 = n2.__v, t2 = u2.__e, i2 = [], r2 = [], o2 = w$2({}, u2);
    o2.__v = u2.__v + 1, l$4.vnode && l$4.vnode(o2), z$1(n2.__P, o2, u2, n2.__n, n2.__P.namespaceURI, 32 & u2.__u ? [t2] : null, i2, null == t2 ? S(u2) : t2, !!(32 & u2.__u), r2), o2.__v = u2.__v, o2.__.__k[o2.__i] = o2, V$1(i2, o2, r2), u2.__e = u2.__ = null, o2.__e != t2 && M$1(o2);
  }
}
function M$1(n2) {
  if (null != (n2 = n2.__) && null != n2.__c) return n2.__e = n2.__c.base = null, n2.__k.some(function(l2) {
    if (null != l2 && null != l2.__e) return n2.__e = n2.__c.base = l2.__e;
  }), M$1(n2);
}
function $$1(n2) {
  (!n2.__d && (n2.__d = true) && i$5.push(n2) && !I.__r++ || r$3 != l$4.debounceRendering) && ((r$3 = l$4.debounceRendering) || o$2)(I);
}
function I() {
  try {
    for (var n2, l2 = 1; i$5.length; ) i$5.length > l2 && i$5.sort(e$2), n2 = i$5.shift(), l2 = i$5.length, C$1(n2);
  } finally {
    i$5.length = I.__r = 0;
  }
}
function P$1(n2, l2, u2, t2, i2, r2, o2, e2, f2, c2, s2) {
  var a2, h2, y2, d2, w2, g2, _2, m2 = t2 && t2.__k || v$2, b2 = l2.length;
  for (f2 = A$2(u2, l2, m2, f2, b2), a2 = 0; a2 < b2; a2++) null != (y2 = u2.__k[a2]) && (h2 = -1 != y2.__i && m2[y2.__i] || p$3, y2.__i = a2, g2 = z$1(n2, y2, h2, i2, r2, o2, e2, f2, c2, s2), d2 = y2.__e, y2.ref && h2.ref != y2.ref && (h2.ref && D$2(h2.ref, null, y2), s2.push(y2.ref, y2.__c || d2, y2)), null == w2 && null != d2 && (w2 = d2), (_2 = !!(4 & y2.__u)) || h2.__k === y2.__k ? f2 = H$1(y2, f2, n2, _2) : "function" == typeof y2.type && void 0 !== g2 ? f2 = g2 : d2 && (f2 = d2.nextSibling), y2.__u &= -7);
  return u2.__e = w2, f2;
}
function A$2(n2, l2, u2, t2, i2) {
  var r2, o2, e2, f2, c2, s2 = u2.length, a2 = s2, h2 = 0;
  for (n2.__k = new Array(i2), r2 = 0; r2 < i2; r2++) null != (o2 = l2[r2]) && "boolean" != typeof o2 && "function" != typeof o2 ? ("string" == typeof o2 || "number" == typeof o2 || "bigint" == typeof o2 || o2.constructor == String ? o2 = n2.__k[r2] = m$2(null, o2, null, null, null) : d$2(o2) ? o2 = n2.__k[r2] = m$2(k$1, { children: o2 }, null, null, null) : void 0 === o2.constructor && o2.__b > 0 ? o2 = n2.__k[r2] = m$2(o2.type, o2.props, o2.key, o2.ref ? o2.ref : null, o2.__v) : n2.__k[r2] = o2, f2 = r2 + h2, o2.__ = n2, o2.__b = n2.__b + 1, e2 = null, -1 != (c2 = o2.__i = T$2(o2, u2, f2, a2)) && (a2--, (e2 = u2[c2]) && (e2.__u |= 2)), null == e2 || null == e2.__v ? (-1 == c2 && (i2 > s2 ? h2-- : i2 < s2 && h2++), "function" != typeof o2.type && (o2.__u |= 4)) : c2 != f2 && (c2 == f2 - 1 ? h2-- : c2 == f2 + 1 ? h2++ : (c2 > f2 ? h2-- : h2++, o2.__u |= 4))) : n2.__k[r2] = null;
  if (a2) for (r2 = 0; r2 < s2; r2++) null != (e2 = u2[r2]) && 0 == (2 & e2.__u) && (e2.__e == t2 && (t2 = S(e2)), E$1(e2, e2));
  return t2;
}
function H$1(n2, l2, u2, t2) {
  var i2, r2;
  if ("function" == typeof n2.type) {
    for (i2 = n2.__k, r2 = 0; i2 && r2 < i2.length; r2++) i2[r2] && (i2[r2].__ = n2, l2 = H$1(i2[r2], l2, u2, t2));
    return l2;
  }
  n2.__e != l2 && (t2 && (l2 && n2.type && !l2.parentNode && (l2 = S(n2)), u2.insertBefore(n2.__e, l2 || null)), l2 = n2.__e);
  do {
    l2 = l2 && l2.nextSibling;
  } while (null != l2 && 8 == l2.nodeType);
  return l2;
}
function L(n2, l2) {
  return l2 = l2 || [], null == n2 || "boolean" == typeof n2 || (d$2(n2) ? n2.some(function(n3) {
    L(n3, l2);
  }) : l2.push(n2)), l2;
}
function T$2(n2, l2, u2, t2) {
  var i2, r2, o2, e2 = n2.key, f2 = n2.type, c2 = l2[u2], s2 = null != c2 && 0 == (2 & c2.__u);
  if (null === c2 && null == e2 || s2 && e2 == c2.key && f2 == c2.type) return u2;
  if (t2 > (s2 ? 1 : 0)) {
    for (i2 = u2 - 1, r2 = u2 + 1; i2 >= 0 || r2 < l2.length; ) if (null != (c2 = l2[o2 = i2 >= 0 ? i2-- : r2++]) && 0 == (2 & c2.__u) && e2 == c2.key && f2 == c2.type) return o2;
  }
  return -1;
}
function j$2(n2, l2, u2) {
  "-" == l2[0] ? n2.setProperty(l2, null == u2 ? "" : u2) : n2[l2] = null == u2 ? "" : "number" != typeof u2 || y$2.test(l2) ? u2 : u2 + "px";
}
function F$1(n2, l2, u2, t2, i2) {
  var r2, o2;
  n: if ("style" == l2) if ("string" == typeof u2) n2.style.cssText = u2;
  else {
    if ("string" == typeof t2 && (n2.style.cssText = t2 = ""), t2) for (l2 in t2) u2 && l2 in u2 || j$2(n2.style, l2, "");
    if (u2) for (l2 in u2) t2 && u2[l2] == t2[l2] || j$2(n2.style, l2, u2[l2]);
  }
  else if ("o" == l2[0] && "n" == l2[1]) r2 = l2 != (l2 = l2.replace(f$3, "$1")), o2 = l2.toLowerCase(), l2 = o2 in n2 || "onFocusOut" == l2 || "onFocusIn" == l2 ? o2.slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + r2] = u2, u2 ? t2 ? u2.u = t2.u : (u2.u = c$4, n2.addEventListener(l2, r2 ? a$4 : s$4, r2)) : n2.removeEventListener(l2, r2 ? a$4 : s$4, r2);
  else {
    if ("http://www.w3.org/2000/svg" == i2) l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if ("width" != l2 && "height" != l2 && "href" != l2 && "list" != l2 && "form" != l2 && "tabIndex" != l2 && "download" != l2 && "rowSpan" != l2 && "colSpan" != l2 && "role" != l2 && "popover" != l2 && l2 in n2) try {
      n2[l2] = null == u2 ? "" : u2;
      break n;
    } catch (n3) {
    }
    "function" == typeof u2 || (null == u2 || false === u2 && "-" != l2[4] ? n2.removeAttribute(l2) : n2.setAttribute(l2, "popover" == l2 && 1 == u2 ? "" : u2));
  }
}
function O$1(n2) {
  return function(u2) {
    if (this.l) {
      var t2 = this.l[u2.type + n2];
      if (null == u2.t) u2.t = c$4++;
      else if (u2.t < t2.u) return;
      return t2(l$4.event ? l$4.event(u2) : u2);
    }
  };
}
function z$1(n2, u2, t2, i2, r2, o2, e2, f2, c2, s2) {
  var a2, h2, p2, y2, _2, m2, b2, S2, C2, M2, $2, I2, A2, H2, L2, T2 = u2.type;
  if (void 0 !== u2.constructor) return null;
  128 & t2.__u && (c2 = !!(32 & t2.__u), o2 = [f2 = u2.__e = t2.__e]), (a2 = l$4.__b) && a2(u2);
  n: if ("function" == typeof T2) try {
    if (S2 = u2.props, C2 = T2.prototype && T2.prototype.render, M2 = (a2 = T2.contextType) && i2[a2.__c], $2 = a2 ? M2 ? M2.props.value : a2.__ : i2, t2.__c ? b2 = (h2 = u2.__c = t2.__c).__ = h2.__E : (C2 ? u2.__c = h2 = new T2(S2, $2) : (u2.__c = h2 = new x(S2, $2), h2.constructor = T2, h2.render = G$1), M2 && M2.sub(h2), h2.state || (h2.state = {}), h2.__n = i2, p2 = h2.__d = true, h2.__h = [], h2._sb = []), C2 && null == h2.__s && (h2.__s = h2.state), C2 && null != T2.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = w$2({}, h2.__s)), w$2(h2.__s, T2.getDerivedStateFromProps(S2, h2.__s))), y2 = h2.props, _2 = h2.state, h2.__v = u2, p2) C2 && null == T2.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), C2 && null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);
    else {
      if (C2 && null == T2.getDerivedStateFromProps && S2 !== y2 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(S2, $2), u2.__v == t2.__v || !h2.__e && null != h2.shouldComponentUpdate && false === h2.shouldComponentUpdate(S2, h2.__s, $2)) {
        u2.__v != t2.__v && (h2.props = S2, h2.state = h2.__s, h2.__d = false), u2.__e = t2.__e, u2.__k = t2.__k, u2.__k.some(function(n3) {
          n3 && (n3.__ = u2);
        }), v$2.push.apply(h2.__h, h2._sb), h2._sb = [], h2.__h.length && e2.push(h2);
        break n;
      }
      null != h2.componentWillUpdate && h2.componentWillUpdate(S2, h2.__s, $2), C2 && null != h2.componentDidUpdate && h2.__h.push(function() {
        h2.componentDidUpdate(y2, _2, m2);
      });
    }
    if (h2.context = $2, h2.props = S2, h2.__P = n2, h2.__e = false, I2 = l$4.__r, A2 = 0, C2) h2.state = h2.__s, h2.__d = false, I2 && I2(u2), a2 = h2.render(h2.props, h2.state, h2.context), v$2.push.apply(h2.__h, h2._sb), h2._sb = [];
    else do {
      h2.__d = false, I2 && I2(u2), a2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s;
    } while (h2.__d && ++A2 < 25);
    h2.state = h2.__s, null != h2.getChildContext && (i2 = w$2(w$2({}, i2), h2.getChildContext())), C2 && !p2 && null != h2.getSnapshotBeforeUpdate && (m2 = h2.getSnapshotBeforeUpdate(y2, _2)), H2 = null != a2 && a2.type === k$1 && null == a2.key ? q$2(a2.props.children) : a2, f2 = P$1(n2, d$2(H2) ? H2 : [H2], u2, t2, i2, r2, o2, e2, f2, c2, s2), h2.base = u2.__e, u2.__u &= -161, h2.__h.length && e2.push(h2), b2 && (h2.__E = h2.__ = null);
  } catch (n3) {
    if (u2.__v = null, c2 || null != o2) if (n3.then) {
      for (u2.__u |= c2 ? 160 : 128; f2 && 8 == f2.nodeType && f2.nextSibling; ) f2 = f2.nextSibling;
      o2[o2.indexOf(f2)] = null, u2.__e = f2;
    } else {
      for (L2 = o2.length; L2--; ) g$1(o2[L2]);
      N(u2);
    }
    else u2.__e = t2.__e, u2.__k = t2.__k, n3.then || N(u2);
    l$4.__e(n3, u2, t2);
  }
  else null == o2 && u2.__v == t2.__v ? (u2.__k = t2.__k, u2.__e = t2.__e) : f2 = u2.__e = B$2(t2.__e, u2, t2, i2, r2, o2, e2, c2, s2);
  return (a2 = l$4.diffed) && a2(u2), 128 & u2.__u ? void 0 : f2;
}
function N(n2) {
  n2 && (n2.__c && (n2.__c.__e = true), n2.__k && n2.__k.some(N));
}
function V$1(n2, u2, t2) {
  for (var i2 = 0; i2 < t2.length; i2++) D$2(t2[i2], t2[++i2], t2[++i2]);
  l$4.__c && l$4.__c(u2, n2), n2.some(function(u3) {
    try {
      n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
        n3.call(u3);
      });
    } catch (n3) {
      l$4.__e(n3, u3.__v);
    }
  });
}
function q$2(n2) {
  return "object" != typeof n2 || null == n2 || n2.__b > 0 ? n2 : d$2(n2) ? n2.map(q$2) : w$2({}, n2);
}
function B$2(u2, t2, i2, r2, o2, e2, f2, c2, s2) {
  var a2, h2, v2, y2, w2, _2, m2, b2 = i2.props || p$3, k2 = t2.props, x2 = t2.type;
  if ("svg" == x2 ? o2 = "http://www.w3.org/2000/svg" : "math" == x2 ? o2 = "http://www.w3.org/1998/Math/MathML" : o2 || (o2 = "http://www.w3.org/1999/xhtml"), null != e2) {
    for (a2 = 0; a2 < e2.length; a2++) if ((w2 = e2[a2]) && "setAttribute" in w2 == !!x2 && (x2 ? w2.localName == x2 : 3 == w2.nodeType)) {
      u2 = w2, e2[a2] = null;
      break;
    }
  }
  if (null == u2) {
    if (null == x2) return document.createTextNode(k2);
    u2 = document.createElementNS(o2, x2, k2.is && k2), c2 && (l$4.__m && l$4.__m(t2, e2), c2 = false), e2 = null;
  }
  if (null == x2) b2 === k2 || c2 && u2.data == k2 || (u2.data = k2);
  else {
    if (e2 = e2 && n$1.call(u2.childNodes), !c2 && null != e2) for (b2 = {}, a2 = 0; a2 < u2.attributes.length; a2++) b2[(w2 = u2.attributes[a2]).name] = w2.value;
    for (a2 in b2) w2 = b2[a2], "dangerouslySetInnerHTML" == a2 ? v2 = w2 : "children" == a2 || a2 in k2 || "value" == a2 && "defaultValue" in k2 || "checked" == a2 && "defaultChecked" in k2 || F$1(u2, a2, null, w2, o2);
    for (a2 in k2) w2 = k2[a2], "children" == a2 ? y2 = w2 : "dangerouslySetInnerHTML" == a2 ? h2 = w2 : "value" == a2 ? _2 = w2 : "checked" == a2 ? m2 = w2 : c2 && "function" != typeof w2 || b2[a2] === w2 || F$1(u2, a2, w2, b2[a2], o2);
    if (h2) c2 || v2 && (h2.__html == v2.__html || h2.__html == u2.innerHTML) || (u2.innerHTML = h2.__html), t2.__k = [];
    else if (v2 && (u2.innerHTML = ""), P$1("template" == t2.type ? u2.content : u2, d$2(y2) ? y2 : [y2], t2, i2, r2, "foreignObject" == x2 ? "http://www.w3.org/1999/xhtml" : o2, e2, f2, e2 ? e2[0] : i2.__k && S(i2, 0), c2, s2), null != e2) for (a2 = e2.length; a2--; ) g$1(e2[a2]);
    c2 || (a2 = "value", "progress" == x2 && null == _2 ? u2.removeAttribute("value") : null != _2 && (_2 !== u2[a2] || "progress" == x2 && !_2 || "option" == x2 && _2 != b2[a2]) && F$1(u2, a2, _2, b2[a2], o2), a2 = "checked", null != m2 && m2 != u2[a2] && F$1(u2, a2, m2, b2[a2], o2));
  }
  return u2;
}
function D$2(n2, u2, t2) {
  try {
    if ("function" == typeof n2) {
      var i2 = "function" == typeof n2.__u;
      i2 && n2.__u(), i2 && null == u2 || (n2.__u = n2(u2));
    } else n2.current = u2;
  } catch (n3) {
    l$4.__e(n3, t2);
  }
}
function E$1(n2, u2, t2) {
  var i2, r2;
  if (l$4.unmount && l$4.unmount(n2), (i2 = n2.ref) && (i2.current && i2.current != n2.__e || D$2(i2, null, u2)), null != (i2 = n2.__c)) {
    if (i2.componentWillUnmount) try {
      i2.componentWillUnmount();
    } catch (n3) {
      l$4.__e(n3, u2);
    }
    i2.base = i2.__P = null;
  }
  if (i2 = n2.__k) for (r2 = 0; r2 < i2.length; r2++) i2[r2] && E$1(i2[r2], u2, t2 || "function" != typeof n2.type);
  t2 || g$1(n2.__e), n2.__c = n2.__ = n2.__e = void 0;
}
function G$1(n2, l2, u2) {
  return this.constructor(n2, u2);
}
function J$1(u2, t2, i2) {
  var r2, o2, e2, f2;
  t2 == document && (t2 = document.documentElement), l$4.__ && l$4.__(u2, t2), o2 = (r2 = "function" == typeof i2) ? null : i2 && i2.__k || t2.__k, e2 = [], f2 = [], z$1(t2, u2 = (!r2 && i2 || t2).__k = _$1(k$1, null, [u2]), o2 || p$3, p$3, t2.namespaceURI, !r2 && i2 ? [i2] : o2 ? null : t2.firstChild ? n$1.call(t2.childNodes) : null, e2, !r2 && i2 ? i2 : o2 ? o2.__e : t2.firstChild, r2, f2), V$1(e2, u2, f2);
}
function K$1(n2, l2) {
  J$1(n2, l2, K$1);
}
function Q$1(l2, u2, t2) {
  var i2, r2, o2, e2, f2 = w$2({}, l2.props);
  for (o2 in l2.type && l2.type.defaultProps && (e2 = l2.type.defaultProps), u2) "key" == o2 ? i2 = u2[o2] : "ref" == o2 ? r2 = u2[o2] : f2[o2] = void 0 === u2[o2] && null != e2 ? e2[o2] : u2[o2];
  return arguments.length > 2 && (f2.children = arguments.length > 3 ? n$1.call(arguments, 2) : t2), m$2(l2.type, f2, i2 || l2.key, r2 || l2.ref, null);
}
n$1 = v$2.slice, l$4 = { __e: function(n2, l2, u2, t2) {
  for (var i2, r2, o2; l2 = l2.__; ) if ((i2 = l2.__c) && !i2.__) try {
    if ((r2 = i2.constructor) && null != r2.getDerivedStateFromError && (i2.setState(r2.getDerivedStateFromError(n2)), o2 = i2.__d), null != i2.componentDidCatch && (i2.componentDidCatch(n2, t2 || {}), o2 = i2.__d), o2) return i2.__E = i2;
  } catch (l3) {
    n2 = l3;
  }
  throw n2;
} }, u$5 = 0, x.prototype.setState = function(n2, l2) {
  var u2;
  u2 = null != this.__s && this.__s != this.state ? this.__s : this.__s = w$2({}, this.state), "function" == typeof n2 && (n2 = n2(w$2({}, u2), this.props)), n2 && w$2(u2, n2), null != n2 && this.__v && (l2 && this._sb.push(l2), $$1(this));
}, x.prototype.forceUpdate = function(n2) {
  this.__v && (this.__e = true, n2 && this.__h.push(n2), $$1(this));
}, x.prototype.render = k$1, i$5 = [], o$2 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, e$2 = function(n2, l2) {
  return n2.__v.__b - l2.__v.__b;
}, I.__r = 0, f$3 = /(PointerCapture)$|Capture$/i, c$4 = 0, s$4 = O$1(false), a$4 = O$1(true);
var i$4;
function t$3(o2, e2) {
  return l$4.__a && l$4.__a(e2), o2;
}
null != (i$4 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0) && i$4.__PREACT_DEVTOOLS__ && i$4.__PREACT_DEVTOOLS__.attachPreact("10.29.0", l$4, { Fragment: k$1, Component: x });
var t$2 = {};
function a$3(e2) {
  return e2.type === k$1 ? "Fragment" : "function" == typeof e2.type ? e2.type.displayName || e2.type.name : "string" == typeof e2.type ? e2.type : "#text";
}
var i$3 = [], s$3 = [];
function c$3() {
  return i$3.length > 0 ? i$3[i$3.length - 1] : null;
}
var l$3 = true;
function u$4(e2) {
  return "function" == typeof e2.type && e2.type != k$1;
}
function f$2(n2) {
  for (var e2 = [n2], o2 = n2; null != o2.__o; ) e2.push(o2.__o), o2 = o2.__o;
  return e2.reduce(function(n3, e3) {
    n3 += "  in " + a$3(e3);
    var o3 = e3.__source;
    return o3 ? n3 += " (at " + o3.fileName + ":" + o3.lineNumber + ")" : l$3 && console.warn("Add @babel/plugin-transform-react-jsx-source to get a more detailed component stack. Note that you should not add it to production builds of your App for bundle size reasons."), l$3 = false, n3 + "\n";
  }, "");
}
var d$1 = "function" == typeof WeakMap;
function p$2(n2) {
  var e2 = [];
  return n2.__k ? (n2.__k.forEach(function(n3) {
    n3 && "function" == typeof n3.type ? e2.push.apply(e2, p$2(n3)) : n3 && "string" == typeof n3.type && e2.push(n3.type);
  }), e2) : e2;
}
function h$2(n2) {
  return n2 ? "function" == typeof n2.type ? null == n2.__ ? null != n2.__e && null != n2.__e.parentNode ? n2.__e.parentNode.localName : "" : h$2(n2.__) : n2.type : "";
}
var v$1 = x.prototype.setState;
function y$1(n2) {
  return "table" === n2 || "tfoot" === n2 || "tbody" === n2 || "thead" === n2 || "td" === n2 || "tr" === n2 || "th" === n2;
}
x.prototype.setState = function(n2, e2) {
  return null == this.__v && null == this.state && console.warn('Calling "this.setState" inside the constructor of a component is a no-op and might be a bug in your application. Instead, set "this.state = {}" directly.\n\n' + f$2(c$3())), v$1.call(this, n2, e2);
};
var m$1 = /^(address|article|aside|blockquote|details|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|main|menu|nav|ol|p|pre|search|section|table|ul)$/, b = x.prototype.forceUpdate;
function w$1(n2) {
  var e2 = n2.props, o2 = a$3(n2), t2 = "";
  for (var r2 in e2) if (e2.hasOwnProperty(r2) && "children" !== r2) {
    var i2 = e2[r2];
    "function" == typeof i2 && (i2 = "function " + (i2.displayName || i2.name) + "() {}"), i2 = Object(i2) !== i2 || i2.toString ? i2 + "" : Object.prototype.toString.call(i2), t2 += " " + r2 + "=" + JSON.stringify(i2);
  }
  var s2 = e2.children;
  return "<" + o2 + t2 + (s2 && s2.length ? ">..</" + o2 + ">" : " />");
}
x.prototype.forceUpdate = function(n2) {
  return null == this.__v ? console.warn('Calling "this.forceUpdate" inside the constructor of a component is a no-op and might be a bug in your application.\n\n' + f$2(c$3())) : null == this.__P && console.warn(`Can't call "this.forceUpdate" on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in the componentWillUnmount method.

` + f$2(this.__v)), b.call(this, n2);
}, l$4.__m = function(n2, e2) {
  var o2 = n2.type, t2 = e2.map(function(n3) {
    return n3 && n3.localName;
  }).filter(Boolean);
  console.error('Expected a DOM node of type "' + o2 + '" but found "' + t2.join(", ") + `" as available DOM-node(s), this is caused by the SSR'd HTML containing different DOM-nodes compared to the hydrated one.

` + f$2(n2));
}, function() {
  !function() {
    var n3 = l$4.__b, o3 = l$4.diffed, t2 = l$4.__, r3 = l$4.vnode, a2 = l$4.__r;
    l$4.diffed = function(n4) {
      u$4(n4) && s$3.pop(), i$3.pop(), o3 && o3(n4);
    }, l$4.__b = function(e2) {
      u$4(e2) && i$3.push(e2), n3 && n3(e2);
    }, l$4.__ = function(n4, e2) {
      s$3 = [], t2 && t2(n4, e2);
    }, l$4.vnode = function(n4) {
      n4.__o = s$3.length > 0 ? s$3[s$3.length - 1] : null, r3 && r3(n4);
    }, l$4.__r = function(n4) {
      u$4(n4) && s$3.push(n4), a2 && a2(n4);
    };
  }();
  var n2 = false, o2 = l$4.__b, r2 = l$4.diffed, c2 = l$4.vnode, l2 = l$4.__r, v2 = l$4.__e, b2 = l$4.__, g2 = l$4.__h, E2 = d$1 ? { useEffect: /* @__PURE__ */ new WeakMap(), useLayoutEffect: /* @__PURE__ */ new WeakMap(), lazyPropTypes: /* @__PURE__ */ new WeakMap() } : null, k2 = [];
  l$4.__e = function(n3, e2, o3, t2) {
    if (e2 && e2.__c && "function" == typeof n3.then) {
      var r3 = n3;
      n3 = new Error("Missing Suspense. The throwing component was: " + a$3(e2));
      for (var i2 = e2; i2; i2 = i2.__) if (i2.__c && i2.__c.__c) {
        n3 = r3;
        break;
      }
      if (n3 instanceof Error) throw n3;
    }
    try {
      (t2 = t2 || {}).componentStack = f$2(e2), v2(n3, e2, o3, t2), "function" != typeof n3.then && setTimeout(function() {
        throw n3;
      });
    } catch (n4) {
      throw n4;
    }
  }, l$4.__ = function(n3, e2) {
    if (!e2) throw new Error("Undefined parent passed to render(), this is the second argument.\nCheck if the element is available in the DOM/has the correct id.");
    var o3;
    switch (e2.nodeType) {
      case 1:
      case 11:
      case 9:
        o3 = true;
        break;
      default:
        o3 = false;
    }
    if (!o3) {
      var t2 = a$3(n3);
      throw new Error("Expected a valid HTML node as a second argument to render.	Received " + e2 + " instead: render(<" + t2 + " />, " + e2 + ");");
    }
    b2 && b2(n3, e2);
  }, l$4.__b = function(e2) {
    var r3 = e2.type;
    if (n2 = true, void 0 === r3) throw new Error("Undefined component passed to createElement()\n\nYou likely forgot to export your component or might have mixed up default and named imports" + w$1(e2) + "\n\n" + f$2(e2));
    if (null != r3 && "object" == typeof r3) {
      if (void 0 !== r3.__k && void 0 !== r3.__e) throw new Error("Invalid type passed to createElement(): " + r3 + "\n\nDid you accidentally pass a JSX literal as JSX twice?\n\n  let My" + a$3(e2) + " = " + w$1(r3) + ";\n  let vnode = <My" + a$3(e2) + " />;\n\nThis usually happens when you export a JSX literal and not the component.\n\n" + f$2(e2));
      throw new Error("Invalid type passed to createElement(): " + (Array.isArray(r3) ? "array" : r3));
    }
    if (void 0 !== e2.ref && "function" != typeof e2.ref && "object" != typeof e2.ref && !("$$typeof" in e2)) throw new Error(`Component's "ref" property should be a function, or an object created by createRef(), but got [` + typeof e2.ref + "] instead\n" + w$1(e2) + "\n\n" + f$2(e2));
    if ("string" == typeof e2.type) {
      for (var i2 in e2.props) if ("o" === i2[0] && "n" === i2[1] && "function" != typeof e2.props[i2] && null != e2.props[i2]) throw new Error(`Component's "` + i2 + '" property should be a function, but got [' + typeof e2.props[i2] + "] instead\n" + w$1(e2) + "\n\n" + f$2(e2));
    }
    if ("function" == typeof e2.type && e2.type.propTypes) {
      if ("Lazy" === e2.type.displayName && E2 && !E2.lazyPropTypes.has(e2.type)) {
        var s2 = "PropTypes are not supported on lazy(). Use propTypes on the wrapped component itself. ";
        try {
          var c3 = e2.type();
          E2.lazyPropTypes.set(e2.type, true), console.warn(s2 + "Component wrapped in lazy() is " + a$3(c3));
        } catch (n3) {
          console.warn(s2 + "We will log the wrapped component's name once it is loaded.");
        }
      }
      var l3 = e2.props;
      e2.type.__f && delete (l3 = function(n3, e3) {
        for (var o3 in e3) n3[o3] = e3[o3];
        return n3;
      }({}, l3)).ref, function(n3, e3, o3, r4, a2) {
        Object.keys(n3).forEach(function(o4) {
          var i3;
          try {
            i3 = n3[o4](e3, o4, r4, "prop", null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (n4) {
            i3 = n4;
          }
          i3 && !(i3.message in t$2) && (t$2[i3.message] = true, console.error("Failed prop type: " + i3.message + (a2 && "\n" + a2() || "")));
        });
      }(e2.type.propTypes, l3, 0, a$3(e2), function() {
        return f$2(e2);
      });
    }
    o2 && o2(e2);
  };
  var T2, _2 = 0;
  l$4.__r = function(e2) {
    l2 && l2(e2), n2 = true;
    var o3 = e2.__c;
    if (o3 === T2 ? _2++ : _2 = 1, _2 >= 25) throw new Error("Too many re-renders. This is limited to prevent an infinite loop which may lock up your browser. The component causing this is: " + a$3(e2));
    T2 = o3;
  }, l$4.__h = function(e2, o3, t2) {
    if (!e2 || !n2) throw new Error("Hook can only be invoked from render methods.");
    g2 && g2(e2, o3, t2);
  };
  var O2 = function(n3, e2) {
    return { get: function() {
      var o3 = "get" + n3 + e2;
      k2 && k2.indexOf(o3) < 0 && (k2.push(o3), console.warn("getting vnode." + n3 + " is deprecated, " + e2));
    }, set: function() {
      var o3 = "set" + n3 + e2;
      k2 && k2.indexOf(o3) < 0 && (k2.push(o3), console.warn("setting vnode." + n3 + " is not allowed, " + e2));
    } };
  }, I2 = { nodeName: O2("nodeName", "use vnode.type"), attributes: O2("attributes", "use vnode.props"), children: O2("children", "use vnode.props.children") }, M2 = Object.create({}, I2);
  l$4.vnode = function(n3) {
    var e2 = n3.props;
    if (null !== n3.type && null != e2 && ("__source" in e2 || "__self" in e2)) {
      var o3 = n3.props = {};
      for (var t2 in e2) {
        var r3 = e2[t2];
        "__source" === t2 ? n3.__source = r3 : "__self" === t2 ? n3.__self = r3 : o3[t2] = r3;
      }
    }
    n3.__proto__ = M2, c2 && c2(n3);
  }, l$4.diffed = function(e2) {
    var o3, t2 = e2.type, i2 = e2.__;
    if (e2.__k && e2.__k.forEach(function(n3) {
      if ("object" == typeof n3 && n3 && void 0 === n3.type) {
        var o4 = Object.keys(n3).join(",");
        throw new Error("Objects are not valid as a child. Encountered an object with the keys {" + o4 + "}.\n\n" + f$2(e2));
      }
    }), e2.__c === T2 && (_2 = 0), "string" == typeof t2 && (y$1(t2) || "p" === t2 || "a" === t2 || "button" === t2)) {
      var s2 = h$2(i2);
      if ("" !== s2 && y$1(t2)) "table" === t2 && "td" !== s2 && y$1(s2) ? console.error("Improper nesting of table. Your <table> should not have a table-node parent." + w$1(e2) + "\n\n" + f$2(e2)) : "thead" !== t2 && "tfoot" !== t2 && "tbody" !== t2 || "table" === s2 ? "tr" === t2 && "thead" !== s2 && "tfoot" !== s2 && "tbody" !== s2 ? console.error("Improper nesting of table. Your <tr> should have a <thead/tbody/tfoot> parent." + w$1(e2) + "\n\n" + f$2(e2)) : "td" === t2 && "tr" !== s2 ? console.error("Improper nesting of table. Your <td> should have a <tr> parent." + w$1(e2) + "\n\n" + f$2(e2)) : "th" === t2 && "tr" !== s2 && console.error("Improper nesting of table. Your <th> should have a <tr>." + w$1(e2) + "\n\n" + f$2(e2)) : console.error("Improper nesting of table. Your <thead/tbody/tfoot> should have a <table> parent." + w$1(e2) + "\n\n" + f$2(e2));
      else if ("p" === t2) {
        var c3 = p$2(e2).filter(function(n3) {
          return m$1.test(n3);
        });
        c3.length && console.error("Improper nesting of paragraph. Your <p> should not have " + c3.join(", ") + " as child-elements." + w$1(e2) + "\n\n" + f$2(e2));
      } else "a" !== t2 && "button" !== t2 || -1 !== p$2(e2).indexOf(t2) && console.error("Improper nesting of interactive content. Your <" + t2 + "> should not have other " + ("a" === t2 ? "anchor" : "button") + " tags as child-elements." + w$1(e2) + "\n\n" + f$2(e2));
    }
    if (n2 = false, r2 && r2(e2), null != e2.__k) for (var l3 = [], u2 = 0; u2 < e2.__k.length; u2++) {
      var d2 = e2.__k[u2];
      if (d2 && null != d2.key) {
        var v3 = d2.key;
        if (-1 !== l3.indexOf(v3)) {
          console.error('Following component has two or more children with the same key attribute: "' + v3 + '". This may cause glitches and misbehavior in rendering process. Component: \n\n' + w$1(e2) + "\n\n" + f$2(e2));
          break;
        }
        l3.push(v3);
      }
    }
    if (null != e2.__c && null != e2.__c.__H) {
      var b3 = e2.__c.__H.__;
      if (b3) for (var g3 = 0; g3 < b3.length; g3 += 1) {
        var E3 = b3[g3];
        if (E3.__H) {
          for (var k3 = 0; k3 < E3.__H.length; k3++) if ((o3 = E3.__H[k3]) != o3) {
            var O3 = a$3(e2);
            console.warn("Invalid argument passed to hook. Hooks should not be called with NaN in the dependency array. Hook index " + g3 + " in component " + O3 + " was called with NaN.");
          }
        }
      }
    }
  };
}();
(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
function r$2() {
  return (r$2 = Object.assign ? Object.assign.bind() : function(t2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var n2 = arguments[e2];
      for (var o2 in n2) Object.prototype.hasOwnProperty.call(n2, o2) && (t2[o2] = n2[o2]);
    }
    return t2;
  }).apply(this, arguments);
}
var i$2 = ["context", "children"];
function a$2(t2) {
  this.getChildContext = function() {
    return t2.context;
  };
  var e2 = t2.children, n2 = function(t3, e3) {
    if (null == t3) return {};
    var n3, o2, r2 = {}, i2 = Object.keys(t3);
    for (o2 = 0; o2 < i2.length; o2++) e3.indexOf(n3 = i2[o2]) >= 0 || (r2[n3] = t3[n3]);
    return r2;
  }(t2, i$2);
  return Q$1(e2, n2);
}
function s$2() {
  var o2 = new CustomEvent("_preact", { detail: {}, bubbles: true, cancelable: true });
  this.dispatchEvent(o2), this._vdom = _$1(a$2, r$2({}, this._props, { context: o2.detail.context }), function e2(n2, o3) {
    if (3 === n2.nodeType) return n2.data;
    if (1 !== n2.nodeType) return null;
    var r2 = [], i2 = {}, a2 = 0, s2 = n2.attributes, l2 = n2.childNodes;
    for (a2 = s2.length; a2--; ) "slot" !== s2[a2].name && (i2[s2[a2].name] = s2[a2].value, i2[c$2(s2[a2].name)] = s2[a2].value);
    for (a2 = l2.length; a2--; ) {
      var u2 = e2(l2[a2], null), d2 = l2[a2].slot;
      d2 ? i2[d2] = _$1(p$1, { name: d2 }, u2) : r2[a2] = u2;
    }
    var h2 = o3 ? _$1(p$1, null, r2) : r2;
    return _$1(o3 || n2.nodeName.toLowerCase(), i2, h2);
  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? K$1 : J$1)(this._vdom, this._root);
}
function c$2(t2) {
  return t2.replace(/-(\w)/g, function(t3, e2) {
    return e2 ? e2.toUpperCase() : "";
  });
}
function l$2(t2, e2, r2) {
  if (this._vdom) {
    var i2 = {};
    i2[t2] = r2 = null == r2 ? void 0 : r2, i2[c$2(t2)] = r2, this._vdom = Q$1(this._vdom, i2), J$1(this._vdom, this._root);
  }
}
function u$3() {
  J$1(this._vdom = null, this._root);
}
function p$1(e2, n2) {
  var o2 = this;
  return _$1("slot", r$2({}, e2, { ref: function(t2) {
    t2 ? (o2.ref = t2, o2._listener || (o2._listener = function(t3) {
      t3.stopPropagation(), t3.detail.context = n2;
    }, t2.addEventListener("_preact", o2._listener))) : o2.ref.removeEventListener("_preact", o2._listener);
  } }));
}
function register(t2, e2, n2, o2) {
  function r2() {
    var e3 = Reflect.construct(HTMLElement, [], r2);
    return e3._vdomComponent = t2, e3._root = e3, e3;
  }
  return (r2.prototype = Object.create(HTMLElement.prototype)).constructor = r2, r2.prototype.connectedCallback = s$2, r2.prototype.attributeChangedCallback = l$2, r2.prototype.disconnectedCallback = u$3, n2 = n2 || t2.observedAttributes || Object.keys(t2.propTypes || {}), r2.observedAttributes = n2, n2.forEach(function(t3) {
    Object.defineProperty(r2.prototype, t3, { get: function() {
      return this._vdom.props[t3];
    }, set: function(e3) {
      this._vdom ? this.attributeChangedCallback(t3, null, e3) : (this._props || (this._props = {}), this._props[t3] = e3, this.connectedCallback());
      var n3 = typeof e3;
      null != e3 && "string" !== n3 && "boolean" !== n3 && "number" !== n3 || this.setAttribute(t3, e3);
    } });
  }), customElements.define(e2 || t2.tagName || t2.displayName || t2.name, r2);
}
var t$1, r$1, u$2, i$1, o$1 = 0, f$1 = [], c$1 = l$4, e$1 = c$1.__b, a$1 = c$1.__r, v = c$1.diffed, l$1 = c$1.__c, m = c$1.unmount, s$1 = c$1.__;
function p(n2, t2) {
  c$1.__h && c$1.__h(r$1, n2, o$1 || t2), o$1 = 0;
  var u2 = r$1.__H || (r$1.__H = { __: [], __h: [] });
  return n2 >= u2.__.length && u2.__.push({}), u2.__[n2];
}
function d(n2) {
  return o$1 = 1, h$1(D$1, n2);
}
function h$1(n2, u2, i2) {
  var o2 = p(t$1++, 2);
  if (o2.t = n2, !o2.__c && (o2.__ = [i2 ? i2(u2) : D$1(void 0, u2), function(n3) {
    var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n3);
    t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
  }], o2.__c = r$1, !r$1.__f)) {
    var f2 = function(n3, t2, r2) {
      if (!o2.__c.__H) return true;
      var u3 = o2.__c.__H.__.filter(function(n4) {
        return n4.__c;
      });
      if (u3.every(function(n4) {
        return !n4.__N;
      })) return !c2 || c2.call(this, n3, t2, r2);
      var i3 = o2.__c.props !== n3;
      return u3.some(function(n4) {
        if (n4.__N) {
          var t3 = n4.__[0];
          n4.__ = n4.__N, n4.__N = void 0, t3 !== n4.__[0] && (i3 = true);
        }
      }), c2 && c2.call(this, n3, t2, r2) || i3;
    };
    r$1.__f = true;
    var c2 = r$1.shouldComponentUpdate, e2 = r$1.componentWillUpdate;
    r$1.componentWillUpdate = function(n3, t2, r2) {
      if (this.__e) {
        var u3 = c2;
        c2 = void 0, f2(n3, t2, r2), c2 = u3;
      }
      e2 && e2.call(this, n3, t2, r2);
    }, r$1.shouldComponentUpdate = f2;
  }
  return o2.__N || o2.__;
}
function y(n2, u2) {
  var i2 = p(t$1++, 3);
  !c$1.__s && C(i2.__H, u2) && (i2.__ = n2, i2.u = u2, r$1.__H.__h.push(i2));
}
function _(n2, u2) {
  var i2 = p(t$1++, 4);
  !c$1.__s && C(i2.__H, u2) && (i2.__ = n2, i2.u = u2, r$1.__h.push(i2));
}
function A$1(n2) {
  return o$1 = 5, T$1(function() {
    return { current: n2 };
  }, []);
}
function F(n2, t2, r2) {
  o$1 = 6, _(function() {
    if ("function" == typeof n2) {
      var r3 = n2(t2());
      return function() {
        n2(null), r3 && "function" == typeof r3 && r3();
      };
    }
    if (n2) return n2.current = t2(), function() {
      return n2.current = null;
    };
  }, null == r2 ? r2 : r2.concat(n2));
}
function T$1(n2, r2) {
  var u2 = p(t$1++, 7);
  return C(u2.__H, r2) && (u2.__ = n2(), u2.__H = r2, u2.__h = n2), u2.__;
}
function q$1(n2, t2) {
  return o$1 = 8, T$1(function() {
    return n2;
  }, t2);
}
function j$1() {
  for (var n2; n2 = f$1.shift(); ) {
    var t2 = n2.__H;
    if (n2.__P && t2) try {
      t2.__h.some(z), t2.__h.some(B$1), t2.__h = [];
    } catch (r2) {
      t2.__h = [], c$1.__e(r2, n2.__v);
    }
  }
}
c$1.__b = function(n2) {
  r$1 = null, e$1 && e$1(n2);
}, c$1.__ = function(n2, t2) {
  n2 && t2.__k && t2.__k.__m && (n2.__m = t2.__k.__m), s$1 && s$1(n2, t2);
}, c$1.__r = function(n2) {
  a$1 && a$1(n2), t$1 = 0;
  var i2 = (r$1 = n2.__c).__H;
  i2 && (u$2 === r$1 ? (i2.__h = [], r$1.__h = [], i2.__.some(function(n3) {
    n3.__N && (n3.__ = n3.__N), n3.u = n3.__N = void 0;
  })) : (i2.__h.some(z), i2.__h.some(B$1), i2.__h = [], t$1 = 0)), u$2 = r$1;
}, c$1.diffed = function(n2) {
  v && v(n2);
  var t2 = n2.__c;
  t2 && t2.__H && (t2.__H.__h.length && (1 !== f$1.push(t2) && i$1 === c$1.requestAnimationFrame || ((i$1 = c$1.requestAnimationFrame) || w)(j$1)), t2.__H.__.some(function(n3) {
    n3.u && (n3.__H = n3.u), n3.u = void 0;
  })), u$2 = r$1 = null;
}, c$1.__c = function(n2, t2) {
  t2.some(function(n3) {
    try {
      n3.__h.some(z), n3.__h = n3.__h.filter(function(n4) {
        return !n4.__ || B$1(n4);
      });
    } catch (r2) {
      t2.some(function(n4) {
        n4.__h && (n4.__h = []);
      }), t2 = [], c$1.__e(r2, n3.__v);
    }
  }), l$1 && l$1(n2, t2);
}, c$1.unmount = function(n2) {
  m && m(n2);
  var t2, r2 = n2.__c;
  r2 && r2.__H && (r2.__H.__.some(function(n3) {
    try {
      z(n3);
    } catch (n4) {
      t2 = n4;
    }
  }), r2.__H = void 0, t2 && c$1.__e(t2, r2.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n2) {
  var t2, r2 = function() {
    clearTimeout(u2), k && cancelAnimationFrame(t2), setTimeout(n2);
  }, u2 = setTimeout(r2, 35);
  k && (t2 = requestAnimationFrame(r2));
}
function z(n2) {
  var t2 = r$1, u2 = n2.__c;
  "function" == typeof u2 && (n2.__c = void 0, u2()), r$1 = t2;
}
function B$1(n2) {
  var t2 = r$1;
  n2.__c = n2.__(), r$1 = t2;
}
function C(n2, t2) {
  return !n2 || n2.length !== t2.length || t2.some(function(t3, r2) {
    return t3 !== n2[r2];
  });
}
function D$1(n2, t2) {
  return "function" == typeof t2 ? t2(n2) : t2;
}
var f = 0;
function u$1(e2, t2, n2, o2, i2, u2) {
  t2 || (t2 = {});
  var a2, c2, p2 = t2;
  if ("ref" in p2) for (c2 in p2 = {}, t2) "ref" == c2 ? a2 = t2[c2] : p2[c2] = t2[c2];
  var l2 = { type: e2, props: p2, key: n2, ref: a2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --f, __i: -1, __u: 0, __source: i2, __self: u2 };
  if ("function" == typeof e2 && (a2 = e2.defaultProps)) for (c2 in a2) void 0 === p2[c2] && (p2[c2] = a2[c2]);
  return l$4.vnode && l$4.vnode(l2), l2;
}
var _jsxFileName$j = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/HelloWorld.tsx";
function HelloWorld({
  firstName,
  lastName,
  initialCount = 1
}) {
  const [counter, setCounter] = t$3(d(initialCount || 1), "counter");
  const handleClick = () => {
    setCounter(counter + 1);
  };
  return u$1("div", {
    children: [u$1("h1", {
      children: ["Hello ", firstName, " ", lastName]
    }, void 0, true, {
      fileName: _jsxFileName$j,
      lineNumber: 28,
      columnNumber: 7
    }, this), u$1("p", {
      className: "font-primary",
      children: ["Counter: ", counter]
    }, void 0, true, {
      fileName: _jsxFileName$j,
      lineNumber: 32,
      columnNumber: 7
    }, this), u$1("button", {
      onClick: handleClick,
      children: "Increase Counter"
    }, void 0, false, {
      fileName: _jsxFileName$j,
      lineNumber: 33,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$j,
    lineNumber: 26,
    columnNumber: 5
  }, this);
}
register(HelloWorld, "hello-world");
var _jsxFileName$i = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/AcousticCalculator.tsx";
function AcousticCalculator({
  heading = "",
  headingSize = "h1",
  title = "Acoustic Panel Calculator",
  description = "Whether you're treating a home theater, recording studio, office, or restaurant, the right number and placement of acoustic panels can significantly improve sound quality, reduce reverberation, and control sound reflections. This guide explores the most important factors and gives you a smart, simple way to estimate your panel count using our Acoustic Panel Calculator.",
  buttonText = "Get Free Advice From Our Experts",
  buttonUrl = "#contact"
}) {
  const [dimensions, setDimensions] = t$3(d({
    length: "",
    width: "",
    height: ""
  }), "dimensions");
  const [panelSize, setPanelSize] = t$3(d("24in x 48in"), "panelSize");
  const [results, setResults] = t$3(d({
    coverage10: 0,
    coverage15: 0,
    coverage25: 0,
    rt60Before: "",
    rt60After10: "",
    rt60After15: "",
    rt60After25: ""
  }), "results");
  const panelSizes = ["24in x 24in", "12in x 48in", "24in x 48in"];
  const calculatePanels = () => {
    const length = parseFloat(dimensions.length);
    const width = parseFloat(dimensions.width);
    const height = parseFloat(dimensions.height);
    if (!length || !width || !height) return;
    let coverage10, coverage15, coverage25;
    if (panelSize === "24in x 24in") {
      coverage10 = Math.round(length / 3.5 * 2 + width / 3.5 * 2);
      coverage15 = Math.round(length / 3 * 2 + width / 3 * 2);
      coverage25 = Math.round(length / 2 * 2 + width / 2 * 2);
    } else if (panelSize === "12in x 48in") {
      coverage10 = Math.round(length / 4.5 * 2 + width / 4.5 * 2);
      coverage15 = Math.round(length / 4 * 2 + width / 4 * 2);
      coverage25 = Math.round(length / 3 * 2 + width / 3 * 2);
    } else if (panelSize === "24in x 48in") {
      coverage10 = Math.round(length / 3.5 * 2 + width / 3.5 * 2);
      coverage15 = Math.round(length / 3 * 2 + width / 3 * 2);
      coverage25 = Math.round(length / 2 * 2 + width / 2 * 2);
    }
    const roomVolume = length * width * height;
    const rt60Before = (roomVolume / 1e3 * 1.2).toFixed(2);
    const rt60After10 = (parseFloat(rt60Before) * 0.85).toFixed(2);
    const rt60After15 = (parseFloat(rt60Before) * 0.75).toFixed(2);
    const rt60After25 = (parseFloat(rt60Before) * 0.6).toFixed(2);
    setResults({
      coverage10,
      coverage15,
      coverage25,
      rt60Before,
      rt60After10,
      rt60After15,
      rt60After25
    });
  };
  y(() => {
    calculatePanels();
  }, [dimensions, panelSize]);
  const handleDimensionChange = (field, value) => {
    setDimensions((prev) => ({
      ...prev,
      [field]: value
    }));
  };
  return u$1("div", {
    className: "acoustic-calculator",
    children: u$1("div", {
      className: "acoustic-calculator__container",
      children: u$1("div", {
        className: "acoustic-calculator__content",
        children: [heading && u$1("div", {
          className: "acoustic-calculator__heading",
          children: [headingSize === "h0" && u$1("h1", {
            className: "heading h0",
            children: heading
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 115,
            columnNumber: 17
          }, this), headingSize === "h1" && u$1("h1", {
            className: "heading h1",
            children: heading
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 118,
            columnNumber: 17
          }, this), headingSize === "h2" && u$1("h2", {
            className: "heading h2",
            children: heading
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 121,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$i,
          lineNumber: 113,
          columnNumber: 13
        }, this), u$1("div", {
          className: "acoustic-calculator__header",
          children: [u$1("div", {
            className: "acoustic-calculator__description rte",
            dangerouslySetInnerHTML: {
              __html: description
            }
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 128,
            columnNumber: 13
          }, this), u$1("a", {
            href: buttonUrl,
            className: "acoustic-calculator__button",
            children: buttonText
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 132,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$i,
          lineNumber: 127,
          columnNumber: 11
        }, this), u$1("div", {
          className: "acoustic-calculator__main",
          children: u$1("div", {
            className: "acoustic-calculator__form",
            children: u$1("div", {
              className: "acoustic-calculator__section",
              children: [u$1("h3", {
                className: "acoustic-calculator__section-title",
                children: "Room Dimensions (Feet)"
              }, void 0, false, {
                fileName: _jsxFileName$i,
                lineNumber: 142,
                columnNumber: 17
              }, this), u$1("div", {
                className: "acoustic-calculator__input-row",
                children: [u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "Length"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 147,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "number",
                    className: "acoustic-calculator__input",
                    value: dimensions.length,
                    onChange: (e2) => handleDimensionChange("length", e2.currentTarget.value),
                    placeholder: "Value"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 148,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$i,
                  lineNumber: 146,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "Width"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 159,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "number",
                    className: "acoustic-calculator__input",
                    value: dimensions.width,
                    onChange: (e2) => handleDimensionChange("width", e2.currentTarget.value),
                    placeholder: "Value"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 160,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$i,
                  lineNumber: 158,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "Height"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 171,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "number",
                    className: "acoustic-calculator__input",
                    value: dimensions.height,
                    onChange: (e2) => handleDimensionChange("height", e2.currentTarget.value),
                    placeholder: "Value"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 172,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$i,
                  lineNumber: 170,
                  columnNumber: 19
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$i,
                lineNumber: 145,
                columnNumber: 17
              }, this), u$1("div", {
                className: "acoustic-calculator__results-container",
                children: [u$1("div", {
                  className: "acoustic-calculator__panel-selector",
                  children: [u$1("label", {
                    className: "acoustic-calculator__section-title",
                    children: "Select Panel Size"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 187,
                    columnNumber: 21
                  }, this), u$1("select", {
                    className: "acoustic-calculator__select",
                    value: panelSize,
                    onChange: (e2) => setPanelSize(e2.currentTarget.value),
                    children: panelSizes.map((size) => u$1("option", {
                      value: size,
                      children: size
                    }, size, false, {
                      fileName: _jsxFileName$i,
                      lineNumber: 196,
                      columnNumber: 25
                    }, this))
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 190,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$i,
                  lineNumber: 186,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__results-section",
                  children: [u$1("h4", {
                    className: "acoustic-calculator__section-title",
                    children: "Suggested Number of Panels"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 205,
                    columnNumber: 21
                  }, this), u$1("p", {
                    className: "acoustic-calculator__results-subtitle",
                    children: "Approximately how many acoustic panels you should place on the walls and ceiling"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 208,
                    columnNumber: 21
                  }, this), u$1("div", {
                    className: "acoustic-calculator__input-row",
                    children: [u$1("div", {
                      className: "acoustic-calculator__input-group",
                      children: [u$1("label", {
                        className: "acoustic-calculator__label",
                        children: "10% Coverage (minimum)"
                      }, void 0, false, {
                        fileName: _jsxFileName$i,
                        lineNumber: 215,
                        columnNumber: 25
                      }, this), u$1("input", {
                        type: "text",
                        className: "acoustic-calculator__input",
                        value: results.coverage10,
                        readOnly: true
                      }, void 0, false, {
                        fileName: _jsxFileName$i,
                        lineNumber: 218,
                        columnNumber: 25
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$i,
                      lineNumber: 214,
                      columnNumber: 23
                    }, this), u$1("div", {
                      className: "acoustic-calculator__input-group",
                      children: [u$1("label", {
                        className: "acoustic-calculator__label",
                        children: "15% Coverage (recommended)"
                      }, void 0, false, {
                        fileName: _jsxFileName$i,
                        lineNumber: 226,
                        columnNumber: 25
                      }, this), u$1("input", {
                        type: "text",
                        className: "acoustic-calculator__input",
                        value: results.coverage15,
                        readOnly: true
                      }, void 0, false, {
                        fileName: _jsxFileName$i,
                        lineNumber: 229,
                        columnNumber: 25
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$i,
                      lineNumber: 225,
                      columnNumber: 23
                    }, this), u$1("div", {
                      className: "acoustic-calculator__input-group",
                      children: [u$1("label", {
                        className: "acoustic-calculator__label",
                        children: "25% Coverage (ideal)"
                      }, void 0, false, {
                        fileName: _jsxFileName$i,
                        lineNumber: 237,
                        columnNumber: 25
                      }, this), u$1("input", {
                        type: "text",
                        className: "acoustic-calculator__input",
                        value: results.coverage25,
                        readOnly: true
                      }, void 0, false, {
                        fileName: _jsxFileName$i,
                        lineNumber: 240,
                        columnNumber: 25
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$i,
                      lineNumber: 236,
                      columnNumber: 23
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName$i,
                    lineNumber: 213,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$i,
                  lineNumber: 204,
                  columnNumber: 19
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$i,
                lineNumber: 185,
                columnNumber: 17
              }, this), u$1("h3", {
                className: "acoustic-calculator__section-title",
                children: "RT60 (Reverberation Time) Reduction When Using 2IN Thick Panels"
              }, void 0, false, {
                fileName: _jsxFileName$i,
                lineNumber: 252,
                columnNumber: 17
              }, this), u$1("div", {
                className: "acoustic-calculator__rt60-section",
                children: [u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "RT60 Before (seconds)"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 259,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "text",
                    className: "acoustic-calculator__input acoustic-calculator__input--result",
                    value: results.rt60Before || "Result will appear here",
                    readOnly: true
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 262,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$i,
                  lineNumber: 258,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "RT60 (seconds) After Minimal Treatment"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 270,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "text",
                    className: "acoustic-calculator__input acoustic-calculator__input--result",
                    value: results.rt60After10 || "Result will appear here",
                    readOnly: true
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 273,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$i,
                  lineNumber: 269,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "RT60 (seconds) After Recommended Treatment"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 281,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "text",
                    className: "acoustic-calculator__input acoustic-calculator__input--result",
                    value: results.rt60After15 || "Result will appear here",
                    readOnly: true
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 284,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$i,
                  lineNumber: 280,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "RT60 (seconds) After Ideal Treatment"
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 292,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "text",
                    className: "acoustic-calculator__input acoustic-calculator__input--result",
                    value: results.rt60After25 || "Result will appear here",
                    readOnly: true
                  }, void 0, false, {
                    fileName: _jsxFileName$i,
                    lineNumber: 295,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$i,
                  lineNumber: 291,
                  columnNumber: 19
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$i,
                lineNumber: 257,
                columnNumber: 17
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$i,
              lineNumber: 140,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$i,
            lineNumber: 139,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$i,
          lineNumber: 138,
          columnNumber: 11
        }, this), u$1("p", {
          className: "acoustic-calculator__footer",
          children: "We recommend reaching out to us for advice for recording rooms, control rooms, mixing rooms, studios, and any musical applications."
        }, void 0, false, {
          fileName: _jsxFileName$i,
          lineNumber: 308,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$i,
        lineNumber: 110,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$i,
      lineNumber: 109,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$i,
    lineNumber: 108,
    columnNumber: 5
  }, this);
}
register(AcousticCalculator, "acoustic-calculator");
function g(n2, t2) {
  for (var e2 in t2) n2[e2] = t2[e2];
  return n2;
}
function E(n2, t2) {
  for (var e2 in n2) if ("__source" !== e2 && !(e2 in t2)) return true;
  for (var r2 in t2) if ("__source" !== r2 && n2[r2] !== t2[r2]) return true;
  return false;
}
function M(n2, t2) {
  this.props = n2, this.context = t2;
}
(M.prototype = new x()).isPureReactComponent = true, M.prototype.shouldComponentUpdate = function(n2, t2) {
  return E(this.props, n2) || E(this.state, t2);
};
var T = l$4.__b;
l$4.__b = function(n2) {
  n2.type && n2.type.__f && n2.ref && (n2.props.ref = n2.ref, n2.ref = null), T && T(n2);
};
var A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function D(n2) {
  function t2(t3) {
    var e2 = g({}, t3);
    return delete e2.ref, n2(e2, t3.ref || null);
  }
  return t2.$$typeof = A, t2.render = n2, t2.prototype.isReactComponent = t2.__f = true, t2.displayName = "ForwardRef(" + (n2.displayName || n2.name) + ")", t2;
}
var O = l$4.__e;
l$4.__e = function(n2, t2, e2, r2) {
  if (n2.then) {
    for (var u2, o2 = t2; o2 = o2.__; ) if ((u2 = o2.__c) && u2.__c) return null == t2.__e && (t2.__e = e2.__e, t2.__k = e2.__k), u2.__c(n2, t2);
  }
  O(n2, t2, e2, r2);
};
var U = l$4.unmount;
function V(n2, t2, e2) {
  return n2 && (n2.__c && n2.__c.__H && (n2.__c.__H.__.forEach(function(n3) {
    "function" == typeof n3.__c && n3.__c();
  }), n2.__c.__H = null), null != (n2 = g({}, n2)).__c && (n2.__c.__P === e2 && (n2.__c.__P = t2), n2.__c.__e = true, n2.__c = null), n2.__k = n2.__k && n2.__k.map(function(n3) {
    return V(n3, t2, e2);
  })), n2;
}
function W(n2, t2, e2) {
  return n2 && e2 && (n2.__v = null, n2.__k = n2.__k && n2.__k.map(function(n3) {
    return W(n3, t2, e2);
  }), n2.__c && n2.__c.__P === t2 && (n2.__e && e2.appendChild(n2.__e), n2.__c.__e = true, n2.__c.__P = e2)), n2;
}
function P() {
  this.__u = 0, this.o = null, this.__b = null;
}
function j(n2) {
  var t2 = n2.__ && n2.__.__c;
  return t2 && t2.__a && t2.__a(n2);
}
function B() {
  this.i = null, this.l = null;
}
l$4.unmount = function(n2) {
  var t2 = n2.__c;
  t2 && (t2.__z = true), t2 && t2.__R && t2.__R(), t2 && 32 & n2.__u && (n2.type = null), U && U(n2);
}, (P.prototype = new x()).__c = function(n2, t2) {
  var e2 = t2.__c, r2 = this;
  null == r2.o && (r2.o = []), r2.o.push(e2);
  var u2 = j(r2.__v), o2 = false, i2 = function() {
    o2 || r2.__z || (o2 = true, e2.__R = null, u2 ? u2(c2) : c2());
  };
  e2.__R = i2;
  var l2 = e2.__P;
  e2.__P = null;
  var c2 = function() {
    if (!--r2.__u) {
      if (r2.state.__a) {
        var n3 = r2.state.__a;
        r2.__v.__k[0] = W(n3, n3.__c.__P, n3.__c.__O);
      }
      var t3;
      for (r2.setState({ __a: r2.__b = null }); t3 = r2.o.pop(); ) t3.__P = l2, t3.forceUpdate();
    }
  };
  r2.__u++ || 32 & t2.__u || r2.setState({ __a: r2.__b = r2.__v.__k[0] }), n2.then(i2, i2);
}, P.prototype.componentWillUnmount = function() {
  this.o = [];
}, P.prototype.render = function(n2, e2) {
  if (this.__b) {
    if (this.__v.__k) {
      var r2 = document.createElement("div"), o2 = this.__v.__k[0].__c;
      this.__v.__k[0] = V(this.__b, r2, o2.__O = o2.__P);
    }
    this.__b = null;
  }
  var i2 = e2.__a && _$1(k$1, null, n2.fallback);
  return i2 && (i2.__u &= -33), [_$1(k$1, null, e2.__a ? null : n2.children), i2];
};
var H = function(n2, t2, e2) {
  if (++e2[1] === e2[0] && n2.l.delete(t2), n2.props.revealOrder && ("t" !== n2.props.revealOrder[0] || !n2.l.size)) for (e2 = n2.i; e2; ) {
    for (; e2.length > 3; ) e2.pop()();
    if (e2[1] < e2[0]) break;
    n2.i = e2 = e2[2];
  }
};
function Z(n2) {
  return this.getChildContext = function() {
    return n2.context;
  }, n2.children;
}
function Y(n2) {
  var e2 = this, r2 = n2.h;
  if (e2.componentWillUnmount = function() {
    J$1(null, e2.v), e2.v = null, e2.h = null;
  }, e2.h && e2.h !== r2 && e2.componentWillUnmount(), !e2.v) {
    for (var u2 = e2.__v; null !== u2 && !u2.__m && null !== u2.__; ) u2 = u2.__;
    e2.h = r2, e2.v = { nodeType: 1, parentNode: r2, childNodes: [], __k: { __m: u2.__m }, contains: function() {
      return true;
    }, namespaceURI: r2.namespaceURI, insertBefore: function(n3, t2) {
      this.childNodes.push(n3), e2.h.insertBefore(n3, t2);
    }, removeChild: function(n3) {
      this.childNodes.splice(this.childNodes.indexOf(n3) >>> 1, 1), e2.h.removeChild(n3);
    } };
  }
  J$1(_$1(Z, { context: e2.context }, n2.__v), e2.v);
}
function $(n2, e2) {
  var r2 = _$1(Y, { __v: n2, h: e2 });
  return r2.containerInfo = e2, r2;
}
(B.prototype = new x()).__a = function(n2) {
  var t2 = this, e2 = j(t2.__v), r2 = t2.l.get(n2);
  return r2[0]++, function(u2) {
    var o2 = function() {
      t2.props.revealOrder ? (r2.push(u2), H(t2, n2, r2)) : u2();
    };
    e2 ? e2(o2) : o2();
  };
}, B.prototype.render = function(n2) {
  this.i = null, this.l = /* @__PURE__ */ new Map();
  var t2 = L(n2.children);
  n2.revealOrder && "b" === n2.revealOrder[0] && t2.reverse();
  for (var e2 = t2.length; e2--; ) this.l.set(t2[e2], this.i = [1, 0, this.i]);
  return n2.children;
}, B.prototype.componentDidUpdate = B.prototype.componentDidMount = function() {
  var n2 = this;
  this.l.forEach(function(t2, e2) {
    H(n2, e2, t2);
  });
};
var q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, K = /[A-Z0-9]/g, Q = "undefined" != typeof document, X = function(n2) {
  return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n2);
};
x.prototype.isReactComponent = true, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t2) {
  Object.defineProperty(x.prototype, t2, { configurable: true, get: function() {
    return this["UNSAFE_" + t2];
  }, set: function(n2) {
    Object.defineProperty(this, t2, { configurable: true, writable: true, value: n2 });
  } });
});
var en = l$4.event;
l$4.event = function(n2) {
  return en && (n2 = en(n2)), n2.persist = function() {
  }, n2.isPropagationStopped = function() {
    return this.cancelBubble;
  }, n2.isDefaultPrevented = function() {
    return this.defaultPrevented;
  }, n2.nativeEvent = n2;
};
var un = { configurable: true, get: function() {
  return this.class;
} }, on = l$4.vnode;
l$4.vnode = function(n2) {
  "string" == typeof n2.type && function(n3) {
    var t2 = n3.props, e2 = n3.type, u2 = {}, o2 = -1 == e2.indexOf("-");
    for (var i2 in t2) {
      var l2 = t2[i2];
      if (!("value" === i2 && "defaultValue" in t2 && null == l2 || Q && "children" === i2 && "noscript" === e2 || "class" === i2 || "className" === i2)) {
        var c2 = i2.toLowerCase();
        "defaultValue" === i2 && "value" in t2 && null == t2.value ? i2 = "value" : "download" === i2 && true === l2 ? l2 = "" : "translate" === c2 && "no" === l2 ? l2 = false : "o" === c2[0] && "n" === c2[1] ? "ondoubleclick" === c2 ? i2 = "ondblclick" : "onchange" !== c2 || "input" !== e2 && "textarea" !== e2 || X(t2.type) ? "onfocus" === c2 ? i2 = "onfocusin" : "onblur" === c2 ? i2 = "onfocusout" : J.test(i2) && (i2 = c2) : c2 = i2 = "oninput" : o2 && G.test(i2) ? i2 = i2.replace(K, "-$&").toLowerCase() : null === l2 && (l2 = void 0), "oninput" === c2 && u2[i2 = c2] && (i2 = "oninputCapture"), u2[i2] = l2;
      }
    }
    "select" == e2 && (u2.multiple && Array.isArray(u2.value) && (u2.value = L(t2.children).forEach(function(n4) {
      n4.props.selected = -1 != u2.value.indexOf(n4.props.value);
    })), null != u2.defaultValue && (u2.value = L(t2.children).forEach(function(n4) {
      n4.props.selected = u2.multiple ? -1 != u2.defaultValue.indexOf(n4.props.value) : u2.defaultValue == n4.props.value;
    }))), t2.class && !t2.className ? (u2.class = t2.class, Object.defineProperty(u2, "className", un)) : t2.className && (u2.class = u2.className = t2.className), n3.props = u2;
  }(n2), n2.$$typeof = q, on && on(n2);
};
var ln = l$4.__r;
l$4.__r = function(n2) {
  ln && ln(n2), n2.__c;
};
var cn = l$4.diffed;
l$4.diffed = function(n2) {
  cn && cn(n2);
  var t2 = n2.props, e2 = n2.__e;
  null != e2 && "textarea" === n2.type && "value" in t2 && t2.value !== e2.value && (e2.value = null == t2.value ? "" : t2.value);
};
class t {
  constructor(t2, e2, r2, s2) {
    this.t = null, this.s = null, this.i = t2, this.o = e2, this.t = r2, this.s = s2, this.o.addEventListener("message", this.l.bind(this));
  }
  setOutgoingMessageBus(t2) {
    this.t = t2;
  }
  setMessageExecution(t2) {
    this.s = t2;
  }
  sendMessage(t2, e2 = []) {
    return new Promise((r2, s2) => {
      const i2 = new MessageChannel();
      i2.port1.onmessage = (t3) => {
        if (!t3 || !t3.data) return i2.port1.close(), i2.port2.close(), s2(new Error(this.i + " received message but response can not be interpreted"));
        let e3;
        try {
          e3 = JSON.parse(t3.data);
        } catch (t4) {
          return i2.port1.close(), i2.port2.close(), this.h(t4), s2(t4);
        }
        e3.error ? s2(e3.error) : void 0 !== e3.result ? r2(e3.result) : r2(), i2.port1.close(), i2.port2.close();
      };
      let o2 = "";
      try {
        o2 = JSON.stringify({ message: t2, args: e2 });
      } catch (t3) {
        return s2(new Error(this.i + ": can not create command because it is not JSON.stringify able"));
      }
      if (!this.t) return s2(new Error(this.i + ": outgoing bus not set yet"));
      this.t.postMessage(o2, "*", [i2.port2]);
    });
  }
  l(t2) {
    const e2 = t2.ports && Array.isArray(t2.ports) && t2.ports.length > 0 ? t2.ports[0] : null;
    if (t2.data && e2) try {
      const r2 = JSON.parse(t2.data);
      if (!this.s) return e2.postMessage(JSON.stringify({ error: this.i + " is not ready to handle messages" }));
      Array.isArray(r2.args) || (r2.args = [r2.args]);
      const s2 = this.s(r2, t2);
      if (void 0 === s2) return;
      s2.then((t3 = {}) => {
        let r3 = void 0, s3 = void 0;
        "object" == typeof t3 && null !== t3 && (r3 = t3.error, s3 = t3.result), r3 ? e2.postMessage(JSON.stringify({ error: r3 })) : void 0 !== s3 ? e2.postMessage(JSON.stringify({ result: s3 })) : e2.postMessage(JSON.stringify({ result: t3 }));
      }, (t3) => {
        e2.postMessage(JSON.stringify({ error: this.h(t3) }));
      });
    } catch (t3) {
      e2.postMessage(JSON.stringify({ error: this.h(t3) }));
    }
  }
  h(t2) {
    if ("string" == typeof t2) {
      const e2 = this.i + ": " + t2;
      return console.error(e2), e2;
    }
    return t2.message = this.i + ": " + t2.message, console.error(t2), t2.message;
  }
}
const e = ["127.0.0.1", "localhost", "0.0.0.0"], r = (t2, e2) => {
  for (const s2 in e2) try {
    e2[s2].constructor === Object ? t2[s2] = r(t2[s2], e2[s2]) : t2[s2] = e2[s2];
  } catch (r2) {
    t2[s2] = e2[s2];
  }
  return t2;
}, s = ["language", "browserLanguage", "userLanguage", "systemLanguage"], i = (t2) => {
  if (!t2) return;
  const e2 = Object.keys(t2);
  for (const r2 of e2) {
    const e3 = t2[r2];
    if (!Array.isArray(e3) && "object" == typeof e3 && null !== e3) return i(e3);
    if (Array.isArray(e3)) {
      for (const t3 of e3) i(t3);
      return;
    }
    "true" !== e3 && "false" !== e3 || (t2[r2] = "true" === e3);
  }
}, o = () => /(android)/i.test(navigator.userAgent), n = (t2, e2, r2) => {
  let s2 = null;
  Object.defineProperty(t2, e2, { get: () => s2 || r2, set(t3) {
    (null == t3 ? void 0 : t3.mute) ? s2 = t3.value : (console.warn("You override Roomle defined behaviour. To disalbe this warning pass in an object with the following properties"), console.warn("{ mute: true, value: () => void }"), s2 = t3);
  } });
}, a = () => 0.01 * window.innerHeight + "px", l = (t2) => {
  t2 && setTimeout(() => t2.style.setProperty(h, a()), 0);
}, h = "--rml-full-height", c = /* @__PURE__ */ new Map();
class u {
  constructor(e2, r2, s2, i2) {
    if (this.ui = { callbacks: null }, this.extended = { callbacks: null }, this.analytics = { callbacks: {} }, this.global = { callbacks: {} }, this.u = {}, !e2 || "string" != typeof e2.id) throw new Error("Please provide a correct configuratorId, you get the correct ID from your Roomle Contact Person");
    if (c.has(r2)) throw new Error("There is already an instance on this DOM element");
    if (!document.getElementById("rml-styles")) {
      const t2 = s2.zIndex || 9999999, e3 = document.createElement("style");
      e3.type = "text/css", e3.id = "rml-styles";
      const r3 = "transition:all ease-in-out 450ms;", i3 = ["-webkit-", "-o-"].reduce((t3, e4) => t3 + (e4 + r3), "") + r3, o2 = a();
      e3.innerHTML = `
        .rml-container{${h}:${o2};}
        .rml-pos{position:fixed;top:0;left:0;z-index:${t2};opacity:0}
        .rml-transition{${i3}}
        .rml-fill{width:100%;height:100%;opacity:1}
        .rml-android-height{height:calc(var(${h},1vh)*100)}
        .rml-overflow-hidden{overflow:hidden}
      `, document.head.appendChild(e3);
    }
    this.m = this.m.bind(this), o() && window.addEventListener("resize", this.m), this.g = r2, this.u = s2, this.p = e2;
    const n2 = this.v();
    this.O = this.O.bind(this), this.N = this.N.bind(this), this.P = this.P.bind(this), this._ = new t("website", window, null, this.N), this.J = i2, this.g.appendChild(n2), this.S = n2, c.set(r2, true);
  }
  static createPlanner(t2, e2, r2) {
    return this.k(t2, e2, r2);
  }
  static createConfigurator(t2, e2, r2) {
    return this.k(t2, e2, r2);
  }
  static create(t2, e2, r2) {
    return this.k(t2, e2, r2);
  }
  static createViewer(t2, e2, r2) {
    return this.k(t2, e2, r2);
  }
  static k(t2, o2, n2) {
    return new Promise(async (a2, l2) => {
      try {
        const l3 = r((() => {
          const t3 = {};
          t3.locale || (t3.locale = ((t4 = null) => {
            const e2 = window.navigator;
            if (t4) return t4.substr(0, 2);
            if (Array.isArray(e2.languages) && e2.languages.length > 0) return e2.languages[0].substr(0, 2);
            for (let t5 = 0, r3 = s.length; t5 < r3; t5++) {
              const r4 = e2[s[t5]];
              if (r4) return r4.substr(0, 2);
            }
            return "en";
          })()), "(idle)" === t3.id && delete t3.id;
          const r2 = (() => {
            const t4 = (() => {
              try {
                return window.self !== window.top;
              } catch (t5) {
                return true;
              }
            })();
            let e2 = window.location.href;
            if (t4) {
              if (!document.referrer) return null;
              e2 = document.referrer;
            }
            const { hostname: r3 } = new URL(e2);
            return r3;
          })();
          return r2 && ((t4) => !!e.includes(t4) || !!t4.endsWith("roomle.com") || !(!t4.endsWith("gitlab.io") && !t4.endsWith("gitlab.com")))(r2) && (t3.configuratorId = "demoConfigurator"), t3.customApiUrl = "https://www.roomle.com/api/v2", t3.emails = false, t3;
        })(), ((t3) => (i(t3), (null == t3 ? void 0 : t3.customApiUrl) && (t3.customApiUrl = decodeURIComponent(t3.customApiUrl)), t3.shareUrl && (t3.deeplink = t3.shareUrl.replace("<CONF_ID>", "#CONFIGURATIONID#")), t3))(n2));
        l3.featureFlags || (l3.featureFlags = {}), "boolean" != typeof l3.featureFlags.realPartList && (l3.featureFlags.realPartList = true), "boolean" != typeof l3.featureFlags.globalCallbacks && (l3.featureFlags.globalCallbacks = true);
        const h2 = await (async (t3, e2) => {
          if ("string" != typeof t3) throw new Error('Configurator ID is not a string type: "' + typeof t3 + '"');
          const r2 = e2.customApiUrl ? e2.customApiUrl : "https://api.roomle.com/v2", s2 = e2.overrideTenant || 9, i2 = r2 + "/configurators/" + t3, o3 = "03-" + window.btoa((/* @__PURE__ */ new Date()).toISOString() + ";anonymous;roomle_portal_v2"), n3 = new Request(i2, { method: "GET", headers: new Headers({ apiKey: "roomle_portal_v2", currentTenant: s2, locale: "en", language: "en", device: 1, token: o3, platform: "web" }), mode: "cors", cache: "default" }), a3 = await fetch(n3), { configurator: l4 } = await a3.json();
          return l4;
        })(t2, l3);
        return n2 = ((t3, e2) => {
          e2.configuratorId = t3.id;
          const s2 = t3.settings || {};
          return !e2.overrideTenant && t3.tenant && (e2.overrideTenant = t3.tenant), ((t4, e3) => {
            const s3 = JSON.parse(JSON.stringify(t4));
            return r(s3, e3);
          })(s2, e2);
        })(h2, l3), new this(h2, o2, n2, a2);
      } catch (t3) {
        return l2(t3);
      }
    });
  }
  teardown() {
    this.g && c.delete(this.g);
    const t2 = this.g.querySelector("iframe");
    t2 && this.g.removeChild(t2), window.removeEventListener("resize", this.m);
  }
  v() {
    var t2;
    const e2 = document.createElement("iframe");
    let r2 = (null === (t2 = this.p) || void 0 === t2 ? void 0 : t2.url) || "https://www.roomle.com/t/cp/";
    return this.u.useLocalRoomle && (r2 = location.href.replace("embedding.html", "")), location.href.includes("roomle.gitlab.io") && (r2 = location.href.replace("embedding.html", "index.html")), this.u.overrideServerUrl && (r2 = this.u.overrideServerUrl), e2.src = r2, e2.classList.add("rml-container"), e2.classList.add("rml-fill"), e2;
  }
  m() {
    l(this.S);
  }
  O() {
    this.S.classList.add("rml-pos"), document.documentElement.classList.add("rml-overflow-hidden"), window.document.body.classList.add("rml-overflow-hidden"), o() && (l(this.S), this.S.classList.add("rml-android-height"));
  }
  P() {
    this.S.classList.remove("rml-pos"), this.S.classList.remove("rml-android-height"), document.documentElement.classList.remove("rml-overflow-hidden"), window.document.body.classList.remove("rml-overflow-hidden");
  }
  N({ message: t2, args: e2 }, r2) {
    var s2;
    if (!r2.source) return;
    if (r2.source !== (null === (s2 = this.S) || void 0 === s2 ? void 0 : s2.contentWindow)) return;
    if ("requestBoot" === t2) return this._.setOutgoingMessageBus(r2.source), Promise.resolve({ result: this.u });
    if ("setup" === t2) {
      const { methods: t3, callbacks: r3 } = e2[0];
      return t3.forEach((t4) => {
        const e3 = t4.split("."), r4 = e3[0], s3 = e3[1];
        this[r4] || (this[r4] = {}), this[r4][s3] = (function() {
          return this._.sendMessage(t4, [...arguments]);
        }).bind(this);
      }), r3.forEach((t4) => {
        const e3 = t4.split("."), r4 = e3[0], s3 = e3[1], i3 = e3[2];
        this[r4] || (this[r4] = {}), this[r4][s3] || (this[r4][s3] = {}), this[r4][s3][i3] = () => {
        };
      }), n(this.ui.callbacks, "onUseFullPage", this.O), n(this.ui.callbacks, "onBackToWebsite", this.P), this.J(this), setTimeout(() => this._.sendMessage("websiteReady"), 0), Promise.resolve({ result: null });
    }
    const i2 = t2.split("."), o2 = i2[0], a2 = i2[1], l2 = 3 === i2.length ? i2[2] : null;
    if (l2 && this[o2][a2][l2]) {
      const t3 = this[o2][a2][l2](...e2);
      return t3 instanceof Promise ? t3.then((t4) => ({ result: t4 })) : void 0 !== t3 ? Promise.resolve({ result: t3 }) : Promise.resolve({ result: null });
    }
    return Promise.reject('Message "' + t2 + '" is unkown');
  }
}
let cachedProducts = null;
let prefetchPromise = null;
const prefetchAllProducts = () => {
  if (cachedProducts) return Promise.resolve(cachedProducts);
  if (prefetchPromise) return prefetchPromise;
  prefetchPromise = fetchAllProducts().then((products) => {
    cachedProducts = products;
    prefetchPromise = null;
    return products;
  }).catch((err) => {
    prefetchPromise = null;
    throw err;
  });
  return prefetchPromise;
};
const fetchAllProducts = async () => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  const storefrontApiKey = (_b = (_a = window.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.storefront_api_key;
  const shopDomain = (_d = (_c = window == null ? void 0 : window.theme) == null ? void 0 : _c.routes) == null ? void 0 : _d.shop_url;
  if (!storefrontApiKey || !shopDomain) {
    console.error("Storefront API key or shop domain not found");
    return [];
  }
  const products = [];
  let hasNextPage = true;
  let cursor = null;
  while (hasNextPage) {
    const query = `
      query getProducts($first: Int!, $after: String, $country: CountryCode) @inContext(country: $country) {
        products(first: $first, after: $after) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              options {
                name
                values
              }
              metafields(identifiers: [
                {namespace: "roomle", key: "room_builder_connection"},
                {namespace: "shopify", key: "color-pattern"},
                {namespace: "product", key: "finish"},
                {namespace: "product", key: "flexrange_technology"},
                {namespace: "product", key: "frequency"},
                {namespace: "product", key: "extras_1"},
                {namespace: "product", key: "shape"}
              ]) {
                id
                key
                namespace
                value
              }
              variants(first: 250) {
                nodes {
                  id
                  selectedOptions {
                    name
                    value
                  }
                  title
                  availableForSale
                  price {
                    amount
                  }
                }
              }
            }
          }
        }
      }
    `;
    try {
      const response = await fetch(`${shopDomain}/api/2024-10/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontApiKey
        },
        body: JSON.stringify({
          query,
          variables: {
            first: 250,
            after: cursor,
            country: ((_e = window.Shopify) == null ? void 0 : _e.country) || "US"
          }
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.errors) {
        console.error("GraphQL errors:", data.errors);
        break;
      }
      const productEdges = ((_g = (_f = data.data) == null ? void 0 : _f.products) == null ? void 0 : _g.edges) || [];
      for (const edge of productEdges) {
        const product = edge.node;
        const metafields = Array.isArray(product.metafields) ? product.metafields.filter((mf) => mf != null) : [];
        const metafield = metafields.find((mf) => (mf == null ? void 0 : mf.namespace) === "roomle" && (mf == null ? void 0 : mf.key) === "room_builder_connection");
        if (metafield == null ? void 0 : metafield.value) {
          products.push({
            ...product,
            catalogItemId: metafield.value
          });
        }
      }
      hasNextPage = ((_j = (_i = (_h = data.data) == null ? void 0 : _h.products) == null ? void 0 : _i.pageInfo) == null ? void 0 : _j.hasNextPage) || false;
      cursor = ((_m = (_l = (_k = data.data) == null ? void 0 : _k.products) == null ? void 0 : _l.pageInfo) == null ? void 0 : _m.endCursor) || null;
    } catch (error) {
      console.error("Error fetching products:", error);
      break;
    }
  }
  return products;
};
const productHasConnection = (product, value) => {
  var _a;
  return !!((_a = product.metafields) == null ? void 0 : _a.some((mf) => (mf == null ? void 0 : mf.namespace) === "roomle" && (mf == null ? void 0 : mf.key) === "room_builder_connection" && (mf == null ? void 0 : mf.value) === value));
};
const findProductForRoomleItem = (roomleItem, products) => {
  if (roomleItem.catalogItemId) {
    const byCatalogItem = products.find((p2) => productHasConnection(p2, roomleItem.catalogItemId));
    if (byCatalogItem) return byCatalogItem;
  }
  if (roomleItem.componentId) {
    return products.find((p2) => productHasConnection(p2, roomleItem.componentId));
  }
  return void 0;
};
const findProductsByCatalogItemIds = async (catalogItemIds) => {
  if (!catalogItemIds || catalogItemIds.length === 0) {
    return [];
  }
  const allProducts = await prefetchAllProducts();
  return allProducts.filter((p2) => p2.catalogItemId && catalogItemIds.includes(p2.catalogItemId));
};
const getCatalogItemIdsFromOverviewSync = (overview) => {
  var _a;
  if (!(overview == null ? void 0 : overview.objects)) return [];
  const catalogItemIds = /* @__PURE__ */ new Set();
  for (const obj of overview.objects) {
    if (obj.catalogItemId) {
      catalogItemIds.add(obj.catalogItemId);
    }
    const parts = ((_a = obj.parts) == null ? void 0 : _a.fullList) || [];
    for (const part of parts) {
      if (part.componentId) {
        catalogItemIds.add(part.componentId);
      }
    }
    if (!obj.catalogItemId && obj.configuration) {
      try {
        const config = typeof obj.configuration === "string" ? JSON.parse(obj.configuration) : obj.configuration;
        if (config.componentId) {
          catalogItemIds.add(config.componentId);
        }
      } catch (_2) {
      }
    }
  }
  return Array.from(catalogItemIds);
};
const metaobjectTypes = ["roomle_color_map", "product_structure_standing", "product_structure_finish", "product_structure_pattern", "swatch_value_translations"];
const ROOMLE_COLOR_MAP = metaobjectTypes[0];
const PRODUCT_STRUCTURE_STANDING = metaobjectTypes[1];
const PRODUCT_STRUCTURE_FINISH = metaobjectTypes[2];
const PRODUCT_STRUCTURE_PATTERN = metaobjectTypes[3];
const SWATCH_VALUE_TRANSLATIONS = metaobjectTypes[4];
const LANGUAGE_LOCALE_MAP = {
  french: "fr",
  german: "de",
  italian: "it",
  spanish: "es",
  polish: "pl"
};
let metaobjectsCache = {};
let formattedMetaobjects = {};
let swatchTranslationsCache = [];
const findMetaobjectsByTypes = async (metaobjectTypes2) => {
  var _a, _b, _c, _d, _e, _f;
  if (!metaobjectTypes2 || metaobjectTypes2.length === 0) {
    return {};
  }
  const storefrontApiKey = (_b = (_a = window.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.storefront_api_key;
  const shopDomain = (_d = (_c = window == null ? void 0 : window.theme) == null ? void 0 : _c.routes) == null ? void 0 : _d.shop_url;
  if (!storefrontApiKey || !shopDomain) {
    console.error("Storefront API key or shop domain not found");
    return {};
  }
  const metaobjectsByType = {};
  for (const type of metaobjectTypes2) {
    const query = `
      query getMetaobjects($type: String!, $first: Int!) {
        metaobjects(type: $type, first: $first) {
          nodes {
            id
            type
            fields {
              key
              value
              references(first: 250) {
                nodes {
                  ... on Metaobject {
                    id
                    type
                    fields {
                      key
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
    try {
      const response = await fetch(`${shopDomain}/api/2024-10/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontApiKey
        },
        body: JSON.stringify({
          query,
          variables: {
            type,
            first: 250
          }
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.errors) {
        console.error(`GraphQL errors for ${type}:`, data.errors);
        continue;
      }
      metaobjectsByType[type] = ((_f = (_e = data.data) == null ? void 0 : _e.metaobjects) == null ? void 0 : _f.nodes) || [];
    } catch (error) {
      console.error(`Error fetching metaobjects for type ${type}:`, error);
    }
  }
  return metaobjectsByType;
};
const formatFabricMetaobject = (metaobjects) => {
  const colorMap = {};
  if (!metaobjects || !Array.isArray(metaobjects)) {
    console.log("🔍 formatFabricMetaobject: No metaobjects provided");
    return colorMap;
  }
  for (const metaobject of metaobjects) {
    if (!metaobject.fields || !Array.isArray(metaobject.fields)) {
      continue;
    }
    let roomleColor = null;
    let shopifyColor = null;
    for (const field of metaobject.fields) {
      if (field.key === "roomle_color" && field.value) {
        roomleColor = field.value;
      } else if (field.key === "shopify_color" && field.value) {
        shopifyColor = field.value;
      }
    }
    if (roomleColor && shopifyColor) {
      colorMap[roomleColor] = shopifyColor;
    }
  }
  return colorMap;
};
const getMetaobjects = () => {
  return metaobjectsCache;
};
const formatFinishMetaobject = (metaobjects) => {
  const finishMap = {};
  if (!metaobjects || !Array.isArray(metaobjects)) {
    console.warn("🔍 formatFinishMetaobject: No metaobjects provided");
    return finishMap;
  }
  for (const metaobject of metaobjects) {
    if (!metaobject.fields || !Array.isArray(metaobject.fields)) {
      continue;
    }
    let roomleValue = null;
    let name = null;
    for (const field of metaobject.fields) {
      if (field.key === "roomle_value" && field.value) {
        roomleValue = field.value;
      } else if (field.key === "name" && field.value) {
        name = field.value;
      }
    }
    if (roomleValue && name) {
      finishMap[roomleValue] = name;
    }
  }
  return finishMap;
};
const getFormattedFabricMap = () => {
  return formattedMetaobjects[ROOMLE_COLOR_MAP] || {};
};
const getFormattedFinishMap = () => {
  return formattedMetaobjects[PRODUCT_STRUCTURE_FINISH] || {};
};
const formatPatternMetaobject = (metaobjects) => {
  const patternMap = {};
  if (!metaobjects || !Array.isArray(metaobjects)) {
    return patternMap;
  }
  for (const metaobject of metaobjects) {
    if (!metaobject.fields || !Array.isArray(metaobject.fields)) {
      continue;
    }
    let roomleValue = null;
    let name = null;
    for (const field of metaobject.fields) {
      if (field && typeof field === "object") {
        if (field.key === "roomle_value" && field.value) {
          roomleValue = field.value;
        } else if (field.key === "name" && field.value) {
          name = field.value;
        }
      }
    }
    if (roomleValue && name) {
      patternMap[roomleValue] = name;
    }
  }
  return patternMap;
};
const getFormattedPatternMap = () => {
  return formattedMetaobjects[PRODUCT_STRUCTURE_PATTERN] || {};
};
const formatStandingMetaobject = (metaobjects) => {
  const standingMap = {};
  if (!metaobjects || !Array.isArray(metaobjects)) {
    return standingMap;
  }
  for (const metaobject of metaobjects) {
    if (!metaobject.fields || !Array.isArray(metaobject.fields)) {
      continue;
    }
    let roomleValue = null;
    let name = null;
    for (const field of metaobject.fields) {
      if (field && typeof field === "object") {
        if (field.key === "roomle_value" && field.value) {
          roomleValue = field.value;
        } else if (field.key === "name" && field.value) {
          name = field.value;
        }
      }
    }
    if (roomleValue && name) {
      standingMap[roomleValue] = name;
    }
  }
  return standingMap;
};
const getFormattedStandingMap = () => {
  return formattedMetaobjects[PRODUCT_STRUCTURE_STANDING] || {};
};
const formatSwatchTranslations = (metaobjects) => {
  if (!metaobjects || !Array.isArray(metaobjects)) {
    return [];
  }
  return metaobjects.map((metaobject) => {
    const fields = metaobject.fields || [];
    const getField = (key) => {
      var _a;
      return ((_a = fields.find((f2) => f2.key === key)) == null ? void 0 : _a.value) || "";
    };
    const translations = {};
    for (const field of fields) {
      const match = field.key.match(/^(.+)_translation$/);
      if (match && field.value) {
        const locale = LANGUAGE_LOCALE_MAP[match[1]];
        if (locale) translations[locale] = field.value;
      }
    }
    return {
      english: getField("english_swatch_value"),
      translations
    };
  }).filter((t2) => t2.english);
};
const getTranslatedSwatchValue = (value) => {
  var _a;
  if (!value || swatchTranslationsCache.length === 0) return value;
  const locale = (((_a = window.theme) == null ? void 0 : _a.locale) || "en").split("-")[0].toLowerCase();
  if (locale === "en") return value;
  const normalizedValue = value.toLowerCase();
  const translation = swatchTranslationsCache.find((t2) => t2.english.toLowerCase() === normalizedValue);
  if (!translation) return value;
  return translation.translations[locale] || value;
};
const formatMetaobjects = (metaobjects) => {
  const metaobjectsCache2 = getMetaobjects();
  for (const metaobjectType of metaobjectTypes) {
    const metaobject = metaobjectsCache2[metaobjectType];
    if (metaobjectType === ROOMLE_COLOR_MAP) {
      const formattedMap = formatFabricMetaobject(metaobject);
      formattedMetaobjects[metaobjectType] = formattedMap;
    } else if (metaobjectType === PRODUCT_STRUCTURE_FINISH) {
      const formattedMap = formatFinishMetaobject(metaobject);
      formattedMetaobjects[metaobjectType] = formattedMap;
    } else if (metaobjectType === PRODUCT_STRUCTURE_PATTERN) {
      const formattedMap = formatPatternMetaobject(metaobject);
      formattedMetaobjects[metaobjectType] = formattedMap;
    } else if (metaobjectType === PRODUCT_STRUCTURE_STANDING) {
      const formattedMap = formatStandingMetaobject(metaobject);
      formattedMetaobjects[metaobjectType] = formattedMap;
    } else if (metaobjectType === SWATCH_VALUE_TRANSLATIONS) {
      swatchTranslationsCache = formatSwatchTranslations(metaobject);
    }
  }
  return null;
};
let metaobjectsReadyPromise = null;
const initializeMetaobjects = async () => {
  try {
    metaobjectsCache = await findMetaobjectsByTypes(metaobjectTypes);
    formatMetaobjects(metaobjectsCache);
  } catch (error) {
    console.error("Error fetching metaobjects during initialization:", error);
  }
};
const ensureMetaobjectsReady = () => {
  if (!metaobjectsReadyPromise) {
    metaobjectsReadyPromise = initializeMetaobjects();
  }
  return metaobjectsReadyPromise;
};
const filterVariantsByOption = (variants, paramValue, config) => {
  if (!(variants == null ? void 0 : variants.length)) return [];
  if (!paramValue) return variants;
  const {
    optionNameMatchers,
    resolveValue,
    warnOnMissingResolution,
    compare = "includes"
  } = config;
  const rawResolved = resolveValue ? resolveValue(paramValue) : paramValue;
  if (!rawResolved || Array.isArray(rawResolved) && rawResolved.length === 0) {
    if (warnOnMissingResolution) {
      console.warn(`🔍 ${warnOnMissingResolution}: ${paramValue}`);
    }
    return [];
  }
  const candidates = Array.isArray(rawResolved) ? rawResolved : [rawResolved];
  for (const candidate of candidates) {
    const target = candidate.toLowerCase();
    const filtered = variants.filter((variant) => {
      var _a;
      if (!((_a = variant.selectedOptions) == null ? void 0 : _a.length)) return false;
      for (const matcher of optionNameMatchers) {
        const option = variant.selectedOptions.find((opt) => matcher(opt.name.toLowerCase()));
        if (option == null ? void 0 : option.value) {
          const val = option.value.toLowerCase();
          return compare === "exact" ? val === target : val.includes(target);
        }
      }
      return false;
    });
    if (filtered.length > 0) return filtered;
  }
  return [];
};
const findVariantToAdd = (shopifyProduct, roomleProduct) => {
  var _a, _b, _c, _d;
  if (!shopifyProduct || !roomleProduct) {
    return null;
  }
  if (!roomleProduct.parameters || roomleProduct.parameters.length === 0 || ((_b = (_a = shopifyProduct.variants) == null ? void 0 : _a.nodes) == null ? void 0 : _b.length) === 1) {
    const variants2 = ((_c = shopifyProduct.variants) == null ? void 0 : _c.nodes) || [];
    return variants2.length > 0 ? variants2[0] : null;
  }
  const variants = ((_d = shopifyProduct.variants) == null ? void 0 : _d.nodes) || [];
  if (variants.length === 0) {
    return null;
  }
  const frequencyParam = roomleProduct.parameters.find((param) => param.key === "frequency");
  const standingParam = roomleProduct.parameters.find((param) => param.key === "standing");
  const freeStandingParam = roomleProduct.parameters.find((param) => param.key === "freeStanding");
  const fabricParam = roomleProduct.parameters.find((param) => param.key === "fabric");
  const finishParam = roomleProduct.parameters.find((param) => param.key === "finish");
  const customSizeParam = roomleProduct.parameters.find((param) => param.key === "customSize");
  const shapeParam = roomleProduct.parameters.find((param) => param.key === "shape");
  const flexParam = roomleProduct.parameters.find((param) => param.key === "rangeLimiter");
  const stackHeightParam = roomleProduct.parameters.find((param) => param.key === "stackHeight");
  let filteredVariants = variants;
  const standingValue = (() => {
    const raw = (standingParam == null ? void 0 : standingParam.value) ?? (standingParam == null ? void 0 : standingParam.valueLabel);
    if (raw) return raw;
    const fs = freeStandingParam == null ? void 0 : freeStandingParam.value;
    if (fs === "1") return "freestand";
    if (fs === "0") return "wallmount";
    return void 0;
  })();
  const filterSteps = [{
    productOptionMatch: (n2) => n2.includes("frequency"),
    optionNameMatchers: [(n2) => n2 === "frequency"],
    paramValue: frequencyParam == null ? void 0 : frequencyParam.value
  }, {
    // SoundBlocks "Standing" option (Free Stand / Wall Mount). Roomle sends a
    // `standing` param whose valueLabel ("Free Stand" / "Wall Mount") matches
    // the Shopify option values verbatim. For modular products extracted from
    // the configuration string, only the raw value ("freestand"/"wallmount")
    // is available, so resolve it to the human-readable label first.
    productOptionMatch: (n2) => n2.includes("standing"),
    optionNameMatchers: [(n2) => n2.includes("standing")],
    // Prefer the raw Roomle key (value) over valueLabel — valueLabel may be a
    // localized display name (e.g. "Tower") that resolveValue won't recognise.
    // standingValue also covers the newer `freeStanding` (1/0) param.
    paramValue: standingValue,
    resolveValue: (raw) => {
      const lower = raw.toLowerCase();
      if (lower === "freestand" || lower === "free stand") return ["Free Stand", "Tower"];
      if (lower === "wallmount" || lower === "wall mount") return "Wall Mount";
      return raw;
    },
    compare: "exact"
  }, {
    productOptionMatch: (n2) => n2.includes("fabric") || n2.includes("color"),
    optionNameMatchers: [(n2) => n2.includes("fabric"), (n2) => n2.includes("color")],
    paramValue: fabricParam == null ? void 0 : fabricParam.value,
    resolveValue: (raw) => getFormattedFabricMap()[raw],
    warnOnMissingResolution: "No Shopify color mapping found for fabric",
    compare: "exact"
  }, {
    productOptionMatch: (n2) => n2.includes("finish"),
    optionNameMatchers: [(n2) => n2 === "finish"],
    paramValue: finishParam == null ? void 0 : finishParam.value,
    resolveValue: (raw) => getFormattedFinishMap()[raw],
    warnOnMissingResolution: "No Shopify finish mapping found for finish"
  }, {
    productOptionMatch: (n2) => n2.includes("size") || n2.includes("shape"),
    optionNameMatchers: [(n2) => n2 === "shape"],
    paramValue: customSizeParam == null ? void 0 : customSizeParam.valueLabel
  }, {
    productOptionMatch: (n2) => n2.includes("shape"),
    optionNameMatchers: [(n2) => n2 === "shape"],
    paramValue: shapeParam == null ? void 0 : shapeParam.valueLabel
  }, {
    productOptionMatch: (n2) => n2.includes("flex"),
    optionNameMatchers: [(n2) => n2.includes("flex")],
    paramValue: flexParam == null ? void 0 : flexParam.valueLabel
  }, {
    // "Configuration" / "Option" products use data-roomle-standing with values
    // "freestand" / "wallmount" — same Roomle param as the Standing option but
    // with different Shopify option value labels.
    productOptionMatch: (n2) => n2.includes("configuration") || n2 === "option",
    optionNameMatchers: [(n2) => n2.includes("configuration") || n2 === "option"],
    paramValue: standingValue,
    resolveValue: (raw) => {
      const lower = raw.toLowerCase();
      if (lower === "freestand" || lower === "free stand") return ["Freestanding", "Tower", "Free Stand"];
      if (lower === "wallmount" || lower === "wall mount") return ["Wall/Ceiling Mount", "Wall Mount"];
      return raw;
    },
    compare: "exact"
  }, {
    // "Block Quantity" (SoundBlocks stack): Roomle does not send a quantity
    // parameter — the number of stacked blocks is the item's aggregated
    // `count` — so match the Shopify option against count, not a param.
    productOptionMatch: (n2) => n2.includes("quantity"),
    optionNameMatchers: [(n2) => n2.includes("quantity")],
    paramValue: roomleProduct.count != null ? String(roomleProduct.count) : void 0,
    compare: "exact"
  }, {
    // SoundBlocks "Blocks" option: the stackHeight Roomle param maps directly
    // to the number of blocks. For modular products from the room configurator,
    // stackHeight is also stored in roomleProduct.count, so fall back to that.
    productOptionMatch: (n2) => n2.includes("block"),
    optionNameMatchers: [(n2) => n2.includes("block")],
    paramValue: (stackHeightParam == null ? void 0 : stackHeightParam.value) ?? (roomleProduct.count != null ? String(roomleProduct.count) : void 0),
    compare: "exact"
  }];
  for (const step of filterSteps) {
    if (shopifyProduct.options.some((opt) => step.productOptionMatch(opt.name.toLowerCase()))) {
      filteredVariants = filterVariantsByOption(filteredVariants, step.paramValue, step);
      if (filteredVariants.length === 1) {
        return filteredVariants[0];
      }
    }
  }
  if (filteredVariants.length > 1) {
    console.warn(`Unable to fully filter variants for the following roomle product: ${roomleProduct.label || "unknown"}: `, roomleProduct, `filteredVariants:`, filteredVariants);
    return null;
  }
  return filteredVariants.length === 1 ? filteredVariants[0] : null;
};
const addCustomLineItemAttributes = (product, roomleProduct, variant) => {
  var _a, _b;
  if (!product || !roomleProduct || !roomleProduct.parameters) {
    return {};
  }
  const customAttributes = {};
  const fabricMap = getFormattedFabricMap();
  const finishMap = getFormattedFinishMap();
  const patternMap = getFormattedPatternMap();
  const standingMap = getFormattedStandingMap();
  const lineItemStrings = ((_a = window.theme) == null ? void 0 : _a.lineItemPropertyStrings) || {};
  const optionNames = (product.options || []).map((o2) => o2.name.toLowerCase());
  const optionTriggers = ((_b = window.theme) == null ? void 0 : _b.optionTriggers) || {};
  const standingPatterns = ["standing", "freestand", "mount", "configuration", "option"].map((key) => optionTriggers[key]).filter((v2) => typeof v2 === "string" && v2.trim().length > 0).map((v2) => v2.toLowerCase());
  const standingPatternsFull = standingPatterns.includes("option") ? standingPatterns : [...standingPatterns, "option"];
  const variantOptionPatterns = {
    frequency: ["frequency"],
    fabric: ["fabric", "color"],
    finish: ["finish"],
    finishBack: ["finish back", "finishback"],
    customSize: ["size", "shape"],
    shape: ["shape"],
    rangeLimiter: ["flex"],
    standing: standingPatternsFull.length ? standingPatternsFull : ["stand", "mount", "configuration", "option"],
    stackHeight: ["block", "quantity"]
  };
  const isHandledByVariant = (paramKey) => {
    const patterns = variantOptionPatterns[paramKey];
    if (!patterns) return false;
    return optionNames.some((name) => patterns.some((pattern) => name.includes(pattern)));
  };
  const localeKeyMap = {
    finish: "finish",
    pattern: "pattern",
    rangeLimiter: "flexrange",
    frequency: "frequency",
    fabric: "color",
    height: "height",
    width: "width"
  };
  const isCmDimension = (key) => {
    const k2 = key.toLowerCase();
    if (k2 === "height") return "height";
    if (k2 === "width") return "width";
    return null;
  };
  const isCustomTuning = (param) => (param.label ?? "").toLowerCase().includes("custom tuning");
  const translationMaps = {
    fabric: fabricMap,
    finish: finishMap,
    pattern: patternMap,
    standing: standingMap
  };
  const ignoredParamKeys = /* @__PURE__ */ new Set(["finishBack", "size", "freeStanding"]);
  for (const param of roomleProduct.parameters) {
    if (!param.key || !param.value) continue;
    if (ignoredParamKeys.has(param.key)) continue;
    if (isHandledByVariant(param.key)) continue;
    const dimensionType = isCmDimension(param.key);
    const tuning = isCustomTuning(param);
    const localeKey = dimensionType ? dimensionType : tuning ? "frequency" : localeKeyMap[param.key];
    const propertyName = localeKey && lineItemStrings[localeKey] || param.label || param.key;
    let propertyValue = param.valueLabel || param.value;
    if (dimensionType) {
      const cmValue = parseFloat(param.value) / 10;
      if (!isNaN(cmValue)) {
        const inchValue = Math.round(cmValue / 2.54);
        propertyValue = `${Math.round(cmValue)} cm / ${inchValue} in`;
      }
    } else if (tuning) {
      const hz = param.value.replace(/\D/g, "");
      propertyValue = hz ? `${hz}Hz` : param.value;
    } else if (param.key === "pattern" && param.value.toLowerCase() === "noplates") {
      const sp = roomleProduct.parameters.find((p2) => p2.key === "standing");
      const fsp = roomleProduct.parameters.find((p2) => p2.key === "freeStanding");
      const isFreestand = ((sp == null ? void 0 : sp.value) || "").toLowerCase().startsWith("freestand") || (fsp == null ? void 0 : fsp.value) === "1";
      propertyValue = getTranslatedSwatchValue(isFreestand ? "Backplate Only" : "Fabric Only");
    } else {
      const map = translationMaps[param.key];
      if (map && map[param.value]) {
        propertyValue = map[param.value];
      }
      if (param.key !== "fabric") {
        propertyValue = getTranslatedSwatchValue(propertyValue);
      }
    }
    if (propertyValue) {
      customAttributes[propertyName] = propertyValue;
    }
  }
  const extras1Metafield = (product.metafields || []).find((mf) => (mf == null ? void 0 : mf.namespace) === "product" && (mf == null ? void 0 : mf.key) === "extras_1");
  if (extras1Metafield == null ? void 0 : extras1Metafield.value) {
    const endCapIds = ["108492751076", "105711075541", "9046339846357"];
    if (endCapIds.some((id) => extras1Metafield.value.includes(id))) {
      const patternKey = lineItemStrings["pattern"] || "Front";
      customAttributes[patternKey] = "End Caps";
    }
  }
  return customAttributes;
};
let isProcessing = false;
let lastProcessedDetail = null;
const handleAddToCart = async (event) => {
  var _a;
  const {
    roomleItems,
    shopifyProducts,
    planId
  } = event.detail;
  let variantsToAdd = [];
  const detailHash = JSON.stringify({
    itemsCount: (roomleItems == null ? void 0 : roomleItems.length) || 0
  });
  if (isProcessing && lastProcessedDetail === detailHash) {
    return;
  }
  isProcessing = true;
  lastProcessedDetail = detailHash;
  setTimeout(() => {
    isProcessing = false;
  }, 200);
  if (!roomleItems || !Array.isArray(roomleItems) || roomleItems.length === 0) {
    console.warn("🛒 No roomle items to process");
    return;
  }
  if (!shopifyProducts || !Array.isArray(shopifyProducts) || shopifyProducts.length === 0) {
    console.warn("🛒 No shopify products available");
    return;
  }
  for (const roomleProduct of roomleItems) {
    if (!roomleProduct.componentId && !roomleProduct.catalogItemId) {
      console.warn("🛒 Roomle product missing componentId/catalogItemId:", roomleProduct);
      continue;
    }
    const matchingShopifyProduct = findProductForRoomleItem(roomleProduct, shopifyProducts);
    if (!matchingShopifyProduct) {
      console.warn(`🛒 No matching Shopify product found for catalogItemId: ${roomleProduct.catalogItemId} / componentId: ${roomleProduct.componentId}`);
      continue;
    }
    const variant = findVariantToAdd(matchingShopifyProduct, roomleProduct);
    if (variant) {
      const variantId = variant.id.split("gid://shopify/ProductVariant/")[1];
      const properties = addCustomLineItemAttributes(matchingShopifyProduct, roomleProduct);
      if (planId) {
        properties["_room_design_id"] = String(planId);
      }
      const units = roomleProduct.units || 1;
      const item = {
        id: parseInt(variantId, 10),
        quantity: units
      };
      if (Object.keys(properties).length > 0) {
        item.properties = properties;
      }
      variantsToAdd.push(item);
    } else {
      console.warn(`⚠️ No variant found for ${roomleProduct.componentId}`);
    }
  }
  if (variantsToAdd.length === 0) {
    console.warn("🛒 No variants to add to cart");
    return;
  }
  const origin = window.location.origin;
  const routes = (_a = window.theme) == null ? void 0 : _a.routes;
  const cartAddUrl = (routes == null ? void 0 : routes.cart_add_url) || `${origin}/cart/add.js`;
  const cartUpdateUrl = `${origin}/cart/update.js`;
  try {
    const cartResponse = await fetch(`${origin}/cart.js`);
    const cart = await cartResponse.json();
    const roomItemUpdates = (cart.items || []).filter((item) => {
      var _a2;
      return ((_a2 = item.properties) == null ? void 0 : _a2["_room_design_id"]) != null;
    }).reduce((acc, item) => {
      acc[item.key] = 0;
      return acc;
    }, {});
    if (Object.keys(roomItemUpdates).length > 0) {
      await fetch(cartUpdateUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          updates: roomItemUpdates
        })
      });
    }
    const addResponse = await fetch(cartAddUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: variantsToAdd
      })
    });
    if (!addResponse.ok) {
      const errorText = await addResponse.text();
      console.error("❌ HTTP error response:", addResponse.status, errorText);
      throw new Error(`HTTP error! status: ${addResponse.status}`);
    }
    document.dispatchEvent(new CustomEvent("cart:refresh", {
      detail: {
        open: true
      }
    }));
  } catch (error) {
    console.error("❌ Error updating cart:", error);
  }
};
const initializeRoomleCartHandler = async () => {
  window.addEventListener("roomle:addtocart", (event) => {
    handleAddToCart(event).finally(() => {
      document.dispatchEvent(new CustomEvent("roomle:cart:settled"));
    });
  });
  await ensureMetaobjectsReady();
};
if (typeof window !== "undefined") {
  initializeRoomleCartHandler();
}
var _jsxFileName$h = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/Roomle/RoomleRoomConfigurator/RoomleRoomButtons.tsx";
const stripZeroDecimals = (price) => price.replace(/([.,])00(?=\D*$)/, "");
const formatPrice = (cents) => {
  var _a, _b, _c, _d;
  const t2 = window.theme;
  const fmt = ((_a = t2 == null ? void 0 : t2.settings) == null ? void 0 : _a.currencyCodeEnabled) ? (_b = t2 == null ? void 0 : t2.settings) == null ? void 0 : _b.moneyWithCurrencyFormat : (_c = t2 == null ? void 0 : t2.settings) == null ? void 0 : _c.moneyFormat;
  if ((_d = t2 == null ? void 0 : t2.Currency) == null ? void 0 : _d.formatMoney) {
    return stripZeroDecimals(t2.Currency.formatMoney(cents, fmt));
  }
  return stripZeroDecimals(`$${(cents / 100).toFixed(2)}`);
};
const animateButton = (btn, loading) => {
  const M2 = window.Motion;
  if (!btn || !M2) return;
  const btnText = btn.querySelector(".btn-text");
  const btnLoader = btn.querySelector(".btn-loader");
  if (!btnText || !btnLoader) return;
  if (loading) {
    M2.timeline([[btnText, {
      opacity: 0
    }, {
      duration: 0.15
    }], [btnLoader, {
      opacity: 1
    }, {
      duration: 0.15
    }]]);
    M2.animate(btnLoader.children, {
      transform: ["scale(1.6)", "scale(0.6)"]
    }, {
      duration: 0.35,
      delay: M2.stagger(0.35 / 2),
      direction: "alternate",
      repeat: Infinity
    });
  } else {
    M2.timeline([[btnLoader, {
      opacity: 0
    }, {
      duration: 0.15
    }], [btnText, {
      opacity: 1
    }, {
      duration: 0.15
    }]]);
  }
};
const FILL_STYLE$1 = "transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;";
const RoomleRoomButtons = ({
  isAddingToCart,
  isSavingPlan,
  totalPriceCents,
  onAddToCart,
  onSavePlan
}) => {
  var _a, _b, _c, _d;
  const addToCartRef = t$3(A$1(null), "addToCartRef");
  const savePlanRef = t$3(A$1(null), "savePlanRef");
  y(() => {
    var _a2;
    const btns = [addToCartRef.current, savePlanRef.current];
    for (const btn of btns) {
      if (!btn || !((_a2 = window.theme) == null ? void 0 : _a2.HoverButton)) continue;
      const hoverBtn = new window.theme.HoverButton(btn);
      hoverBtn.load();
    }
  }, []);
  y(() => animateButton(addToCartRef.current, isAddingToCart), [isAddingToCart]);
  y(() => animateButton(savePlanRef.current, isSavingPlan), [isSavingPlan]);
  return u$1("div", {
    class: "roomle-room-buttons",
    children: [u$1("button", {
      ref: addToCartRef,
      class: "product-form__submit button button--primary button--fixed",
      onClick: onAddToCart,
      disabled: isAddingToCart,
      "aria-busy": isAddingToCart ? "true" : void 0,
      children: [u$1("span", {
        class: "btn-fill",
        "data-fill": "",
        style: FILL_STYLE$1
      }, void 0, false, {
        fileName: _jsxFileName$h,
        lineNumber: 85,
        columnNumber: 9
      }, void 0), u$1("span", {
        class: "btn-text",
        children: [u$1("span", {
          children: ((_b = (_a = window.theme) == null ? void 0 : _a.variantStrings) == null ? void 0 : _b.addToCart) || "Add to cart"
        }, void 0, false, {
          fileName: _jsxFileName$h,
          lineNumber: 87,
          columnNumber: 11
        }, void 0), totalPriceCents > 0 && u$1("div", {
          id: "BuyButtonPrice-roomle-room-configurator",
          class: "flex",
          children: [u$1("span", {
            class: "relative",
            children: "  -  "
          }, void 0, false, {
            fileName: _jsxFileName$h,
            lineNumber: 90,
            columnNumber: 15
          }, void 0), u$1("product-buy-price", {
            class: "price",
            "data-price": totalPriceCents,
            children: formatPrice(totalPriceCents)
          }, void 0, false, {
            fileName: _jsxFileName$h,
            lineNumber: 91,
            columnNumber: 15
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$h,
          lineNumber: 89,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$h,
        lineNumber: 86,
        columnNumber: 9
      }, void 0), u$1("span", {
        class: "btn-loader",
        children: [u$1("span", {}, void 0, false, {
          fileName: _jsxFileName$h,
          lineNumber: 98,
          columnNumber: 11
        }, void 0), u$1("span", {}, void 0, false, {
          fileName: _jsxFileName$h,
          lineNumber: 98,
          columnNumber: 19
        }, void 0), u$1("span", {}, void 0, false, {
          fileName: _jsxFileName$h,
          lineNumber: 98,
          columnNumber: 27
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$h,
        lineNumber: 97,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$h,
      lineNumber: 78,
      columnNumber: 7
    }, void 0), u$1("button", {
      ref: savePlanRef,
      class: "product-form__submit button button--primary button--fixed",
      onClick: onSavePlan,
      disabled: isSavingPlan,
      "aria-busy": isSavingPlan ? "true" : void 0,
      children: [u$1("span", {
        class: "btn-fill",
        "data-fill": "",
        style: FILL_STYLE$1
      }, void 0, false, {
        fileName: _jsxFileName$h,
        lineNumber: 108,
        columnNumber: 9
      }, void 0), u$1("span", {
        class: "btn-text",
        children: u$1("span", {
          children: isSavingPlan ? "Saving..." : ((_d = (_c = window.theme) == null ? void 0 : _c.variantStrings) == null ? void 0 : _d.savePlan) || "Save plan"
        }, void 0, false, {
          fileName: _jsxFileName$h,
          lineNumber: 110,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$h,
        lineNumber: 109,
        columnNumber: 9
      }, void 0), u$1("span", {
        class: "btn-loader",
        children: [u$1("span", {}, void 0, false, {
          fileName: _jsxFileName$h,
          lineNumber: 113,
          columnNumber: 11
        }, void 0), u$1("span", {}, void 0, false, {
          fileName: _jsxFileName$h,
          lineNumber: 113,
          columnNumber: 19
        }, void 0), u$1("span", {}, void 0, false, {
          fileName: _jsxFileName$h,
          lineNumber: 113,
          columnNumber: 27
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$h,
        lineNumber: 112,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$h,
      lineNumber: 101,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$h,
    lineNumber: 77,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$g = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/Roomle/RoomleRoomConfigurator/RoomleSaveModal.tsx";
const FILL_STYLE = "transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;";
const RoomleSaveModal = ({
  isOpen,
  url,
  onClose
}) => {
  const copyRef = t$3(A$1(null), "copyRef");
  const [copied, setCopied] = t$3(d(false), "copied");
  y(() => {
    var _a;
    const btn = copyRef.current;
    if (!btn || !((_a = window.theme) == null ? void 0 : _a.HoverButton)) return;
    const hoverBtn = new window.theme.HoverButton(btn);
    hoverBtn.load();
  }, [isOpen]);
  y(() => {
    if (!isOpen) return;
    const onKey = (e2) => e2.key === "Escape" && onClose();
    document.addEventListener("keyup", onKey);
    return () => document.removeEventListener("keyup", onKey);
  }, [isOpen, onClose]);
  y(() => {
    if (isOpen) setCopied(false);
  }, [isOpen]);
  if (!isOpen || !url) return null;
  const handleCopy = () => {
    var _a;
    (_a = navigator.clipboard) == null ? void 0 : _a.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2e3);
    }, () => {
    });
  };
  return u$1("div", {
    class: "roomle-save-modal",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Plan saved",
    onClick: onClose,
    children: u$1("div", {
      class: "roomle-save-modal__card",
      onClick: (e2) => e2.stopPropagation(),
      children: [u$1("button", {
        type: "button",
        class: "roomle-save-modal__close",
        "aria-label": "Close",
        onClick: onClose,
        children: u$1("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          stroke: "currentColor",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: u$1("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M5 15L15 5M5 5L15 15"
          }, void 0, false, {
            fileName: _jsxFileName$g,
            lineNumber: 55,
            columnNumber: 13
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$g,
          lineNumber: 54,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$g,
        lineNumber: 53,
        columnNumber: 9
      }, void 0), u$1("h2", {
        class: "roomle-save-modal__title text-lg",
        children: "Plan saved"
      }, void 0, false, {
        fileName: _jsxFileName$g,
        lineNumber: 59,
        columnNumber: 9
      }, void 0), u$1("p", {
        class: "roomle-save-modal__text",
        children: "Your configuration is saved — use the link below to share it."
      }, void 0, false, {
        fileName: _jsxFileName$g,
        lineNumber: 60,
        columnNumber: 9
      }, void 0), u$1("a", {
        class: "roomle-save-modal__link",
        href: url,
        children: url
      }, void 0, false, {
        fileName: _jsxFileName$g,
        lineNumber: 62,
        columnNumber: 9
      }, void 0), u$1("button", {
        ref: copyRef,
        type: "button",
        class: "roomle-save-modal__copy product-form__submit button button--primary button--fixed",
        onClick: handleCopy,
        children: [u$1("span", {
          class: "btn-fill",
          "data-fill": "",
          style: FILL_STYLE
        }, void 0, false, {
          fileName: _jsxFileName$g,
          lineNumber: 72,
          columnNumber: 11
        }, void 0), u$1("span", {
          class: "btn-text",
          children: u$1("span", {
            children: copied ? "Link copied!" : "Copy link"
          }, void 0, false, {
            fileName: _jsxFileName$g,
            lineNumber: 74,
            columnNumber: 13
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$g,
          lineNumber: 73,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$g,
        lineNumber: 66,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$g,
      lineNumber: 52,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName$g,
    lineNumber: 51,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$f = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/Roomle/RoomleRoomConfigurator/RoomleDebugPanel.tsx";
const cell$1 = {
  border: "1px solid #ddd",
  padding: "4px 8px",
  textAlign: "left",
  verticalAlign: "top"
};
const th$1 = {
  ...cell$1,
  background: "#f2f2f2",
  fontWeight: 700
};
const mono$1 = {
  fontFamily: "monospace",
  fontSize: "12px",
  wordBreak: "break-all"
};
const RoomleDebugPanel = ({
  isOpen,
  onClose,
  roomleItems,
  shopifyProducts,
  overview,
  configurator
}) => {
  const [liveParams, setLiveParams] = t$3(d(null), "liveParams");
  const [isFetchingParams, setIsFetchingParams] = t$3(d(false), "isFetchingParams");
  const [objectParams, setObjectParams] = t$3(d({}), "objectParams");
  const fetchLiveParams = q$1(async () => {
    if (!configurator) return;
    setIsFetchingParams(true);
    try {
      const api = configurator.extended ?? configurator.configurator;
      const all = [];
      const tryNoArgMethod = async (method, label) => {
        if (typeof (api == null ? void 0 : api[method]) !== "function") return;
        try {
          const params = await api[method]();
          params == null ? void 0 : params.forEach((p2) => {
            if (!all.find((x2) => x2.key === p2.key && x2._source === label)) {
              all.push({
                ...p2,
                _source: label
              });
            }
          });
        } catch (_2) {
        }
      };
      await tryNoArgMethod("getParametersOfRootComponent", "root");
      await tryNoArgMethod("getParametersOfPlanObject", "plan");
      const overviewObjects = (overview == null ? void 0 : overview.objects) ?? [];
      const perObject = {};
      for (const obj of overviewObjects) {
        const rid = obj.runtimeId ?? obj.componentRuntimeId;
        if (rid == null) continue;
        for (const method of ["getParametersOfComponent", "getParametersOfObject", "getParametersOfPlanElement"]) {
          if (typeof (api == null ? void 0 : api[method]) !== "function") continue;
          try {
            const params = await api[method](rid);
            if (params == null ? void 0 : params.length) {
              perObject[rid] = params;
              params.forEach((p2) => {
                if (!all.find((x2) => x2.key === p2.key)) {
                  all.push({
                    ...p2,
                    _source: `obj-runtimeId:${rid}`
                  });
                }
              });
              break;
            }
          } catch (_2) {
          }
        }
      }
      if (typeof (api == null ? void 0 : api.getPartList) === "function") {
        try {
          const parts = await api.getPartList();
          for (const part of parts ?? []) {
            if (part.runtimeId && typeof api.getParametersOfComponent === "function") {
              try {
                const cp = await api.getParametersOfComponent(part.runtimeId);
                cp == null ? void 0 : cp.forEach((p2) => {
                  if (!all.find((x2) => x2.key === p2.key)) {
                    all.push({
                      ...p2,
                      _source: `partlist:${part.name ?? part.runtimeId}`
                    });
                  }
                });
              } catch (_2) {
              }
            }
          }
        } catch (_2) {
        }
      }
      setLiveParams(all);
      setObjectParams(perObject);
    } finally {
      setIsFetchingParams(false);
    }
  }, [configurator, overview]);
  if (!isOpen) return null;
  const objects = (overview == null ? void 0 : overview.objects) || [];
  return u$1("div", {
    style: {
      position: "fixed",
      inset: 0,
      zIndex: 99999,
      background: "rgba(0,0,0,0.85)",
      color: "#111",
      overflow: "auto",
      padding: "24px",
      fontSize: "13px"
    },
    children: u$1("div", {
      style: {
        maxWidth: "1200px",
        margin: "0 auto",
        background: "#fff",
        padding: "24px",
        borderRadius: "8px"
      },
      children: [u$1("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px"
        },
        children: [u$1("h2", {
          style: {
            margin: 0
          },
          children: "Roomle → Shopify match debug"
        }, void 0, false, {
          fileName: _jsxFileName$f,
          lineNumber: 127,
          columnNumber: 11
        }, void 0), u$1("button", {
          onClick: onClose,
          style: {
            padding: "8px 16px",
            cursor: "pointer"
          },
          children: "Close ✕"
        }, void 0, false, {
          fileName: _jsxFileName$f,
          lineNumber: 128,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$f,
        lineNumber: 126,
        columnNumber: 9
      }, void 0), u$1("p", {
        style: {
          ...mono$1
        },
        children: [roomleItems.length, " roomle item(s) · ", shopifyProducts.length, " shopify product(s) fetched"]
      }, void 0, true, {
        fileName: _jsxFileName$f,
        lineNumber: 131,
        columnNumber: 9
      }, void 0), configurator && u$1("div", {
        style: {
          border: "2px dashed #060",
          borderRadius: "6px",
          padding: "12px",
          marginBottom: "24px"
        },
        children: [u$1("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "8px"
          },
          children: [u$1("h4", {
            style: {
              margin: 0
            },
            children: "Live configurator parameters"
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 139,
            columnNumber: 15
          }, void 0), u$1("button", {
            onClick: fetchLiveParams,
            disabled: isFetchingParams,
            style: {
              padding: "4px 12px",
              cursor: "pointer",
              fontWeight: 600
            },
            children: isFetchingParams ? "Fetching…" : liveParams ? "↺ Refresh" : "Fetch params"
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 140,
            columnNumber: 15
          }, void 0), liveParams && u$1("span", {
            style: {
              ...mono$1,
              color: "#555"
            },
            children: [liveParams.length, " param(s) across all sources"]
          }, void 0, true, {
            fileName: _jsxFileName$f,
            lineNumber: 147,
            columnNumber: 30
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$f,
          lineNumber: 138,
          columnNumber: 13
        }, void 0), u$1("p", {
          style: {
            ...mono$1,
            marginTop: 0,
            color: "#555",
            fontSize: "11px"
          },
          children: "Tries root, plan, per-object runtimeId, and part list. Use this when overview parts are empty (hasGeometry: false)."
        }, void 0, false, {
          fileName: _jsxFileName$f,
          lineNumber: 149,
          columnNumber: 13
        }, void 0), objects.length > 0 && u$1("div", {
          style: {
            marginBottom: "12px"
          },
          children: [u$1("h5", {
            style: {
              margin: "0 0 6px"
            },
            children: "Overview objects — configuration & dimensions"
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 156,
            columnNumber: 17
          }, void 0), objects.map((obj, i2) => {
            var _a, _b, _c, _d, _e;
            let parsedConfig = null;
            try {
              parsedConfig = JSON.parse(obj.configuration);
            } catch (_2) {
            }
            const rid = obj.runtimeId ?? obj.componentRuntimeId;
            const params = objectParams[rid] ?? [];
            return u$1("div", {
              style: {
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "8px",
                marginBottom: "8px",
                background: "#f9fff9"
              },
              children: [u$1("div", {
                style: {
                  ...mono$1,
                  fontWeight: 700,
                  marginBottom: "4px"
                },
                children: ["obj #", i2 + 1, " — catalogItemId: ", obj.catalogItemId ?? "—", " · runtimeId: ", rid ?? "—"]
              }, void 0, true, {
                fileName: _jsxFileName$f,
                lineNumber: 164,
                columnNumber: 23
              }, void 0), u$1("div", {
                style: {
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "8px"
                },
                children: [u$1("div", {
                  children: [u$1("div", {
                    style: {
                      ...mono$1,
                      fontSize: "11px",
                      color: "#555"
                    },
                    children: "dimensions (x/y/z mm)"
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 169,
                    columnNumber: 27
                  }, void 0), u$1("div", {
                    style: {
                      ...mono$1
                    },
                    children: obj.dimensions ? `${obj.dimensions.x} × ${obj.dimensions.y} × ${obj.dimensions.z}` : "—"
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 170,
                    columnNumber: 27
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 168,
                  columnNumber: 25
                }, void 0), u$1("div", {
                  children: [u$1("div", {
                    style: {
                      ...mono$1,
                      fontSize: "11px",
                      color: "#555"
                    },
                    children: "hasGeometry"
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 175,
                    columnNumber: 27
                  }, void 0), u$1("div", {
                    style: {
                      ...mono$1,
                      color: ((_b = (_a = obj.parts) == null ? void 0 : _a.originPart) == null ? void 0 : _b.hasGeometry) ? "#060" : "#a00"
                    },
                    children: String(((_d = (_c = obj.parts) == null ? void 0 : _c.originPart) == null ? void 0 : _d.hasGeometry) ?? false)
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 176,
                    columnNumber: 27
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 174,
                  columnNumber: 25
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$f,
                lineNumber: 167,
                columnNumber: 23
              }, void 0), parsedConfig && u$1("div", {
                style: {
                  marginTop: "4px"
                },
                children: [u$1("div", {
                  style: {
                    ...mono$1,
                    fontSize: "11px",
                    color: "#555"
                  },
                  children: "configuration (parsed)"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 183,
                  columnNumber: 27
                }, void 0), u$1("pre", {
                  style: {
                    ...mono$1,
                    background: "#f0f0f0",
                    padding: "4px",
                    margin: "2px 0 0",
                    borderRadius: "3px",
                    maxHeight: "120px",
                    overflow: "auto"
                  },
                  children: JSON.stringify(parsedConfig, null, 2)
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 184,
                  columnNumber: 27
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$f,
                lineNumber: 182,
                columnNumber: 25
              }, void 0), ((_e = obj.parameters) == null ? void 0 : _e.length) > 0 && u$1("div", {
                style: {
                  marginTop: "6px"
                },
                children: [u$1("div", {
                  style: {
                    ...mono$1,
                    fontSize: "11px",
                    color: "#555"
                  },
                  children: "obj.parameters (from overview)"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 192,
                  columnNumber: 27
                }, void 0), u$1("table", {
                  style: {
                    borderCollapse: "collapse",
                    width: "100%",
                    marginTop: "4px"
                  },
                  children: [u$1("thead", {
                    children: u$1("tr", {
                      children: [u$1("th", {
                        style: th$1,
                        children: "key"
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 194,
                        columnNumber: 40
                      }, void 0), u$1("th", {
                        style: th$1,
                        children: "value"
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 194,
                        columnNumber: 63
                      }, void 0), u$1("th", {
                        style: th$1,
                        children: "valueLabel"
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 194,
                        columnNumber: 88
                      }, void 0)]
                    }, void 0, true, {
                      fileName: _jsxFileName$f,
                      lineNumber: 194,
                      columnNumber: 36
                    }, void 0)
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 194,
                    columnNumber: 29
                  }, void 0), u$1("tbody", {
                    children: obj.parameters.map((p2, j2) => u$1("tr", {
                      children: [u$1("td", {
                        style: {
                          ...cell$1,
                          ...mono$1
                        },
                        children: p2.key
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 197,
                        columnNumber: 45
                      }, void 0), u$1("td", {
                        style: {
                          ...cell$1,
                          ...mono$1,
                          color: "#0066cc"
                        },
                        children: p2.value
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 197,
                        columnNumber: 90
                      }, void 0), u$1("td", {
                        style: cell$1,
                        children: p2.valueLabel
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 197,
                        columnNumber: 155
                      }, void 0)]
                    }, j2, true, {
                      fileName: _jsxFileName$f,
                      lineNumber: 197,
                      columnNumber: 33
                    }, void 0))
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 195,
                    columnNumber: 29
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 193,
                  columnNumber: 27
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$f,
                lineNumber: 191,
                columnNumber: 25
              }, void 0), params.length > 0 && u$1("div", {
                style: {
                  marginTop: "6px"
                },
                children: [u$1("div", {
                  style: {
                    ...mono$1,
                    fontSize: "11px",
                    color: "#060",
                    fontWeight: 600
                  },
                  children: ["params via getParametersOfComponent(runtimeId:", rid, ")"]
                }, void 0, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 206,
                  columnNumber: 27
                }, void 0), u$1("table", {
                  style: {
                    borderCollapse: "collapse",
                    width: "100%",
                    marginTop: "4px"
                  },
                  children: [u$1("thead", {
                    children: u$1("tr", {
                      children: [u$1("th", {
                        style: th$1,
                        children: "key"
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 208,
                        columnNumber: 40
                      }, void 0), u$1("th", {
                        style: th$1,
                        children: "value"
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 208,
                        columnNumber: 63
                      }, void 0), u$1("th", {
                        style: th$1,
                        children: "possible values"
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 208,
                        columnNumber: 88
                      }, void 0), u$1("th", {
                        style: th$1,
                        children: "type"
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 208,
                        columnNumber: 123
                      }, void 0)]
                    }, void 0, true, {
                      fileName: _jsxFileName$f,
                      lineNumber: 208,
                      columnNumber: 36
                    }, void 0)
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 208,
                    columnNumber: 29
                  }, void 0), u$1("tbody", {
                    children: params.map((p2, j2) => {
                      var _a2;
                      return u$1("tr", {
                        style: {
                          background: j2 % 2 === 0 ? "#f0fff0" : "#fff"
                        },
                        children: [u$1("td", {
                          style: {
                            ...cell$1,
                            ...mono$1,
                            fontWeight: 600
                          },
                          children: p2.key
                        }, void 0, false, {
                          fileName: _jsxFileName$f,
                          lineNumber: 212,
                          columnNumber: 35
                        }, void 0), u$1("td", {
                          style: {
                            ...cell$1,
                            ...mono$1,
                            color: "#0066cc"
                          },
                          children: p2.value ?? p2.currentValue ?? "—"
                        }, void 0, false, {
                          fileName: _jsxFileName$f,
                          lineNumber: 213,
                          columnNumber: 35
                        }, void 0), u$1("td", {
                          style: {
                            ...cell$1,
                            fontSize: "11px"
                          },
                          children: ((_a2 = p2.possibleValues ?? p2.validValues ?? p2.options) == null ? void 0 : _a2.map((v2) => typeof v2 === "object" ? v2.key ?? v2.value ?? JSON.stringify(v2) : v2).join(", ")) ?? "—"
                        }, void 0, false, {
                          fileName: _jsxFileName$f,
                          lineNumber: 214,
                          columnNumber: 35
                        }, void 0), u$1("td", {
                          style: {
                            ...cell$1,
                            ...mono$1,
                            fontSize: "11px",
                            color: "#666"
                          },
                          children: p2.type ?? "—"
                        }, void 0, false, {
                          fileName: _jsxFileName$f,
                          lineNumber: 219,
                          columnNumber: 35
                        }, void 0)]
                      }, j2, true, {
                        fileName: _jsxFileName$f,
                        lineNumber: 211,
                        columnNumber: 33
                      }, void 0);
                    })
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 209,
                    columnNumber: 29
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 207,
                  columnNumber: 27
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$f,
                lineNumber: 205,
                columnNumber: 25
              }, void 0), liveParams !== null && params.length === 0 && u$1("div", {
                style: {
                  ...mono$1,
                  fontSize: "11px",
                  color: "#a00",
                  marginTop: "4px"
                },
                children: ["No params returned for runtimeId:", rid, " — may need geometry loaded first"]
              }, void 0, true, {
                fileName: _jsxFileName$f,
                lineNumber: 227,
                columnNumber: 25
              }, void 0)]
            }, i2, true, {
              fileName: _jsxFileName$f,
              lineNumber: 163,
              columnNumber: 21
            }, void 0);
          })]
        }, void 0, true, {
          fileName: _jsxFileName$f,
          lineNumber: 155,
          columnNumber: 15
        }, void 0), liveParams && liveParams.length > 0 && u$1("details", {
          children: [u$1("summary", {
            style: {
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "13px"
            },
            children: "All params (flat, deduped by key)"
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 240,
            columnNumber: 17
          }, void 0), u$1("table", {
            style: {
              borderCollapse: "collapse",
              width: "100%",
              marginTop: "6px"
            },
            children: [u$1("thead", {
              children: u$1("tr", {
                children: [u$1("th", {
                  style: th$1,
                  children: "key"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 244,
                  columnNumber: 23
                }, void 0), u$1("th", {
                  style: th$1,
                  children: "value"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 245,
                  columnNumber: 23
                }, void 0), u$1("th", {
                  style: th$1,
                  children: "source"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 246,
                  columnNumber: 23
                }, void 0), u$1("th", {
                  style: th$1,
                  children: "possible values"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 247,
                  columnNumber: 23
                }, void 0), u$1("th", {
                  style: th$1,
                  children: "type"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 248,
                  columnNumber: 23
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$f,
                lineNumber: 243,
                columnNumber: 21
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$f,
              lineNumber: 242,
              columnNumber: 19
            }, void 0), u$1("tbody", {
              children: liveParams.map((p2, i2) => {
                var _a;
                return u$1("tr", {
                  style: {
                    background: i2 % 2 === 0 ? "#fafafa" : "#fff"
                  },
                  children: [u$1("td", {
                    style: {
                      ...cell$1,
                      ...mono$1,
                      fontWeight: 600
                    },
                    children: p2.key
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 254,
                    columnNumber: 25
                  }, void 0), u$1("td", {
                    style: {
                      ...cell$1,
                      ...mono$1,
                      color: "#0066cc"
                    },
                    children: p2.value ?? p2.currentValue ?? "—"
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 255,
                    columnNumber: 25
                  }, void 0), u$1("td", {
                    style: {
                      ...cell$1,
                      ...mono$1,
                      fontSize: "11px",
                      color: "#888"
                    },
                    children: p2._source
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 256,
                    columnNumber: 25
                  }, void 0), u$1("td", {
                    style: {
                      ...cell$1,
                      fontSize: "11px"
                    },
                    children: ((_a = p2.possibleValues ?? p2.validValues ?? p2.options) == null ? void 0 : _a.map((v2) => typeof v2 === "object" ? v2.key ?? v2.value ?? JSON.stringify(v2) : v2).join(", ")) ?? "—"
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 257,
                    columnNumber: 25
                  }, void 0), u$1("td", {
                    style: {
                      ...cell$1,
                      ...mono$1,
                      fontSize: "11px",
                      color: "#666"
                    },
                    children: p2.type ?? "—"
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 262,
                    columnNumber: 25
                  }, void 0)]
                }, i2, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 253,
                  columnNumber: 23
                }, void 0);
              })
            }, void 0, false, {
              fileName: _jsxFileName$f,
              lineNumber: 251,
              columnNumber: 19
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$f,
            lineNumber: 241,
            columnNumber: 17
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$f,
          lineNumber: 239,
          columnNumber: 15
        }, void 0), liveParams && liveParams.length === 0 && u$1("p", {
          style: {
            ...mono$1,
            color: "#a00"
          },
          children: "No parameters found — try after the product geometry loads, then click ↺ Refresh."
        }, void 0, false, {
          fileName: _jsxFileName$f,
          lineNumber: 270,
          columnNumber: 15
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$f,
        lineNumber: 137,
        columnNumber: 11
      }, void 0), u$1("div", {
        style: {
          border: "2px dashed #06c",
          borderRadius: "6px",
          padding: "12px",
          marginBottom: "24px"
        },
        children: [u$1("h4", {
          style: {
            marginTop: 0
          },
          children: ["overview.objects (", objects.length, ") — stack grouping"]
        }, void 0, true, {
          fileName: _jsxFileName$f,
          lineNumber: 277,
          columnNumber: 11
        }, void 0), u$1("p", {
          style: {
            ...mono$1,
            marginTop: 0
          },
          children: `One row per placed object. If each stack is its own object, "geometry parts" tells us the blocks-per-stack. If every block is its own object, they'll all show 1.`
        }, void 0, false, {
          fileName: _jsxFileName$f,
          lineNumber: 278,
          columnNumber: 11
        }, void 0), u$1("table", {
          style: {
            borderCollapse: "collapse",
            width: "100%"
          },
          children: [u$1("thead", {
            children: u$1("tr", {
              children: [u$1("th", {
                style: th$1,
                children: "#"
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 285,
                columnNumber: 17
              }, void 0), u$1("th", {
                style: th$1,
                children: "object id"
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 286,
                columnNumber: 17
              }, void 0), u$1("th", {
                style: th$1,
                children: "parentId"
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 287,
                columnNumber: 17
              }, void 0), u$1("th", {
                style: th$1,
                children: "object catalogItemId / componentId"
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 288,
                columnNumber: 17
              }, void 0), u$1("th", {
                style: th$1,
                children: "geometry parts (componentId × count)"
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 289,
                columnNumber: 17
              }, void 0), u$1("th", {
                style: th$1,
                children: "fullList componentIds"
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 290,
                columnNumber: 17
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$f,
              lineNumber: 284,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 283,
            columnNumber: 13
          }, void 0), u$1("tbody", {
            children: objects.map((obj, j2) => {
              var _a, _b;
              const parts = ((_a = obj == null ? void 0 : obj.parts) == null ? void 0 : _a.perMainComponent) || [];
              const geo = parts.filter((p2) => {
                var _a2;
                return (_a2 = p2 == null ? void 0 : p2.originPart) == null ? void 0 : _a2.hasGeometry;
              });
              const fullList = ((_b = obj == null ? void 0 : obj.parts) == null ? void 0 : _b.fullList) || [];
              return u$1("tr", {
                children: [u$1("td", {
                  style: cell$1,
                  children: j2 + 1
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 300,
                  columnNumber: 21
                }, void 0), u$1("td", {
                  style: {
                    ...cell$1,
                    ...mono$1
                  },
                  children: (obj == null ? void 0 : obj.id) ?? (obj == null ? void 0 : obj.objectId) ?? "—"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 301,
                  columnNumber: 21
                }, void 0), u$1("td", {
                  style: {
                    ...cell$1,
                    ...mono$1
                  },
                  children: (obj == null ? void 0 : obj.parentId) ?? (obj == null ? void 0 : obj.parentObjectId) ?? "—"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 302,
                  columnNumber: 21
                }, void 0), u$1("td", {
                  style: {
                    ...cell$1,
                    ...mono$1
                  },
                  children: (obj == null ? void 0 : obj.catalogItemId) ?? (obj == null ? void 0 : obj.componentId) ?? "—"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 303,
                  columnNumber: 21
                }, void 0), u$1("td", {
                  style: {
                    ...cell$1,
                    ...mono$1
                  },
                  children: geo.length === 0 ? "— (no geometry)" : geo.map((p2) => {
                    var _a2, _b2;
                    return `${(_a2 = p2.originPart) == null ? void 0 : _a2.componentId} × ${((_b2 = p2.originPart) == null ? void 0 : _b2.count) ?? 0}`;
                  }).join("  |  ")
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 304,
                  columnNumber: 21
                }, void 0), u$1("td", {
                  style: {
                    ...cell$1,
                    ...mono$1
                  },
                  children: fullList.map((p2) => p2 == null ? void 0 : p2.componentId).filter(Boolean).join(", ") || "—"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 309,
                  columnNumber: 21
                }, void 0)]
              }, j2, true, {
                fileName: _jsxFileName$f,
                lineNumber: 299,
                columnNumber: 19
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 293,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$f,
          lineNumber: 282,
          columnNumber: 11
        }, void 0), u$1("details", {
          style: {
            marginTop: "8px"
          },
          children: [u$1("summary", {
            style: {
              cursor: "pointer"
            },
            children: "Raw overview JSON (full)"
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 318,
            columnNumber: 13
          }, void 0), u$1("pre", {
            style: {
              ...mono$1,
              background: "#f7f7f7",
              padding: "8px",
              overflow: "auto",
              maxHeight: "400px"
            },
            children: JSON.stringify(overview, null, 2)
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 319,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$f,
          lineNumber: 317,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$f,
        lineNumber: 276,
        columnNumber: 9
      }, void 0), roomleItems.map((item, i2) => {
        var _a;
        const product = findProductForRoomleItem(item, shopifyProducts);
        const variant = product ? findVariantToAdd(product, item) : null;
        const properties = product ? addCustomLineItemAttributes(product, item) : {};
        const variants = ((_a = product == null ? void 0 : product.variants) == null ? void 0 : _a.nodes) || [];
        return u$1("div", {
          style: {
            border: "2px solid #333",
            borderRadius: "6px",
            padding: "16px",
            marginBottom: "24px"
          },
          children: [u$1("h3", {
            style: {
              marginTop: 0
            },
            children: ["#", i2 + 1, " — ", item.label || "(no label)", " ", u$1("span", {
              style: {
                ...mono$1,
                fontWeight: 400
              },
              children: ["catalogItemId: ", item.catalogItemId ?? "—", " · componentId: ", item.componentId]
            }, void 0, true, {
              fileName: _jsxFileName$f,
              lineNumber: 335,
              columnNumber: 17
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$f,
            lineNumber: 333,
            columnNumber: 15
          }, void 0), u$1("p", {
            style: {
              ...mono$1,
              margin: "0 0 8px",
              color: "#555"
            },
            children: "Match order: catalogItemId first, then componentId."
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 339,
            columnNumber: 15
          }, void 0), u$1("p", {
            style: {
              ...mono$1,
              margin: "0 0 8px"
            },
            children: ["count (blocks per stack): ", u$1("strong", {
              children: item.count
            }, void 0, false, {
              fileName: _jsxFileName$f,
              lineNumber: 343,
              columnNumber: 43
            }, void 0), " · units (identical stacks):", " ", u$1("strong", {
              children: item.units ?? 1
            }, void 0, false, {
              fileName: _jsxFileName$f,
              lineNumber: 344,
              columnNumber: 17
            }, void 0), " · articleNr: ", item.articleNr]
          }, void 0, true, {
            fileName: _jsxFileName$f,
            lineNumber: 342,
            columnNumber: 15
          }, void 0), u$1("div", {
            style: {
              padding: "8px 12px",
              borderRadius: "4px",
              marginBottom: "12px",
              fontWeight: 700,
              background: !product ? "#ffdddd" : !variant ? "#fff3cd" : "#d4edda"
            },
            children: !product ? "❌ NO SHOPIFY PRODUCT — no product has metafield roomle.room_builder_connection === componentId above" : !variant ? "⚠️ PRODUCT MATCHED but NO VARIANT resolved — parameter values below don't narrow to a single variant" : `✅ WILL ADD variant: ${variant.title} (${variant.id})`
          }, void 0, false, {
            fileName: _jsxFileName$f,
            lineNumber: 348,
            columnNumber: 15
          }, void 0), u$1("div", {
            style: {
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px"
            },
            children: [u$1("div", {
              children: [u$1("h4", {
                children: "Roomle parameters"
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 367,
                columnNumber: 19
              }, void 0), u$1("table", {
                style: {
                  borderCollapse: "collapse",
                  width: "100%"
                },
                children: [u$1("thead", {
                  children: u$1("tr", {
                    children: [u$1("th", {
                      style: th$1,
                      children: "key"
                    }, void 0, false, {
                      fileName: _jsxFileName$f,
                      lineNumber: 371,
                      columnNumber: 25
                    }, void 0), u$1("th", {
                      style: th$1,
                      children: "value"
                    }, void 0, false, {
                      fileName: _jsxFileName$f,
                      lineNumber: 372,
                      columnNumber: 25
                    }, void 0), u$1("th", {
                      style: th$1,
                      children: "valueLabel"
                    }, void 0, false, {
                      fileName: _jsxFileName$f,
                      lineNumber: 373,
                      columnNumber: 25
                    }, void 0)]
                  }, void 0, true, {
                    fileName: _jsxFileName$f,
                    lineNumber: 370,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 369,
                  columnNumber: 21
                }, void 0), u$1("tbody", {
                  children: item.parameters.map((p2, j2) => u$1("tr", {
                    children: [u$1("td", {
                      style: {
                        ...cell$1,
                        ...mono$1
                      },
                      children: p2.key
                    }, void 0, false, {
                      fileName: _jsxFileName$f,
                      lineNumber: 379,
                      columnNumber: 27
                    }, void 0), u$1("td", {
                      style: {
                        ...cell$1,
                        ...mono$1
                      },
                      children: p2.value
                    }, void 0, false, {
                      fileName: _jsxFileName$f,
                      lineNumber: 380,
                      columnNumber: 27
                    }, void 0), u$1("td", {
                      style: cell$1,
                      children: p2.valueLabel
                    }, void 0, false, {
                      fileName: _jsxFileName$f,
                      lineNumber: 381,
                      columnNumber: 27
                    }, void 0)]
                  }, j2, true, {
                    fileName: _jsxFileName$f,
                    lineNumber: 378,
                    columnNumber: 25
                  }, void 0))
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 376,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$f,
                lineNumber: 368,
                columnNumber: 19
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$f,
              lineNumber: 366,
              columnNumber: 17
            }, void 0), u$1("div", {
              children: [u$1("h4", {
                children: "Shopify product options"
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 390,
                columnNumber: 19
              }, void 0), !product ? u$1("p", {
                style: {
                  ...mono$1
                },
                children: ["No product matched. Set a product's roomle.room_builder_connection metafield to either ", u$1("strong", {
                  children: item.catalogItemId ?? "(no catalogItemId)"
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 392,
                  columnNumber: 131
                }, void 0), " (preferred) or ", u$1("strong", {
                  children: item.componentId
                }, void 0, false, {
                  fileName: _jsxFileName$f,
                  lineNumber: 392,
                  columnNumber: 208
                }, void 0), "."]
              }, void 0, true, {
                fileName: _jsxFileName$f,
                lineNumber: 392,
                columnNumber: 21
              }, void 0) : u$1(k$1, {
                children: [u$1("p", {
                  style: {
                    ...mono$1
                  },
                  children: ["product: ", product.id]
                }, void 0, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 395,
                  columnNumber: 23
                }, void 0), u$1("table", {
                  style: {
                    borderCollapse: "collapse",
                    width: "100%"
                  },
                  children: [u$1("thead", {
                    children: u$1("tr", {
                      children: [u$1("th", {
                        style: th$1,
                        children: "option name"
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 399,
                        columnNumber: 29
                      }, void 0), u$1("th", {
                        style: th$1,
                        children: "values"
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 400,
                        columnNumber: 29
                      }, void 0)]
                    }, void 0, true, {
                      fileName: _jsxFileName$f,
                      lineNumber: 398,
                      columnNumber: 27
                    }, void 0)
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 397,
                    columnNumber: 25
                  }, void 0), u$1("tbody", {
                    children: product.options.map((o2, j2) => u$1("tr", {
                      children: [u$1("td", {
                        style: {
                          ...cell$1,
                          ...mono$1
                        },
                        children: o2.name
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 406,
                        columnNumber: 31
                      }, void 0), u$1("td", {
                        style: cell$1,
                        children: o2.values.join(", ")
                      }, void 0, false, {
                        fileName: _jsxFileName$f,
                        lineNumber: 407,
                        columnNumber: 31
                      }, void 0)]
                    }, j2, true, {
                      fileName: _jsxFileName$f,
                      lineNumber: 405,
                      columnNumber: 29
                    }, void 0))
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 403,
                    columnNumber: 25
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 396,
                  columnNumber: 23
                }, void 0)]
              }, void 0, true)]
            }, void 0, true, {
              fileName: _jsxFileName$f,
              lineNumber: 389,
              columnNumber: 17
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$f,
            lineNumber: 364,
            columnNumber: 15
          }, void 0), product && u$1("div", {
            style: {
              marginTop: "16px"
            },
            children: [u$1("h4", {
              children: ["Variants (", variants.length, ")", variant ? ` — matched: ${variant.title}` : ""]
            }, void 0, true, {
              fileName: _jsxFileName$f,
              lineNumber: 420,
              columnNumber: 19
            }, void 0), u$1("table", {
              style: {
                borderCollapse: "collapse",
                width: "100%"
              },
              children: [u$1("thead", {
                children: u$1("tr", {
                  children: [u$1("th", {
                    style: th$1,
                    children: "title"
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 424,
                    columnNumber: 25
                  }, void 0), u$1("th", {
                    style: th$1,
                    children: "selectedOptions (name = value)"
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 425,
                    columnNumber: 25
                  }, void 0), u$1("th", {
                    style: th$1,
                    children: "match?"
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 426,
                    columnNumber: 25
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 423,
                  columnNumber: 23
                }, void 0)
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 422,
                columnNumber: 21
              }, void 0), u$1("tbody", {
                children: variants.map((v2, j2) => u$1("tr", {
                  style: v2.id === (variant == null ? void 0 : variant.id) ? {
                    background: "#d4edda"
                  } : void 0,
                  children: [u$1("td", {
                    style: cell$1,
                    children: v2.title
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 432,
                    columnNumber: 27
                  }, void 0), u$1("td", {
                    style: {
                      ...cell$1,
                      ...mono$1
                    },
                    children: v2.selectedOptions.map((o2) => `${o2.name} = ${o2.value}`).join("  |  ")
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 433,
                    columnNumber: 27
                  }, void 0), u$1("td", {
                    style: cell$1,
                    children: v2.id === (variant == null ? void 0 : variant.id) ? "✅" : ""
                  }, void 0, false, {
                    fileName: _jsxFileName$f,
                    lineNumber: 436,
                    columnNumber: 27
                  }, void 0)]
                }, j2, true, {
                  fileName: _jsxFileName$f,
                  lineNumber: 431,
                  columnNumber: 25
                }, void 0))
              }, void 0, false, {
                fileName: _jsxFileName$f,
                lineNumber: 429,
                columnNumber: 21
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$f,
              lineNumber: 421,
              columnNumber: 19
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$f,
            lineNumber: 419,
            columnNumber: 17
          }, void 0), product && u$1("div", {
            style: {
              marginTop: "16px"
            },
            children: [u$1("h4", {
              children: "Line item properties that would be attached"
            }, void 0, false, {
              fileName: _jsxFileName$f,
              lineNumber: 447,
              columnNumber: 19
            }, void 0), u$1("pre", {
              style: {
                ...mono$1,
                background: "#f7f7f7",
                padding: "8px",
                overflow: "auto"
              },
              children: JSON.stringify(properties, null, 2)
            }, void 0, false, {
              fileName: _jsxFileName$f,
              lineNumber: 448,
              columnNumber: 19
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$f,
            lineNumber: 446,
            columnNumber: 17
          }, void 0), u$1("details", {
            style: {
              marginTop: "16px"
            },
            children: [u$1("summary", {
              style: {
                cursor: "pointer"
              },
              children: "Raw roomle item JSON"
            }, void 0, false, {
              fileName: _jsxFileName$f,
              lineNumber: 456,
              columnNumber: 17
            }, void 0), u$1("pre", {
              style: {
                ...mono$1,
                background: "#f7f7f7",
                padding: "8px",
                overflow: "auto"
              },
              children: JSON.stringify(item, null, 2)
            }, void 0, false, {
              fileName: _jsxFileName$f,
              lineNumber: 457,
              columnNumber: 17
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$f,
            lineNumber: 455,
            columnNumber: 15
          }, void 0)]
        }, i2, true, {
          fileName: _jsxFileName$f,
          lineNumber: 332,
          columnNumber: 13
        }, void 0);
      })]
    }, void 0, true, {
      fileName: _jsxFileName$f,
      lineNumber: 125,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName$f,
    lineNumber: 113,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$e = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/Roomle/RoomleRoomConfigurator/RoomleRoomConfigurator.tsx";
const RoomleRoomConfigurator = ({
  roomleId,
  savePageUrl,
  requireDesignUrlParam
}) => {
  const designParam = new URLSearchParams(window.location.search).get("design");
  const requiresDesign = requireDesignUrlParam === "true";
  if (requiresDesign && !designParam) return null;
  const [configurator, setConfigurator] = t$3(d(null), "configurator");
  const [totalPriceCents, setTotalPriceCents] = t$3(d(0), "totalPriceCents");
  const createPlanner = async () => {
    const configuratorId = "gikacoustics";
    const domElement = document.getElementById("configurator-container");
    const designParam2 = new URLSearchParams(window.location.search).get("design");
    const idToLoad = designParam2 || roomleId;
    const options = {
      moc: true,
      catalogRootTag: ["gik_root", "moc_mockup_furniture"],
      buttons: {
        requestplan: false,
        savedraft: false
      },
      state: {
        mode: "room"
      },
      id: idToLoad
    };
    try {
      const roomlePlanner = await u.createPlanner(configuratorId, domElement, options);
      setConfigurator(roomlePlanner);
      prefetchAllProducts();
    } catch (error) {
      console.error("Failed to create Roomle planner:", error);
    }
  };
  y(() => {
    createPlanner();
  }, []);
  const getOverview = async () => {
    if (!(configurator == null ? void 0 : configurator.extended)) return null;
    try {
      return await configurator.extended.getPlanOverview();
    } catch (e2) {
      console.error("Error getting plan overview:", e2);
      return null;
    }
  };
  const getCartItemsFromOverview = (overview) => {
    var _a;
    if (!(overview == null ? void 0 : overview.objects)) return [];
    const cartItems = [];
    for (const obj of overview.objects) {
      const objParamsArray = obj.parameters || [];
      const hasStackHeight = objParamsArray.some((p2) => p2.key === "stackHeight");
      if (hasStackHeight) {
        const stackHeightParam = objParamsArray.find((p2) => p2.key === "stackHeight");
        const stackHeight = parseInt((stackHeightParam == null ? void 0 : stackHeightParam.value) ?? "1", 10);
        let componentId = obj.catalogItemId || "";
        if (!componentId && obj.configuration) {
          try {
            const config = typeof obj.configuration === "string" ? JSON.parse(obj.configuration) : obj.configuration;
            componentId = config.componentId || "";
          } catch (_2) {
          }
        }
        if (!componentId) continue;
        const parameters = objParamsArray.map((p2) => ({
          key: p2.key,
          label: p2.key,
          value: p2.value,
          valueLabel: p2.valueLabel || p2.value
        }));
        cartItems.push({
          articleNr: "",
          label: componentId,
          count: stackHeight,
          componentId,
          catalogItemId: obj.catalogItemId ?? void 0,
          parameters,
          price: 0
        });
        continue;
      }
      const perMainComponent = ((_a = obj.parts) == null ? void 0 : _a.perMainComponent) || [];
      const perObjectGroups = {};
      for (const mainComp of perMainComponent) {
        const origin = mainComp.originPart;
        if (!origin || !origin.componentId || !origin.hasGeometry) continue;
        const paramKey = (origin.parameters || []).map((p2) => `${p2.key}:${p2.value}`).sort().join("|");
        const groupKey = `${origin.componentId}__${paramKey}`;
        if (perObjectGroups[groupKey]) {
          perObjectGroups[groupKey].count += origin.count || 1;
        } else {
          perObjectGroups[groupKey] = {
            articleNr: origin.articleNr,
            label: origin.label,
            count: origin.count || 1,
            componentId: origin.componentId,
            // The placed object's catalogItemId is the identity the merchant
            // wires the Shopify metafield to; carry it for product matching.
            catalogItemId: obj.catalogItemId,
            parameters: origin.parameters || [],
            price: origin.price || 0
          };
        }
      }
      cartItems.push(...Object.values(perObjectGroups));
    }
    const aggregatedItems = cartItems.reduce((acc, item) => {
      const paramKey = item.parameters.map((p2) => `${p2.key}:${p2.value}`).sort().join("|");
      const key = `${item.componentId}__${paramKey}__${item.count}`;
      if (acc[key]) {
        acc[key].units += 1;
      } else {
        acc[key] = {
          ...item,
          units: 1
        };
      }
      return acc;
    }, {});
    return Object.values(aggregatedItems);
  };
  const recomputeTotal = async () => {
    var _a;
    const overview = await getOverview();
    if (!overview) return false;
    const roomleItems = getCartItemsFromOverview(overview);
    const catalogItemIds = getCatalogItemIdsFromOverviewSync(overview);
    const [shopifyProducts] = await Promise.all([findProductsByCatalogItemIds(catalogItemIds), ensureMetaobjectsReady()]);
    let totalCents = 0;
    for (const roomleItem of roomleItems) {
      const product = findProductForRoomleItem(roomleItem, shopifyProducts);
      if (!product) continue;
      const variant = findVariantToAdd(product, roomleItem);
      const priceAmount = parseFloat(((_a = variant == null ? void 0 : variant.price) == null ? void 0 : _a.amount) ?? "0");
      const units = roomleItem.units || 1;
      totalCents += Math.round(priceAmount * 100) * units;
    }
    setTotalPriceCents(totalCents);
    return true;
  };
  y(() => {
    var _a;
    if (!((_a = configurator == null ? void 0 : configurator.ui) == null ? void 0 : _a.callbacks)) return;
    let debounceTimer = null;
    const scheduleRecompute = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(recomputeTotal, 500);
    };
    configurator.ui.callbacks.onPlanElementAdded = scheduleRecompute;
    configurator.ui.callbacks.onPlanElementRemoved = scheduleRecompute;
    configurator.ui.callbacks.onPlanElementChanged = scheduleRecompute;
    configurator.ui.callbacks.onPartListUpdate = scheduleRecompute;
    let attempts = 0;
    const tryInitialCompute = () => {
      recomputeTotal().then((ok) => {
        if (!ok && attempts < 8) {
          attempts++;
          setTimeout(tryInitialCompute, 750);
        }
      });
    };
    tryInitialCompute();
  }, [configurator]);
  const [isSavingPlan, setIsSavingPlan] = t$3(d(false), "isSavingPlan");
  const [savedPlanUrl, setSavedPlanUrl] = t$3(d(null), "savedPlanUrl");
  const [isSaveModalOpen, setIsSaveModalOpen] = t$3(d(false), "isSaveModalOpen");
  const triggerSavePlan = async () => {
    if (!configurator || isSavingPlan) return;
    setIsSavingPlan(true);
    try {
      configurator.ui.callbacks.onSaveDraft = (id, _image, _url, _data) => {
        const base = savePageUrl ? `${window.location.origin}${savePageUrl}` : window.location.href;
        const pageUrl = new URL(base);
        pageUrl.searchParams.set("design", id);
        const shareableUrl = pageUrl.toString();
        window.history.replaceState({}, "", shareableUrl);
        setSavedPlanUrl(shareableUrl);
        setIsSavingPlan(false);
        setIsSaveModalOpen(true);
      };
      await configurator.ui.triggerSaveDraft();
    } catch (e2) {
      console.error("Error saving plan:", e2);
      setIsSavingPlan(false);
    }
  };
  const [isAddingToCart, setIsAddingToCart] = t$3(d(false), "isAddingToCart");
  const debugEnabled = new URLSearchParams(window.location.search).get("roomleDebug") === "true";
  const [debugState, setDebugState] = t$3(d({
    isOpen: false,
    roomleItems: [],
    shopifyProducts: [],
    overview: null
  }), "debugState");
  const runDebug = async () => {
    const overview = await getOverview();
    if (!overview) {
      setDebugState({
        isOpen: true,
        roomleItems: [],
        shopifyProducts: [],
        overview: null
      });
      return;
    }
    const roomleItems = getCartItemsFromOverview(overview);
    const catalogItemIds = getCatalogItemIdsFromOverviewSync(overview);
    const [shopifyProducts] = await Promise.all([findProductsByCatalogItemIds(catalogItemIds), ensureMetaobjectsReady()]);
    setDebugState({
      isOpen: true,
      roomleItems,
      shopifyProducts,
      overview
    });
  };
  const triggerAddToCart = async () => {
    var _a;
    if (!configurator || isAddingToCart) return;
    setIsAddingToCart(true);
    const onSettled = () => {
      document.removeEventListener("roomle:cart:settled", onSettled);
      setIsAddingToCart(false);
    };
    document.addEventListener("roomle:cart:settled", onSettled);
    try {
      const overview = await getOverview();
      if (!overview) {
        onSettled();
        return;
      }
      const roomleItems = getCartItemsFromOverview(overview);
      const catalogItemIds = getCatalogItemIdsFromOverviewSync(overview);
      const shopifyProducts = await findProductsByCatalogItemIds(catalogItemIds);
      const event = new CustomEvent("roomle:addtocart", {
        bubbles: true,
        detail: {
          roomleItems,
          shopifyProducts,
          planId: ((_a = configurator.extended) == null ? void 0 : _a.saveCurrentPlanSnapshot) ? await configurator.extended.saveCurrentPlanSnapshot().then((r2) => typeof r2 === "string" ? r2 : (r2 == null ? void 0 : r2.id) ?? (r2 == null ? void 0 : r2.hash) ?? (r2 == null ? void 0 : r2.planId) ?? null).catch(() => null) : new URLSearchParams(window.location.search).get("design")
        }
      });
      const container = document.getElementById("configurator-container");
      if (container) {
        container.dispatchEvent(event);
      } else {
        onSettled();
      }
    } catch (e2) {
      console.error("Error adding to cart:", e2);
      onSettled();
    }
  };
  return u$1(k$1, {
    children: [u$1(RoomleRoomButtons, {
      isAddingToCart,
      isSavingPlan,
      totalPriceCents,
      onAddToCart: triggerAddToCart,
      onSavePlan: triggerSavePlan
    }, void 0, false, {
      fileName: _jsxFileName$e,
      lineNumber: 367,
      columnNumber: 7
    }, void 0), u$1(RoomleSaveModal, {
      isOpen: isSaveModalOpen,
      url: savedPlanUrl,
      onClose: () => setIsSaveModalOpen(false)
    }, void 0, false, {
      fileName: _jsxFileName$e,
      lineNumber: 374,
      columnNumber: 7
    }, void 0), debugEnabled && $(u$1(k$1, {
      children: [u$1("button", {
        type: "button",
        onClick: runDebug,
        style: {
          position: "fixed",
          bottom: "16px",
          right: "16px",
          zIndex: 99998,
          padding: "6px 12px",
          background: debugState.isOpen ? "#b00" : "#333",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: configurator ? "pointer" : "not-allowed",
          fontWeight: 700,
          fontSize: "12px",
          opacity: configurator ? 1 : 0.5
        },
        disabled: !configurator,
        title: configurator ? "Compile current room state" : "Waiting for Roomle to load…",
        children: debugState.isOpen ? "↺ Refresh debug" : "🔍 Debug"
      }, void 0, false, {
        fileName: _jsxFileName$e,
        lineNumber: 381,
        columnNumber: 11
      }, void 0), u$1(RoomleDebugPanel, {
        isOpen: debugState.isOpen,
        onClose: () => setDebugState((prev) => ({
          ...prev,
          isOpen: false
        })),
        roomleItems: debugState.roomleItems,
        shopifyProducts: debugState.shopifyProducts,
        overview: debugState.overview,
        configurator
      }, void 0, false, {
        fileName: _jsxFileName$e,
        lineNumber: 404,
        columnNumber: 11
      }, void 0)]
    }, void 0, true), document.body)]
  }, void 0);
};
register(RoomleRoomConfigurator, "roomle-room-configurator", ["roomle-id", "save-page-url", "require-design-url-param"]);
var _jsxFileName$d = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/ComparisonTool/ComparisonSearch.tsx";
const ComparisonSearch = ({
  searchTerm,
  onSearchChange,
  onDebouncedSearchChange,
  placeholder = "Search Table",
  debounceMs = 1500
}) => {
  const [localSearchTerm, setLocalSearchTerm] = t$3(d(searchTerm), "localSearchTerm");
  const [isSearching, setIsSearching] = t$3(d(false), "isSearching");
  const timeoutRef = t$3(A$1(null), "timeoutRef");
  y(() => {
    setLocalSearchTerm(searchTerm);
  }, [searchTerm]);
  y(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsSearching(localSearchTerm.length > 0);
    onSearchChange(localSearchTerm);
    timeoutRef.current = setTimeout(() => {
      setIsSearching(false);
      onDebouncedSearchChange(localSearchTerm);
      timeoutRef.current = null;
    }, debounceMs);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [localSearchTerm, debounceMs, onSearchChange, onDebouncedSearchChange]);
  const handleInputChange = (e2) => {
    const value = e2.target.value;
    setLocalSearchTerm(value);
  };
  return u$1("div", {
    className: "comparison-chart__search-container",
    children: [u$1("input", {
      type: "text",
      placeholder,
      value: localSearchTerm,
      onInput: handleInputChange,
      className: "comparison-chart__search-input"
    }, void 0, false, {
      fileName: _jsxFileName$d,
      lineNumber: 62,
      columnNumber: 7
    }, void 0), isSearching && u$1("div", {
      className: "comparison-chart__search-loading",
      children: u$1("svg", {
        className: "comparison-chart__search-loading-icon",
        viewBox: "0 0 24 24",
        children: u$1("circle", {
          className: "comparison-chart__search-loading-circle",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          strokeWidth: "4",
          fill: "none"
        }, void 0, false, {
          fileName: _jsxFileName$d,
          lineNumber: 72,
          columnNumber: 13
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$d,
        lineNumber: 71,
        columnNumber: 11
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$d,
      lineNumber: 70,
      columnNumber: 9
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$d,
    lineNumber: 61,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$c = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/ComparisonTool/ComparisonMobileFilters.tsx";
const ComparisonMobileFilters = ({
  selectedFilters,
  onFiltersChange,
  parsedMetaobjects,
  productData,
  getProductName: getProductName2,
  onClearFilters
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = t$3(d(false), "isDrawerOpen");
  const [isAnimating, setIsAnimating] = t$3(d(false), "isAnimating");
  const [isCompareDropdownOpen, setIsCompareDropdownOpen] = t$3(d(false), "isCompareDropdownOpen");
  const [isEffectiveRangeDropdownOpen, setIsEffectiveRangeDropdownOpen] = t$3(d(false), "isEffectiveRangeDropdownOpen");
  const [isThicknessDropdownOpen, setIsThicknessDropdownOpen] = t$3(d(false), "isThicknessDropdownOpen");
  const [mousePosition, setMousePosition] = t$3(d({
    x: -9999,
    y: -9999
  }), "mousePosition");
  const [showCustomCursor, setShowCustomCursor] = t$3(d(false), "showCustomCursor");
  const [cursorExpanded, setCursorExpanded] = t$3(d(false), "cursorExpanded");
  t$3(A$1(null), "drawerRef");
  const dropdownRef = t$3(A$1(null), "dropdownRef");
  const effectiveRangeDropdownRef = t$3(A$1(null), "effectiveRangeDropdownRef");
  const thicknessDropdownRef = t$3(A$1(null), "thicknessDropdownRef");
  y(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsCompareDropdownOpen(false);
      }
      if (effectiveRangeDropdownRef.current && !effectiveRangeDropdownRef.current.contains(event.target)) {
        setIsEffectiveRangeDropdownOpen(false);
      }
      if (thicknessDropdownRef.current && !thicknessDropdownRef.current.contains(event.target)) {
        setIsThicknessDropdownOpen(false);
      }
    };
    if (isCompareDropdownOpen || isEffectiveRangeDropdownOpen || isThicknessDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isCompareDropdownOpen, isEffectiveRangeDropdownOpen, isThicknessDropdownOpen]);
  y(() => {
    if (isDrawerOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isDrawerOpen]);
  y(() => {
    let animationFrameId;
    const handleMouseMove = (e2) => {
      if (!showCustomCursor) return;
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      animationFrameId = requestAnimationFrame(() => {
        setMousePosition({
          x: e2.clientX,
          y: e2.clientY
        });
      });
    };
    if (isDrawerOpen && showCustomCursor) {
      document.addEventListener("mousemove", handleMouseMove, {
        passive: true
      });
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }
      };
    }
  }, [isDrawerOpen, showCustomCursor]);
  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
    setShowCustomCursor(false);
    setCursorExpanded(false);
    setTimeout(() => setIsAnimating(true), 10);
  };
  const handleCloseDrawer = () => {
    setIsAnimating(false);
    setShowCustomCursor(false);
    setCursorExpanded(false);
    setMousePosition({
      x: -9999,
      y: -9999
    });
    setTimeout(() => setIsDrawerOpen(false), 300);
  };
  const handleMouseEnterOverlay = (e2) => {
    setMousePosition({
      x: e2.clientX,
      y: e2.clientY
    });
    setShowCustomCursor(true);
    setTimeout(() => setCursorExpanded(true), 10);
  };
  const handleMouseLeaveOverlay = () => {
    setCursorExpanded(false);
    setTimeout(() => {
      setShowCustomCursor(false);
      setMousePosition({
        x: -9999,
        y: -9999
      });
    }, 200);
  };
  const getUniqueValues2 = () => {
    if (!Array.isArray(parsedMetaobjects) || parsedMetaobjects.length === 0) {
      return {
        frequencies: [],
        thicknesses: [],
        productTitles: []
      };
    }
    const frequencies2 = Array.from(new Set(parsedMetaobjects.map((item) => item.lowest_frequency).filter((freq) => freq && freq !== "N/A").map((freq) => String(freq).trim()))).sort((a2, b2) => {
      const numA = parseInt(String(a2).replace(/[^\d]/g, "")) || 0;
      const numB = parseInt(String(b2).replace(/[^\d]/g, "")) || 0;
      return numA - numB;
    });
    const thicknesses2 = Array.from(new Set(parsedMetaobjects.map((item) => item.thickness).filter((thickness) => thickness && thickness !== "N/A").map((thickness) => String(thickness).trim()))).sort((a2, b2) => {
      const numA = parseFloat(String(a2).replace(/[^\d.]/g, "")) || 0;
      const numB = parseFloat(String(b2).replace(/[^\d.]/g, "")) || 0;
      return numA - numB;
    });
    const productTitles2 = Array.from(new Set(parsedMetaobjects.map((item, index) => getProductName2(item.product, index)).filter((title) => title && title !== "N/A"))).sort();
    return {
      frequencies: frequencies2,
      thicknesses: thicknesses2,
      productTitles: productTitles2
    };
  };
  const {
    frequencies,
    thicknesses,
    productTitles
  } = getUniqueValues2();
  const handleFilterChange = (filterType, value) => {
    if (filterType === "selectedProducts") {
      const currentSelected = selectedFilters.selectedProducts;
      const newSelected = currentSelected.includes(value) ? currentSelected.filter((item) => item !== value) : [...currentSelected, value];
      onFiltersChange({
        ...selectedFilters,
        selectedProducts: newSelected
      });
    } else {
      onFiltersChange({
        ...selectedFilters,
        [filterType]: value
      });
    }
  };
  const handleProductToggle = (productTitle) => {
    handleFilterChange("selectedProducts", productTitle);
  };
  const handleEffectiveRangeSelect = (frequency) => {
    handleFilterChange("effectiveRange", frequency);
    setIsEffectiveRangeDropdownOpen(false);
  };
  const handleThicknessSelect = (thickness) => {
    handleFilterChange("thickness", thickness);
    setIsThicknessDropdownOpen(false);
  };
  const handleApplyFilters = () => {
    setIsCompareDropdownOpen(false);
    handleCloseDrawer();
  };
  const handleClearFilters = () => {
    setIsCompareDropdownOpen(false);
    onClearFilters();
  };
  const getTotalFilterCount = () => {
    let count = 0;
    if (selectedFilters.selectedProducts.length > 0) count++;
    if (selectedFilters.effectiveRange) count++;
    if (selectedFilters.thickness) count++;
    return count;
  };
  return u$1(k$1, {
    children: [u$1("div", {
      className: "comparison-chart__mobile-filter-wrapper",
      children: u$1("button", {
        className: "comparison-chart__mobile-filter-button",
        type: "button",
        onClick: handleOpenDrawer,
        "aria-controls": "ComparisonDrawer",
        "aria-expanded": isDrawerOpen,
        "aria-label": "Open filters",
        children: u$1("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 32 24",
          fill: "none",
          children: u$1("path", {
            d: "M22.5625 12.75C22.5625 12.8992 22.5032 13.0423 22.3977 13.1477C22.2923 13.2532 22.1492 13.3125 22 13.3125H10C9.85082 13.3125 9.70774 13.2532 9.60225 13.1477C9.49676 13.0423 9.4375 12.8992 9.4375 12.75C9.4375 12.6008 9.49676 12.4577 9.60225 12.3523C9.70774 12.2468 9.85082 12.1875 10 12.1875H22C22.1492 12.1875 22.2923 12.2468 22.3977 12.3523C22.5032 12.4577 22.5625 12.6008 22.5625 12.75ZM25.75 7.6875H6.25C6.10082 7.6875 5.95774 7.74676 5.85225 7.85225C5.74676 7.95774 5.6875 8.10082 5.6875 8.25C5.6875 8.39918 5.74676 8.54226 5.85225 8.64775C5.95774 8.75324 6.10082 8.8125 6.25 8.8125H25.75C25.8992 8.8125 26.0423 8.75324 26.1477 8.64775C26.2532 8.54226 26.3125 8.39918 26.3125 8.25C26.3125 8.10082 26.2532 7.95774 26.1477 7.85225C26.0423 7.74676 25.8992 7.6875 25.75 7.6875ZM18.25 16.6875H13.75C13.6008 16.6875 13.4577 16.7468 13.3523 16.8523C13.2468 16.9577 13.1875 17.1008 13.1875 17.25C13.1875 17.3992 13.2468 17.5423 13.3523 17.6477C13.4577 17.7532 13.6008 17.8125 13.75 17.8125H18.25C18.3992 17.8125 18.5423 17.7532 18.6477 17.6477C18.7532 17.5423 18.8125 17.3992 18.8125 17.25C18.8125 17.1008 18.7532 16.9577 18.6477 16.8523C18.5423 16.7468 18.3992 16.6875 18.25 16.6875Z",
            fill: "#187380"
          }, void 0, false, {
            fileName: _jsxFileName$c,
            lineNumber: 262,
            columnNumber: 1
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$c,
          lineNumber: 261,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$c,
        lineNumber: 253,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$c,
      lineNumber: 252,
      columnNumber: 7
    }, void 0), isDrawerOpen && u$1("div", {
      className: "comparison-chart__mobile-drawer-element",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Filter comparison",
      id: "ComparisonDrawer",
      children: [showCustomCursor && u$1("div", {
        className: `mouse-cursor z-50 fixed select-none flex items-center justify-center pointer-events-none rounded-full ${cursorExpanded ? "mouse-cursor--expanded" : "mouse-cursor--contracted"}`,
        style: {
          left: mousePosition.x,
          top: mousePosition.y
        },
        children: u$1("svg", {
          className: "icon icon-cursor",
          stroke: "currentColor",
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: u$1("path", {
            d: "M10 30L30 10M10 10L30 30",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }, void 0, false, {
            fileName: _jsxFileName$c,
            lineNumber: 292,
            columnNumber: 17
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$c,
          lineNumber: 285,
          columnNumber: 15
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$c,
        lineNumber: 278,
        columnNumber: 13
      }, void 0), u$1("div", {
        className: `overlay ${isAnimating ? "overlay--visible" : "overlay--hidden"}`,
        onClick: handleCloseDrawer,
        onMouseEnter: handleMouseEnterOverlay,
        onMouseLeave: handleMouseLeaveOverlay
      }, void 0, false, {
        fileName: _jsxFileName$c,
        lineNumber: 303,
        columnNumber: 11
      }, void 0), u$1("div", {
        className: `drawer__inner flex flex-col overflow-hidden ${isAnimating ? "drawer__inner--visible" : "drawer__inner--hidden"}`,
        children: [u$1("div", {
          className: "drawer__header flex justify-between items-center",
          children: [u$1("span", {
            className: "drawer__title",
            children: "Filter By"
          }, void 0, false, {
            fileName: _jsxFileName$c,
            lineNumber: 317,
            columnNumber: 15
          }, void 0), u$1("div", {
            className: "flex items-center gap-4",
            children: [getTotalFilterCount() > 0 && u$1("button", {
              className: "comparison-chart__header-clear-button",
              type: "button",
              onClick: handleClearFilters,
              children: "Clear"
            }, void 0, false, {
              fileName: _jsxFileName$c,
              lineNumber: 320,
              columnNumber: 19
            }, void 0), u$1("button", {
              className: "button button--secondary button--close drawer__close hidden sm:flex items-center justify-center",
              type: "button",
              onClick: handleCloseDrawer,
              "aria-controls": "ComparisonDrawer",
              "aria-expanded": isDrawerOpen,
              "aria-label": "Close",
              children: [u$1("span", {
                className: "btn-fill",
                "data-fill": true
              }, void 0, false, {
                fileName: _jsxFileName$c,
                lineNumber: 336,
                columnNumber: 19
              }, void 0), u$1("span", {
                className: "btn-text",
                children: u$1("svg", {
                  className: "icon icon-close icon-sm",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 20 20",
                  children: u$1("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M5 15L15 5M5 5L15 15"
                  }, void 0, false, {
                    fileName: _jsxFileName$c,
                    lineNumber: 344,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 338,
                  columnNumber: 21
                }, void 0)
              }, void 0, false, {
                fileName: _jsxFileName$c,
                lineNumber: 337,
                columnNumber: 19
              }, void 0), u$1("span", {
                className: "btn-loader",
                children: [u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 348,
                  columnNumber: 21
                }, void 0), u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 349,
                  columnNumber: 21
                }, void 0), u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 350,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$c,
                lineNumber: 347,
                columnNumber: 19
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$c,
              lineNumber: 328,
              columnNumber: 17
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$c,
            lineNumber: 318,
            columnNumber: 15
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$c,
          lineNumber: 316,
          columnNumber: 13
        }, void 0), u$1("div", {
          className: "drawer__content flex flex-col",
          children: [u$1("div", {
            className: "drawer__scrollable",
            children: [u$1("div", {
              className: "comparison-chart__mobile-filter-group",
              children: u$1("div", {
                className: "details",
                children: [u$1("div", {
                  className: "details__summary flex items-center justify-between gap-2",
                  children: u$1("span", {
                    className: "text-base-xl font-medium",
                    children: "Compare Products"
                  }, void 0, false, {
                    fileName: _jsxFileName$c,
                    lineNumber: 364,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 363,
                  columnNumber: 21
                }, void 0), u$1("div", {
                  className: "details__content",
                  children: u$1("div", {
                    className: "comparison-chart__mobile-multiselect-container",
                    ref: dropdownRef,
                    children: [u$1("button", {
                      className: "comparison-chart__mobile-multiselect-button",
                      onClick: () => setIsCompareDropdownOpen(!isCompareDropdownOpen),
                      children: [u$1("span", {
                        children: selectedFilters.selectedProducts.length === 0 ? "Select Products" : `${selectedFilters.selectedProducts.length} selected`
                      }, void 0, false, {
                        fileName: _jsxFileName$c,
                        lineNumber: 372,
                        columnNumber: 27
                      }, void 0), u$1("svg", {
                        className: `comparison-chart__mobile-dropdown-arrow ${isCompareDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: u$1("path", {
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                          d: "M19 9l-7 7-7-7"
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 384,
                          columnNumber: 29
                        }, void 0)
                      }, void 0, false, {
                        fileName: _jsxFileName$c,
                        lineNumber: 378,
                        columnNumber: 27
                      }, void 0)]
                    }, void 0, true, {
                      fileName: _jsxFileName$c,
                      lineNumber: 368,
                      columnNumber: 25
                    }, void 0), isCompareDropdownOpen && u$1("div", {
                      className: "comparison-chart__mobile-multiselect-dropdown",
                      children: productTitles.map((productTitle) => u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleProductToggle(productTitle),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: productTitle
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 396,
                          columnNumber: 33
                        }, void 0), selectedFilters.selectedProducts.includes(productTitle) && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$c,
                            lineNumber: 404,
                            columnNumber: 37
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 398,
                          columnNumber: 35
                        }, void 0)]
                      }, productTitle, true, {
                        fileName: _jsxFileName$c,
                        lineNumber: 391,
                        columnNumber: 31
                      }, void 0))
                    }, void 0, false, {
                      fileName: _jsxFileName$c,
                      lineNumber: 389,
                      columnNumber: 27
                    }, void 0)]
                  }, void 0, true, {
                    fileName: _jsxFileName$c,
                    lineNumber: 367,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 366,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$c,
                lineNumber: 362,
                columnNumber: 19
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$c,
              lineNumber: 361,
              columnNumber: 17
            }, void 0), u$1("div", {
              className: "comparison-chart__mobile-filter-group",
              children: u$1("div", {
                className: "details",
                children: [u$1("div", {
                  className: "details__summary flex items-center justify-between gap-2",
                  children: u$1("span", {
                    className: "text-base-xl font-medium",
                    children: "Effective Range"
                  }, void 0, false, {
                    fileName: _jsxFileName$c,
                    lineNumber: 420,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 419,
                  columnNumber: 21
                }, void 0), u$1("div", {
                  className: "details__content",
                  children: u$1("div", {
                    className: "comparison-chart__mobile-multiselect-container",
                    ref: effectiveRangeDropdownRef,
                    children: [u$1("button", {
                      className: "comparison-chart__mobile-multiselect-button",
                      onClick: () => setIsEffectiveRangeDropdownOpen(!isEffectiveRangeDropdownOpen),
                      children: [u$1("span", {
                        children: selectedFilters.effectiveRange || "Select Range"
                      }, void 0, false, {
                        fileName: _jsxFileName$c,
                        lineNumber: 428,
                        columnNumber: 27
                      }, void 0), u$1("svg", {
                        className: `comparison-chart__mobile-dropdown-arrow ${isEffectiveRangeDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: u$1("path", {
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                          d: "M19 9l-7 7-7-7"
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 437,
                          columnNumber: 29
                        }, void 0)
                      }, void 0, false, {
                        fileName: _jsxFileName$c,
                        lineNumber: 431,
                        columnNumber: 27
                      }, void 0)]
                    }, void 0, true, {
                      fileName: _jsxFileName$c,
                      lineNumber: 424,
                      columnNumber: 25
                    }, void 0), isEffectiveRangeDropdownOpen && u$1("div", {
                      className: "comparison-chart__mobile-multiselect-dropdown",
                      children: [u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleEffectiveRangeSelect(""),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: "Select Range"
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 447,
                          columnNumber: 31
                        }, void 0), !selectedFilters.effectiveRange && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$c,
                            lineNumber: 455,
                            columnNumber: 35
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 449,
                          columnNumber: 33
                        }, void 0)]
                      }, void 0, true, {
                        fileName: _jsxFileName$c,
                        lineNumber: 443,
                        columnNumber: 29
                      }, void 0), frequencies.map((frequency) => u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleEffectiveRangeSelect(frequency),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: frequency
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 465,
                          columnNumber: 33
                        }, void 0), selectedFilters.effectiveRange === frequency && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$c,
                            lineNumber: 473,
                            columnNumber: 37
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 467,
                          columnNumber: 35
                        }, void 0)]
                      }, frequency, true, {
                        fileName: _jsxFileName$c,
                        lineNumber: 460,
                        columnNumber: 31
                      }, void 0))]
                    }, void 0, true, {
                      fileName: _jsxFileName$c,
                      lineNumber: 442,
                      columnNumber: 27
                    }, void 0)]
                  }, void 0, true, {
                    fileName: _jsxFileName$c,
                    lineNumber: 423,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 422,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$c,
                lineNumber: 418,
                columnNumber: 19
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$c,
              lineNumber: 417,
              columnNumber: 17
            }, void 0), u$1("div", {
              className: "comparison-chart__mobile-filter-group",
              children: u$1("div", {
                className: "details",
                children: [u$1("div", {
                  className: "details__summary flex items-center justify-between gap-2",
                  children: u$1("span", {
                    className: "text-base-xl font-medium",
                    children: "Thickness"
                  }, void 0, false, {
                    fileName: _jsxFileName$c,
                    lineNumber: 489,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 488,
                  columnNumber: 21
                }, void 0), u$1("div", {
                  className: "details__content",
                  children: u$1("div", {
                    className: "comparison-chart__mobile-multiselect-container",
                    ref: thicknessDropdownRef,
                    children: [u$1("button", {
                      className: "comparison-chart__mobile-multiselect-button",
                      onClick: () => setIsThicknessDropdownOpen(!isThicknessDropdownOpen),
                      children: [u$1("span", {
                        children: selectedFilters.thickness || "Select Thickness"
                      }, void 0, false, {
                        fileName: _jsxFileName$c,
                        lineNumber: 497,
                        columnNumber: 27
                      }, void 0), u$1("svg", {
                        className: `comparison-chart__mobile-dropdown-arrow ${isThicknessDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: u$1("path", {
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                          d: "M19 9l-7 7-7-7"
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 506,
                          columnNumber: 29
                        }, void 0)
                      }, void 0, false, {
                        fileName: _jsxFileName$c,
                        lineNumber: 500,
                        columnNumber: 27
                      }, void 0)]
                    }, void 0, true, {
                      fileName: _jsxFileName$c,
                      lineNumber: 493,
                      columnNumber: 25
                    }, void 0), isThicknessDropdownOpen && u$1("div", {
                      className: "comparison-chart__mobile-multiselect-dropdown",
                      children: [u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleThicknessSelect(""),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: "Select Thickness"
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 516,
                          columnNumber: 31
                        }, void 0), !selectedFilters.thickness && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$c,
                            lineNumber: 524,
                            columnNumber: 35
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 518,
                          columnNumber: 33
                        }, void 0)]
                      }, void 0, true, {
                        fileName: _jsxFileName$c,
                        lineNumber: 512,
                        columnNumber: 29
                      }, void 0), thicknesses.map((thickness) => u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleThicknessSelect(thickness),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: thickness
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 534,
                          columnNumber: 33
                        }, void 0), selectedFilters.thickness === thickness && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$c,
                            lineNumber: 542,
                            columnNumber: 37
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$c,
                          lineNumber: 536,
                          columnNumber: 35
                        }, void 0)]
                      }, thickness, true, {
                        fileName: _jsxFileName$c,
                        lineNumber: 529,
                        columnNumber: 31
                      }, void 0))]
                    }, void 0, true, {
                      fileName: _jsxFileName$c,
                      lineNumber: 511,
                      columnNumber: 27
                    }, void 0)]
                  }, void 0, true, {
                    fileName: _jsxFileName$c,
                    lineNumber: 492,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 491,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$c,
                lineNumber: 487,
                columnNumber: 19
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$c,
              lineNumber: 486,
              columnNumber: 17
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$c,
            lineNumber: 358,
            columnNumber: 15
          }, void 0), u$1("div", {
            className: "drawer__sticky",
            children: u$1("button", {
              className: "button button--primary w-full",
              type: "button",
              is: "hover-button",
              onClick: handleApplyFilters,
              "aria-controls": "ComparisonDrawer",
              "aria-expanded": isDrawerOpen,
              children: [u$1("span", {
                className: "btn-fill",
                "data-fill": true
              }, void 0, false, {
                fileName: _jsxFileName$c,
                lineNumber: 565,
                columnNumber: 19
              }, void 0), u$1("span", {
                className: "btn-text flex gap-1",
                children: ["Apply Filters", getTotalFilterCount() > 0 && u$1("span", {
                  className: "comparison-chart__mobile-filter-count block",
                  children: getTotalFilterCount()
                }, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 569,
                  columnNumber: 23
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$c,
                lineNumber: 566,
                columnNumber: 19
              }, void 0), u$1("span", {
                className: "btn-loader",
                children: [u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 575,
                  columnNumber: 21
                }, void 0), u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 576,
                  columnNumber: 21
                }, void 0), u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$c,
                  lineNumber: 577,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$c,
                lineNumber: 574,
                columnNumber: 19
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$c,
              lineNumber: 557,
              columnNumber: 17
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$c,
            lineNumber: 556,
            columnNumber: 15
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$c,
          lineNumber: 357,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$c,
        lineNumber: 311,
        columnNumber: 11
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$c,
      lineNumber: 269,
      columnNumber: 9
    }, void 0)]
  }, void 0);
};
var _jsxFileName$b = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/ComparisonTool/ComparisonFilters.tsx";
const ComparisonFilters = ({
  selectedFilters,
  onFiltersChange,
  parsedMetaobjects,
  productData,
  getProductName: getProductName2,
  onClearFilters
}) => {
  const [isCompareDropdownOpen, setIsCompareDropdownOpen] = t$3(d(false), "isCompareDropdownOpen");
  const [isEffectiveRangeDropdownOpen, setIsEffectiveRangeDropdownOpen] = t$3(d(false), "isEffectiveRangeDropdownOpen");
  const [isThicknessDropdownOpen, setIsThicknessDropdownOpen] = t$3(d(false), "isThicknessDropdownOpen");
  const dropdownRef = t$3(A$1(null), "dropdownRef");
  const effectiveRangeDropdownRef = t$3(A$1(null), "effectiveRangeDropdownRef");
  const thicknessDropdownRef = t$3(A$1(null), "thicknessDropdownRef");
  y(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsCompareDropdownOpen(false);
      }
      if (effectiveRangeDropdownRef.current && !effectiveRangeDropdownRef.current.contains(event.target)) {
        setIsEffectiveRangeDropdownOpen(false);
      }
      if (thicknessDropdownRef.current && !thicknessDropdownRef.current.contains(event.target)) {
        setIsThicknessDropdownOpen(false);
      }
    };
    if (isCompareDropdownOpen || isEffectiveRangeDropdownOpen || isThicknessDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isCompareDropdownOpen, isEffectiveRangeDropdownOpen, isThicknessDropdownOpen]);
  const getUniqueValues2 = () => {
    if (!Array.isArray(parsedMetaobjects) || parsedMetaobjects.length === 0) {
      return {
        frequencies: [],
        thicknesses: [],
        productTitles: []
      };
    }
    const frequencies2 = Array.from(new Set(parsedMetaobjects.map((item) => item.lowest_frequency).filter((freq) => freq && freq !== "N/A").map((freq) => String(freq).trim()))).sort((a2, b2) => {
      const numA = parseInt(String(a2).replace(/[^\d]/g, "")) || 0;
      const numB = parseInt(String(b2).replace(/[^\d]/g, "")) || 0;
      return numA - numB;
    });
    const thicknesses2 = Array.from(new Set(parsedMetaobjects.map((item) => item.thickness).filter((thickness) => thickness && thickness !== "N/A").map((thickness) => String(thickness).trim()))).sort((a2, b2) => {
      const numA = parseFloat(String(a2).replace(/[^\d.]/g, "")) || 0;
      const numB = parseFloat(String(b2).replace(/[^\d.]/g, "")) || 0;
      return numA - numB;
    });
    const productTitles2 = Array.from(new Set(parsedMetaobjects.map((item, index) => getProductName2(item.product, index)).filter((title) => title && title !== "N/A"))).sort();
    return {
      frequencies: frequencies2,
      thicknesses: thicknesses2,
      productTitles: productTitles2
    };
  };
  const {
    frequencies,
    thicknesses,
    productTitles
  } = getUniqueValues2();
  const handleFilterChange = (filterType, value) => {
    if (filterType === "selectedProducts") {
      const currentSelected = selectedFilters.selectedProducts;
      const newSelected = currentSelected.includes(value) ? currentSelected.filter((item) => item !== value) : [...currentSelected, value];
      onFiltersChange({
        ...selectedFilters,
        selectedProducts: newSelected
      });
    } else {
      onFiltersChange({
        ...selectedFilters,
        [filterType]: value
      });
    }
  };
  const handleProductToggle = (productTitle) => {
    handleFilterChange("selectedProducts", productTitle);
  };
  const handleEffectiveRangeSelect = (frequency) => {
    handleFilterChange("effectiveRange", frequency);
    setIsEffectiveRangeDropdownOpen(false);
  };
  const handleThicknessSelect = (thickness) => {
    handleFilterChange("thickness", thickness);
    setIsThicknessDropdownOpen(false);
  };
  const handleClearFilters = () => {
    setIsCompareDropdownOpen(false);
    setIsEffectiveRangeDropdownOpen(false);
    setIsThicknessDropdownOpen(false);
    onClearFilters();
  };
  return u$1("div", {
    className: "comparison-chart__filters",
    children: [u$1("div", {
      className: "comparison-chart__mobile-filters",
      children: u$1(ComparisonMobileFilters, {
        selectedFilters,
        onFiltersChange,
        parsedMetaobjects,
        productData,
        getProductName: getProductName2,
        onClearFilters
      }, void 0, false, {
        fileName: _jsxFileName$b,
        lineNumber: 158,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$b,
      lineNumber: 157,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "comparison-chart__desktop-filters",
      children: [u$1("div", {
        className: "comparison-chart__multiselect-container",
        ref: dropdownRef,
        children: [u$1("button", {
          className: "comparison-chart__multiselect-button",
          onClick: () => setIsCompareDropdownOpen(!isCompareDropdownOpen),
          children: [u$1("span", {
            children: selectedFilters.selectedProducts.length === 0 ? "Compare Products" : `${selectedFilters.selectedProducts.length} selected`
          }, void 0, false, {
            fileName: _jsxFileName$b,
            lineNumber: 176,
            columnNumber: 13
          }, void 0), u$1("svg", {
            className: `comparison-chart__dropdown-arrow ${isCompareDropdownOpen ? "comparison-chart__dropdown-arrow--open" : ""}`,
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M19 9l-7 7-7-7"
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 188,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$b,
            lineNumber: 182,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$b,
          lineNumber: 172,
          columnNumber: 11
        }, void 0), isCompareDropdownOpen && u$1("div", {
          className: "comparison-chart__multiselect-dropdown",
          children: productTitles.map((productTitle) => u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleProductToggle(productTitle),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: productTitle
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 200,
              columnNumber: 19
            }, void 0), selectedFilters.selectedProducts.includes(productTitle) && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$b,
                lineNumber: 208,
                columnNumber: 23
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 202,
              columnNumber: 21
            }, void 0)]
          }, productTitle, true, {
            fileName: _jsxFileName$b,
            lineNumber: 195,
            columnNumber: 17
          }, void 0))
        }, void 0, false, {
          fileName: _jsxFileName$b,
          lineNumber: 193,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$b,
        lineNumber: 171,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__multiselect-container",
        ref: effectiveRangeDropdownRef,
        children: [u$1("button", {
          className: "comparison-chart__multiselect-button",
          onClick: () => setIsEffectiveRangeDropdownOpen(!isEffectiveRangeDropdownOpen),
          children: [u$1("span", {
            children: selectedFilters.effectiveRange || "Effective Range"
          }, void 0, false, {
            fileName: _jsxFileName$b,
            lineNumber: 222,
            columnNumber: 13
          }, void 0), u$1("svg", {
            className: `comparison-chart__dropdown-arrow ${isEffectiveRangeDropdownOpen ? "comparison-chart__dropdown-arrow--open" : ""}`,
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M19 9l-7 7-7-7"
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 231,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$b,
            lineNumber: 225,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$b,
          lineNumber: 218,
          columnNumber: 11
        }, void 0), isEffectiveRangeDropdownOpen && u$1("div", {
          className: "comparison-chart__multiselect-dropdown",
          children: [u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleEffectiveRangeSelect(""),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: "Effective Range"
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 241,
              columnNumber: 17
            }, void 0), !selectedFilters.effectiveRange && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$b,
                lineNumber: 249,
                columnNumber: 21
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 243,
              columnNumber: 19
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$b,
            lineNumber: 237,
            columnNumber: 15
          }, void 0), frequencies.map((frequency) => u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleEffectiveRangeSelect(frequency),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: frequency
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 259,
              columnNumber: 19
            }, void 0), selectedFilters.effectiveRange === frequency && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$b,
                lineNumber: 267,
                columnNumber: 23
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 261,
              columnNumber: 21
            }, void 0)]
          }, frequency, true, {
            fileName: _jsxFileName$b,
            lineNumber: 254,
            columnNumber: 17
          }, void 0))]
        }, void 0, true, {
          fileName: _jsxFileName$b,
          lineNumber: 236,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$b,
        lineNumber: 217,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__multiselect-container",
        ref: thicknessDropdownRef,
        children: [u$1("button", {
          className: "comparison-chart__multiselect-button",
          onClick: () => setIsThicknessDropdownOpen(!isThicknessDropdownOpen),
          children: [u$1("span", {
            children: selectedFilters.thickness || "Thickness"
          }, void 0, false, {
            fileName: _jsxFileName$b,
            lineNumber: 281,
            columnNumber: 13
          }, void 0), u$1("svg", {
            className: `comparison-chart__dropdown-arrow ${isThicknessDropdownOpen ? "comparison-chart__dropdown-arrow--open" : ""}`,
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M19 9l-7 7-7-7"
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 290,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$b,
            lineNumber: 284,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$b,
          lineNumber: 277,
          columnNumber: 11
        }, void 0), isThicknessDropdownOpen && u$1("div", {
          className: "comparison-chart__multiselect-dropdown",
          children: [u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleThicknessSelect(""),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: "Thickness"
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 300,
              columnNumber: 17
            }, void 0), !selectedFilters.thickness && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$b,
                lineNumber: 308,
                columnNumber: 21
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 302,
              columnNumber: 19
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$b,
            lineNumber: 296,
            columnNumber: 15
          }, void 0), thicknesses.map((thickness) => u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleThicknessSelect(thickness),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: thickness
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 318,
              columnNumber: 19
            }, void 0), selectedFilters.thickness === thickness && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$b,
                lineNumber: 326,
                columnNumber: 23
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$b,
              lineNumber: 320,
              columnNumber: 21
            }, void 0)]
          }, thickness, true, {
            fileName: _jsxFileName$b,
            lineNumber: 313,
            columnNumber: 17
          }, void 0))]
        }, void 0, true, {
          fileName: _jsxFileName$b,
          lineNumber: 295,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$b,
        lineNumber: 276,
        columnNumber: 9
      }, void 0), u$1("button", {
        className: "comparison-chart__clear-button",
        onClick: handleClearFilters,
        children: "Clear Filters"
      }, void 0, false, {
        fileName: _jsxFileName$b,
        lineNumber: 335,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$b,
      lineNumber: 169,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$b,
    lineNumber: 155,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$a = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/ComparisonTool/ComparisonActions.tsx";
const ComparisonActions = ({
  onColumnsChange,
  onExport,
  onPrint
}) => {
  const availableColumns = [{
    key: "fire_rated",
    label: "Fire Rated"
  }, {
    key: "absorber",
    label: "Absorber"
  }, {
    key: "thickness",
    label: "Thickness"
  }, {
    key: "lowest_frequency",
    label: "Lowest Frequency"
  }, {
    key: "bass_control",
    label: "Bass Control"
  }, {
    key: "backing_type",
    label: "Backing Type"
  }, {
    key: "custom_sizes",
    label: "Custom Sizes"
  }, {
    key: "diffuser",
    label: "Diffuser"
  }, {
    key: "fits_in_corners",
    label: "Fits in Corners"
  }, {
    key: "free_standing",
    label: "Free Standing"
  }, {
    key: "mounting_hardware",
    label: "Mounting Hardware"
  }, {
    key: "stocked_fabrics",
    label: "Stocked Fabrics"
  }, {
    key: "variety_of_sizes",
    label: "Variety of Sizes"
  }, {
    key: "wall_mountable",
    label: "Wall Mountable"
  }];
  const [isColumnsDropdownOpen, setIsColumnsDropdownOpen] = t$3(d(false), "isColumnsDropdownOpen");
  const [isExportDropdownOpen, setIsExportDropdownOpen] = t$3(d(false), "isExportDropdownOpen");
  const [selectedColumns, setSelectedColumns] = t$3(d(availableColumns.map((col) => col.key)), "selectedColumns");
  const columnsDropdownRef = t$3(A$1(null), "columnsDropdownRef");
  const exportDropdownRef = t$3(A$1(null), "exportDropdownRef");
  y(() => {
    const handleClickOutside = (event) => {
      if (columnsDropdownRef.current && !columnsDropdownRef.current.contains(event.target)) {
        setIsColumnsDropdownOpen(false);
      }
      if (exportDropdownRef.current && !exportDropdownRef.current.contains(event.target)) {
        setIsExportDropdownOpen(false);
      }
    };
    if (isColumnsDropdownOpen || isExportDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isColumnsDropdownOpen, isExportDropdownOpen]);
  y(() => {
    if (onColumnsChange) {
      onColumnsChange(selectedColumns);
    }
  }, []);
  const handleColumnToggle = (columnKey) => {
    const newSelectedColumns = selectedColumns.includes(columnKey) ? selectedColumns.filter((key) => key !== columnKey) : [...selectedColumns, columnKey];
    setSelectedColumns(newSelectedColumns);
    if (onColumnsChange) {
      onColumnsChange(newSelectedColumns);
    }
  };
  const handleExportSelect = (value) => {
    if (value && onExport) {
      onExport(value);
    }
    setIsExportDropdownOpen(false);
  };
  const handlePrint = () => {
    if (onPrint) {
      onPrint();
    } else {
      window.print();
    }
  };
  return u$1("div", {
    className: "comparison-chart__secondary-controls",
    children: [u$1("div", {
      className: "comparison-chart__mobile-multiselect-container",
      ref: columnsDropdownRef,
      children: [u$1("button", {
        className: "comparison-chart__mobile-multiselect-button",
        onClick: () => setIsColumnsDropdownOpen(!isColumnsDropdownOpen),
        style: {
          minWidth: "auto",
          width: "auto"
        },
        children: [u$1("span", {
          children: "Columns"
        }, void 0, false, {
          fileName: _jsxFileName$a,
          lineNumber: 103,
          columnNumber: 11
        }, void 0), u$1("svg", {
          className: `comparison-chart__mobile-dropdown-arrow ${isColumnsDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: u$1("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M19 9l-7 7-7-7"
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 110,
            columnNumber: 13
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$a,
          lineNumber: 104,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$a,
        lineNumber: 98,
        columnNumber: 9
      }, void 0), isColumnsDropdownOpen && u$1("div", {
        className: "comparison-chart__mobile-multiselect-dropdown",
        children: availableColumns.map((column) => u$1("div", {
          className: "comparison-chart__mobile-multiselect-option",
          onClick: () => handleColumnToggle(column.key),
          children: [u$1("span", {
            className: "comparison-chart__mobile-option-text",
            children: column.label
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 122,
            columnNumber: 17
          }, void 0), selectedColumns.includes(column.key) && u$1("svg", {
            className: "comparison-chart__mobile-checkmark",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M5 13l4 4L19 7"
            }, void 0, false, {
              fileName: _jsxFileName$a,
              lineNumber: 130,
              columnNumber: 21
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 124,
            columnNumber: 19
          }, void 0)]
        }, column.key, true, {
          fileName: _jsxFileName$a,
          lineNumber: 117,
          columnNumber: 15
        }, void 0))
      }, void 0, false, {
        fileName: _jsxFileName$a,
        lineNumber: 115,
        columnNumber: 11
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$a,
      lineNumber: 97,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "comparison-chart__mobile-multiselect-container",
      ref: exportDropdownRef,
      children: [u$1("button", {
        className: "comparison-chart__mobile-multiselect-button",
        onClick: () => setIsExportDropdownOpen(!isExportDropdownOpen),
        style: {
          minWidth: "auto",
          width: "auto"
        },
        children: [u$1("span", {
          children: "Export"
        }, void 0, false, {
          fileName: _jsxFileName$a,
          lineNumber: 146,
          columnNumber: 11
        }, void 0), u$1("svg", {
          className: `comparison-chart__mobile-dropdown-arrow ${isExportDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: u$1("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M19 9l-7 7-7-7"
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 153,
            columnNumber: 13
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$a,
          lineNumber: 147,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$a,
        lineNumber: 141,
        columnNumber: 9
      }, void 0), isExportDropdownOpen && u$1("div", {
        className: "comparison-chart__mobile-multiselect-dropdown",
        children: [u$1("div", {
          className: "comparison-chart__mobile-multiselect-option",
          onClick: () => handleExportSelect("csv"),
          children: u$1("span", {
            className: "comparison-chart__mobile-option-text",
            children: "Export as CSV"
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 163,
            columnNumber: 15
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$a,
          lineNumber: 159,
          columnNumber: 13
        }, void 0), u$1("div", {
          className: "comparison-chart__mobile-multiselect-option",
          onClick: () => handleExportSelect("pdf"),
          children: u$1("span", {
            className: "comparison-chart__mobile-option-text",
            children: "Export as PDF"
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 169,
            columnNumber: 15
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$a,
          lineNumber: 165,
          columnNumber: 13
        }, void 0), u$1("div", {
          className: "comparison-chart__mobile-multiselect-option",
          onClick: () => handleExportSelect("excel"),
          children: u$1("span", {
            className: "comparison-chart__mobile-option-text",
            children: "Export as Excel"
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 175,
            columnNumber: 15
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$a,
          lineNumber: 171,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$a,
        lineNumber: 158,
        columnNumber: 11
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$a,
      lineNumber: 140,
      columnNumber: 7
    }, void 0), u$1("button", {
      className: "comparison-chart__print-button",
      onClick: handlePrint,
      children: "Print"
    }, void 0, false, {
      fileName: _jsxFileName$a,
      lineNumber: 182,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$a,
    lineNumber: 95,
    columnNumber: 5
  }, void 0);
};
const getProductName = (product, index, productData) => {
  if (typeof product === "string" && product.includes("Product/")) {
    const productInfo = productData[product];
    if (productInfo && productInfo.title) {
      return productInfo.title;
    }
    const productId = product.split("Product/")[1];
    return `Product ${productId.slice(-4)}`;
  }
  return `Product ${index + 1}`;
};
const getProductHandle = (product, productData) => {
  if (typeof product === "string" && product.includes("Product/")) {
    const productInfo = productData[product];
    return (productInfo == null ? void 0 : productInfo.handle) || null;
  }
  return null;
};
const getProductImage = (product, productData) => {
  if (typeof product === "string" && product.includes("Product/")) {
    const productInfo = productData[product];
    return (productInfo == null ? void 0 : productInfo.featuredImage) || null;
  }
  return null;
};
const formatBooleanValue = (value) => {
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  if (typeof value === "string") {
    if (value.toLowerCase() === "true") return "Yes";
    if (value.toLowerCase() === "false") return "No";
  }
  return value || "N/A";
};
const getUniqueValues = (parsedMetaobjects, productData) => {
  if (!Array.isArray(parsedMetaobjects) || parsedMetaobjects.length === 0) {
    return {
      frequencies: [],
      thicknesses: [],
      productTitles: []
    };
  }
  const frequencies = Array.from(new Set(parsedMetaobjects.map((item) => item.lowest_frequency).filter((freq) => freq && freq !== "N/A").map((freq) => String(freq).trim()))).sort((a2, b2) => {
    const numA = parseInt(String(a2).replace(/[^\d]/g, "")) || 0;
    const numB = parseInt(String(b2).replace(/[^\d]/g, "")) || 0;
    return numA - numB;
  });
  const thicknesses = Array.from(new Set(parsedMetaobjects.map((item) => item.thickness).filter((thickness) => thickness && thickness !== "N/A").map((thickness) => String(thickness).trim()))).sort((a2, b2) => {
    const numA = parseFloat(String(a2).replace(/[^\d.]/g, "")) || 0;
    const numB = parseFloat(String(b2).replace(/[^\d.]/g, "")) || 0;
    return numA - numB;
  });
  const productTitles = Array.from(new Set(parsedMetaobjects.map((item, index) => getProductName(item.product, index, productData)).filter((title) => title && title !== "N/A"))).sort();
  return {
    frequencies,
    thicknesses,
    productTitles
  };
};
const parseFrequency = (frequency) => {
  if (!frequency) return 0;
  const numericValue = frequency.toString().replace(/[^\d.]/g, "");
  return parseFloat(numericValue) || 0;
};
const sortByFrequency = (data, sortOrder) => {
  if (sortOrder === null) {
    return data;
  }
  const sortedData = [...data];
  sortedData.sort((a2, b2) => {
    const freqA = parseFrequency(a2.lowest_frequency);
    const freqB = parseFrequency(b2.lowest_frequency);
    if (sortOrder === "asc") {
      return freqA - freqB;
    } else {
      return freqB - freqA;
    }
  });
  return sortedData;
};
const exportToCSV = (data) => {
  if (data.length === 0) return;
  try {
    const headers = Object.keys(data[0]);
    const csvContent = [headers.join(","), ...data.map((row) => headers.map((header) => {
      const cell2 = row[header];
      if (typeof cell2 === "string" && (cell2.includes(",") || cell2.includes('"') || cell2.includes("\n"))) {
        return `"${cell2.replace(/"/g, '""')}"`;
      }
      return cell2;
    }).join(","))].join("\n");
    const BOM = "\uFEFF";
    const csvData = BOM + csvContent;
    const blob = new Blob([csvData], {
      type: "text/csv;charset=utf-8;"
    });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, "product-comparison.csv");
    } else {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "product-comparison.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    }
    console.log("CSV export completed successfully");
  } catch (error) {
    console.error("Error exporting CSV:", error);
    alert("Error exporting CSV file. Please try again.");
  }
};
const exportToExcel = (data) => {
  if (data.length === 0) return;
  try {
    const headers = Object.keys(data[0]);
    const tsvContent = [
      // Header row
      headers.join("	"),
      // Data rows
      ...data.map((row) => headers.map((header) => {
        const cell2 = row[header];
        if (typeof cell2 === "string") {
          return cell2.replace(/\t/g, " ").replace(/\n/g, " ").replace(/\r/g, " ");
        }
        return cell2 || "";
      }).join("	"))
    ].join("\n");
    const blob = new Blob([tsvContent], {
      type: "application/vnd.ms-excel;charset=utf-8;"
    });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, "product-comparison.xls");
    } else {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "product-comparison.xls");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    }
    console.log("Excel export completed successfully");
  } catch (error) {
    console.error("Error exporting Excel:", error);
    alert("Error exporting Excel file. Please try again.");
  }
};
const exportToPDF = (data) => {
  if (data.length === 0) return;
  try {
    const headers = Object.keys(data[0]);
    const printWindow = window.open("", "_blank", "width=800,height=600");
    if (!printWindow) {
      alert("Please allow popups for this site to export PDF, or try using the Print button instead.");
      return;
    }
    let htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Product Comparison Report</title>
        <meta charset="utf-8">
        <style>
          body { 
            font-family: Arial, sans-serif; 
            margin: 20px;
            background: white;
          }
          h1 { 
            color: #333; 
            margin-bottom: 20px; 
            font-size: 24px;
          }
          .report-info {
            margin-bottom: 20px;
            font-size: 14px;
            color: #666;
          }
          table { 
            border-collapse: collapse; 
            width: 100%; 
            margin-top: 20px;
            font-size: 12px;
          }
          th, td { 
            border: 1px solid #ddd; 
            padding: 8px; 
            text-align: left; 
            vertical-align: top;
          }
          th { 
            background-color: #f2f2f2; 
            font-weight: bold;
            font-size: 11px;
          }
          tr:nth-child(even) { 
            background-color: #f9f9f9; 
          }
          @media print {
            body { margin: 0; }
            table { font-size: 10px; }
            th, td { padding: 4px; }
          }
          @page {
            margin: 1cm;
            size: landscape;
          }
        </style>
      </head>
      <body>
        <h1>Product Comparison Report</h1>
        <div class="report-info">
          <p>Generated on: ${(/* @__PURE__ */ new Date()).toLocaleDateString()}</p>
          <p>Total Products: ${data.length}</p>
        </div>
        <table>
          <thead>
            <tr>`;
    headers.forEach((header) => {
      htmlContent += `<th>${header}</th>`;
    });
    htmlContent += `
            </tr>
          </thead>
          <tbody>`;
    data.forEach((row) => {
      htmlContent += "<tr>";
      headers.forEach((header) => {
        htmlContent += `<td>${row[header]}</td>`;
      });
      htmlContent += "</tr>";
    });
    htmlContent += `
          </tbody>
        </table>
        <script>
          window.onload = function() {
            // Auto-trigger print dialog after content loads
            setTimeout(function() {
              window.print();
            }, 500);
          };
          
          // Close window after printing (user action required)
          window.onafterprint = function() {
            setTimeout(function() {
              window.close();
            }, 1000);
          };
        <\/script>
      </body>
      </html>`;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    console.log("PDF export window opened successfully");
  } catch (error) {
    console.error("Error exporting PDF:", error);
    alert("Error opening PDF export. Please try using the Print button instead.");
  }
};
const generatePrintWindow = (data) => {
  if (data.length === 0) return null;
  const headers = Object.keys(data[0]);
  const printWindow = window.open("", "_blank", "width=800,height=600");
  if (!printWindow) {
    alert("Please allow popups for this site to print the comparison report.");
    return null;
  }
  let htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Product Comparison Report</title>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: Arial, sans-serif; 
          margin: 20px;
          background: white;
        }
        h1 { 
          color: #333; 
          margin-bottom: 20px; 
          font-size: 24px;
        }
        .report-info {
          margin-bottom: 20px;
          font-size: 14px;
          color: #666;
        }
        table { 
          border-collapse: collapse; 
          width: 100%; 
          margin-top: 20px;
          font-size: 12px;
        }
        th, td { 
          border: 1px solid #ddd; 
          padding: 8px; 
          text-align: left; 
          vertical-align: top;
        }
        th { 
          background-color: #f2f2f2; 
          font-weight: bold;
          font-size: 11px;
        }
        tr:nth-child(even) { 
          background-color: #f9f9f9; 
        }
        @media print {
          body { margin: 0; }
          table { font-size: 10px; }
          th, td { padding: 4px; }
        }
        @page {
          margin: 1cm;
          size: landscape;
        }
      </style>
    </head>
    <body>
      <h1>Product Comparison Report</h1>
      <div class="report-info">
        <p>Generated on: ${(/* @__PURE__ */ new Date()).toLocaleDateString()}</p>
        <p>Total Products: ${data.length}</p>
      </div>
      <table>
        <thead>
          <tr>`;
  headers.forEach((header) => {
    htmlContent += `<th>${header}</th>`;
  });
  htmlContent += `
          </tr>
        </thead>
        <tbody>`;
  data.forEach((row) => {
    htmlContent += "<tr>";
    headers.forEach((header) => {
      htmlContent += `<td>${row[header]}</td>`;
    });
    htmlContent += "</tr>";
  });
  htmlContent += `
        </tbody>
      </table>
      <script>
        window.onload = function() {
          // Auto-trigger print dialog after content loads
          setTimeout(function() {
            window.print();
          }, 500);
        };
        
        // Close window after printing (user action required)
        window.onafterprint = function() {
          setTimeout(function() {
            window.close();
          }, 1000);
        };
      <\/script>
    </body>
    </html>`;
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  return printWindow;
};
const prepareExportData = (filteredData, selectedColumns, productData) => {
  return filteredData.map((item, index) => {
    var _a;
    const row = {
      "Product Title": getProductName(item.product, index, productData)
    };
    if (selectedColumns.includes("fire_rated")) {
      row["Fire Rated"] = formatBooleanValue(item.fire_rated);
    }
    if (selectedColumns.includes("absorber")) {
      row["Absorber"] = formatBooleanValue(item.absorber);
    }
    if (selectedColumns.includes("thickness")) {
      row["Thickness"] = item.thickness || "N/A";
    }
    if (selectedColumns.includes("lowest_frequency")) {
      row["Lowest Frequency"] = ((_a = item.lowest_frequency) == null ? void 0 : _a.replace(" Hz", "")) || "N/A";
    }
    if (selectedColumns.includes("bass_control")) {
      row["Bass Control"] = formatBooleanValue(item.bass_control);
    }
    if (selectedColumns.includes("backing_type")) {
      row["Backing Type"] = item.backing_type || "N/A";
    }
    if (selectedColumns.includes("custom_sizes")) {
      row["Custom Sizes"] = formatBooleanValue(item.custom_sizes);
    }
    if (selectedColumns.includes("diffuser")) {
      row["Diffuser"] = item.diffuser || "N/A";
    }
    if (selectedColumns.includes("fits_in_corners")) {
      row["Fits in Corners"] = formatBooleanValue(item.fits_in_corners);
    }
    if (selectedColumns.includes("free_standing")) {
      row["Free Standing"] = item.free_standing || "N/A";
    }
    if (selectedColumns.includes("mounting_hardware")) {
      row["Mounting Hardware"] = item.mounting_hardware || "N/A";
    }
    if (selectedColumns.includes("stocked_fabrics")) {
      row["Stocked Fabrics"] = item.stocked_fabrics || "N/A";
    }
    if (selectedColumns.includes("variety_of_sizes")) {
      row["Variety of Sizes"] = formatBooleanValue(item.variety_of_sizes);
    }
    if (selectedColumns.includes("wall_mountable")) {
      row["Wall Mountable"] = formatBooleanValue(item.wall_mountable);
    }
    return row;
  });
};
const getProductData = async (productGid) => {
  var _a, _b, _c, _d;
  const productId = productGid.split("Product/")[1];
  if (!productId) {
    console.warn("Invalid product GID:", productGid);
    return null;
  }
  const query = `
    query getProduct($id: ID!) {
      product(id: $id) {
        id
        handle
        title
        featuredImage {
          id
          url
          altText
          width
          height
        }
        variants(first: 100) {
          nodes {
            id
            title
            price {
              amount
              currencyCode
            }
            availableForSale
            quantityAvailable
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
  `;
  try {
    const storefrontApiKey = (_b = (_a = window.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.storefront_api_key;
    const shopDomain = (_d = (_c = window == null ? void 0 : window.theme) == null ? void 0 : _c.routes) == null ? void 0 : _d.shop_url;
    if (!storefrontApiKey || !shopDomain) {
      throw new Error("Storefront API key or shop domain not found");
    }
    const response = await fetch(`${shopDomain}/api/2024-10/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontApiKey
      },
      body: JSON.stringify({
        query,
        variables: {
          id: productGid
        }
      })
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (data.errors) {
      console.error("GraphQL errors:", data.errors);
      return null;
    }
    return data.data.product;
  } catch (error) {
    console.error("Error fetching product data:", error);
    return null;
  }
};
const getProductGidFromExtras = (extras) => {
  if (!extras) return null;
  if (typeof extras === "string") {
    return extras.includes("Product/") ? extras : null;
  }
  if (Array.isArray(extras) && extras.length > 0) {
    const firstExtra = extras[0];
    return firstExtra && firstExtra.includes("Product/") ? firstExtra : null;
  }
  return null;
};
const fetchAllProductData = async (metaobjects, setProductData, setLoadingProducts) => {
  setLoadingProducts(true);
  const productPromises = metaobjects.filter((item) => {
    if ("product" in item && item.product && typeof item.product === "string" && item.product.includes("Product/")) {
      return true;
    }
    if ("extras" in item && item.extras) {
      const productGid = getProductGidFromExtras(item.extras);
      return productGid !== null;
    }
    return false;
  }).map(async (item) => {
    let productGid = null;
    if ("product" in item && item.product) {
      productGid = item.product;
    } else if ("extras" in item) {
      productGid = getProductGidFromExtras(item.extras);
    }
    if (!productGid) return null;
    const productInfo = await getProductData(productGid);
    return {
      gid: productGid,
      data: productInfo
    };
  });
  try {
    const results = await Promise.all(productPromises);
    const productMap = {};
    results.filter((result) => result !== null).forEach(({
      gid,
      data
    }) => {
      if (data) {
        productMap[gid] = data;
      }
    });
    setProductData(productMap);
  } catch (error) {
    console.error("Error fetching product data:", error);
  } finally {
    setLoadingProducts(false);
  }
};
var _jsxFileName$9 = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/ComparisonTool/ComparisonTool.tsx";
const ComparisonTool = ({
  initialData = null,
  sectionId = null
}) => {
  const [parsedMetaobjects, setParsedMetaobjects] = t$3(d([]), "parsedMetaobjects");
  const [productData, setProductData] = t$3(d({}), "productData");
  const [loadingProducts, setLoadingProducts] = t$3(d(false), "loadingProducts");
  const [searchTerm, setSearchTerm] = t$3(d(""), "searchTerm");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = t$3(d(""), "debouncedSearchTerm");
  const [selectedFilters, setSelectedFilters] = t$3(d({
    selectedProducts: [],
    // Changed to array for multi-select
    effectiveRange: "",
    thickness: ""
  }), "selectedFilters");
  const [selectedColumns, setSelectedColumns] = t$3(d([]), "selectedColumns");
  const [currentPage, setCurrentPage] = t$3(d(1), "currentPage");
  const itemsPerPage = 15;
  const [sortOrder, setSortOrder] = t$3(d(null), "sortOrder");
  const handleSearchChange = q$1((term) => {
    setSearchTerm(term);
  }, []);
  const handleDebouncedSearchChange = q$1((term) => {
    setDebouncedSearchTerm(term);
  }, []);
  const handleFiltersChange = (filters) => {
    setSelectedFilters(filters);
  };
  const handleClearFilters = () => {
    setSelectedFilters({
      selectedProducts: [],
      effectiveRange: "",
      thickness: ""
    });
    setSearchTerm("");
    setDebouncedSearchTerm("");
    setCurrentPage(1);
    setSortOrder(null);
  };
  const handleColumnsChange = (columns) => {
    setSelectedColumns(columns);
  };
  const handleExport = (format) => {
    console.log("Export requested:", format);
    const exportData = prepareExportData(filteredData, selectedColumns, productData);
    if (exportData.length === 0) {
      alert("No data to export. Please ensure there are products in your comparison.");
      return;
    }
    switch (format) {
      case "csv":
        exportToCSV(exportData);
        break;
      case "excel":
        exportToExcel(exportData);
        break;
      case "pdf":
        exportToPDF(exportData);
        break;
      default:
        console.error("Unknown export format:", format);
    }
  };
  const handlePrint = () => {
    try {
      const printData = prepareExportData(filteredData, selectedColumns, productData);
      if (printData.length === 0) {
        alert("No data to print. Please ensure there are products in your comparison.");
        return;
      }
      const printWindow = generatePrintWindow(printData);
      if (printWindow) {
        console.log("Print window opened successfully");
      }
    } catch (error) {
      console.error("Error opening print dialog:", error);
      alert("Error opening print dialog. Please try again.");
    }
  };
  y(() => {
    if (initialData) {
      try {
        let parsedData;
        if (Array.isArray(initialData)) {
          parsedData = initialData;
        } else if (typeof initialData === "string") {
          parsedData = JSON.parse(initialData);
        } else if (typeof initialData === "object") {
          parsedData = initialData;
        }
        if (Array.isArray(parsedData)) {
          setParsedMetaobjects(parsedData);
        } else {
          console.warn("Parsed data is not an array:", parsedData);
          setParsedMetaobjects([]);
        }
      } catch (error) {
        console.error("Error parsing initialData:", error);
        setParsedMetaobjects([]);
      }
    } else {
      setParsedMetaobjects([]);
    }
  }, [initialData]);
  y(() => {
    if (Array.isArray(parsedMetaobjects) && parsedMetaobjects.length > 0) {
      fetchAllProductData(parsedMetaobjects, setProductData, setLoadingProducts);
    }
  }, [parsedMetaobjects]);
  const {
    frequencies,
    thicknesses,
    productTitles
  } = getUniqueValues(parsedMetaobjects, productData);
  const filteredData = Array.isArray(parsedMetaobjects) ? parsedMetaobjects.filter((item) => {
    const matchesSearch = debouncedSearchTerm === "" || (() => {
      const searchLower = debouncedSearchTerm.toLowerCase();
      const productName = getProductName(item.product, parsedMetaobjects.indexOf(item), productData);
      if (productName.toLowerCase().includes(searchLower)) {
        return true;
      }
      const searchableValues = [item.lowest_frequency, item.thickness, item.backing_type, item.diffuser, item.free_standing, item.mounting_hardware, item.stocked_fabrics, formatBooleanValue(item.fire_rated), formatBooleanValue(item.absorber), formatBooleanValue(item.bass_control), formatBooleanValue(item.custom_sizes), formatBooleanValue(item.fits_in_corners), formatBooleanValue(item.variety_of_sizes), formatBooleanValue(item.wall_mountable)];
      return searchableValues.some((value) => {
        if (value && value !== "N/A") {
          return String(value).toLowerCase().includes(searchLower);
        }
        return false;
      });
    })();
    const matchesCompare = selectedFilters.selectedProducts.length === 0 || selectedFilters.selectedProducts.some((selectedProduct) => getProductName(item.product, parsedMetaobjects.indexOf(item), productData) === selectedProduct);
    const matchesEffectiveRange = selectedFilters.effectiveRange === "" || item.lowest_frequency && String(item.lowest_frequency).trim() === selectedFilters.effectiveRange;
    const matchesThickness = selectedFilters.thickness === "" || item.thickness && String(item.thickness).trim() === selectedFilters.thickness;
    return matchesSearch && matchesCompare && matchesEffectiveRange && matchesThickness;
  }) : [];
  const sortedData = sortByFrequency(filteredData, sortOrder);
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageData = sortedData.slice(startIndex, endIndex);
  y(() => {
    setCurrentPage(1);
  }, [debouncedSearchTerm, selectedFilters, sortOrder]);
  const handleSortByFrequency = () => {
    if (sortOrder === null) {
      setSortOrder("asc");
    } else if (sortOrder === "asc") {
      setSortOrder("desc");
    } else {
      setSortOrder(null);
    }
  };
  const isColumnVisible = (columnKey) => {
    return selectedColumns.includes(columnKey);
  };
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return u$1("div", {
    className: "comparison-chart page-width",
    children: [u$1("div", {
      className: "comparison-chart__controls",
      children: [u$1("div", {
        className: "comparison-chart__header",
        children: [u$1(ComparisonSearch, {
          searchTerm,
          onSearchChange: handleSearchChange,
          onDebouncedSearchChange: handleDebouncedSearchChange
        }, void 0, false, {
          fileName: _jsxFileName$9,
          lineNumber: 269,
          columnNumber: 11
        }, void 0), u$1(ComparisonFilters, {
          selectedFilters,
          onFiltersChange: handleFiltersChange,
          parsedMetaobjects,
          productData,
          getProductName: (product, index) => getProductName(product, index, productData),
          onClearFilters: handleClearFilters
        }, void 0, false, {
          fileName: _jsxFileName$9,
          lineNumber: 275,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$9,
        lineNumber: 268,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__actions",
        children: u$1(ComparisonActions, {
          onColumnsChange: handleColumnsChange,
          onExport: handleExport,
          onPrint: handlePrint
        }, void 0, false, {
          fileName: _jsxFileName$9,
          lineNumber: 287,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$9,
        lineNumber: 286,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$9,
      lineNumber: 266,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "comparison-chart__table-container",
      children: [loadingProducts && u$1("div", {
        className: "comparison-chart__loading",
        style: {
          textAlign: "center",
          padding: "20px"
        },
        children: "Loading product information..."
      }, void 0, false, {
        fileName: _jsxFileName$9,
        lineNumber: 298,
        columnNumber: 11
      }, void 0), u$1("div", {
        className: "comparison-chart__desktop-table",
        children: u$1("table", {
          className: "comparison-chart__table",
          children: [u$1("thead", {
            children: u$1("tr", {
              className: "comparison-chart__table-header",
              children: [u$1("th", {
                className: "comparison-chart__header-cell",
                children: "Products"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 308,
                columnNumber: 17
              }, void 0), u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--image",
                children: "Image"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 309,
                columnNumber: 17
              }, void 0), u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--name",
                children: "Shop"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 310,
                columnNumber: 17
              }, void 0), isColumnVisible("lowest_frequency") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--frequency",
                children: u$1("button", {
                  className: "comparison-chart__sort-button",
                  onClick: handleSortByFrequency,
                  children: ["Lowest Freq.", u$1("svg", {
                    className: "comparison-chart__sort-icon",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: [sortOrder === null && u$1("path", {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                    }, void 0, false, {
                      fileName: _jsxFileName$9,
                      lineNumber: 320,
                      columnNumber: 27
                    }, void 0), sortOrder === "asc" && u$1("path", {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M5 15l7-7 7 7"
                    }, void 0, false, {
                      fileName: _jsxFileName$9,
                      lineNumber: 323,
                      columnNumber: 27
                    }, void 0), sortOrder === "desc" && u$1("path", {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M19 9l-7 7-7-7"
                    }, void 0, false, {
                      fileName: _jsxFileName$9,
                      lineNumber: 326,
                      columnNumber: 27
                    }, void 0)]
                  }, void 0, true, {
                    fileName: _jsxFileName$9,
                    lineNumber: 318,
                    columnNumber: 23
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName$9,
                  lineNumber: 313,
                  columnNumber: 21
                }, void 0)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 312,
                columnNumber: 19
              }, void 0), isColumnVisible("thickness") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--thickness",
                children: "Thickness"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 333,
                columnNumber: 19
              }, void 0), isColumnVisible("fire_rated") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--fire-rated",
                children: "Fire Rated"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 336,
                columnNumber: 19
              }, void 0), isColumnVisible("absorber") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--absorber",
                children: "Absorber"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 339,
                columnNumber: 19
              }, void 0), isColumnVisible("bass_control") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--bass-control",
                children: "Bass Control"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 342,
                columnNumber: 19
              }, void 0), isColumnVisible("backing_type") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--backing-type",
                children: "Backing Type"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 345,
                columnNumber: 19
              }, void 0), isColumnVisible("custom_sizes") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--custom-sizes",
                children: "Custom Sizes"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 348,
                columnNumber: 19
              }, void 0), isColumnVisible("diffuser") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--diffuser",
                children: "Diffuser"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 351,
                columnNumber: 19
              }, void 0), isColumnVisible("fits_in_corners") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--fits-corners",
                children: "Fits in Corners"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 354,
                columnNumber: 19
              }, void 0), isColumnVisible("free_standing") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--free-standing",
                children: "Free Standing"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 357,
                columnNumber: 19
              }, void 0), isColumnVisible("mounting_hardware") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--mounting-hardware",
                children: "Mounting Hardware"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 360,
                columnNumber: 19
              }, void 0), isColumnVisible("stocked_fabrics") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--stocked-fabrics",
                children: "Stocked Fabrics"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 363,
                columnNumber: 19
              }, void 0), isColumnVisible("variety_of_sizes") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--variety-sizes",
                children: "Variety of Sizes"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 366,
                columnNumber: 19
              }, void 0), isColumnVisible("wall_mountable") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--wall-mountable",
                children: "Wall Mountable"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 369,
                columnNumber: 19
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$9,
              lineNumber: 307,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 306,
            columnNumber: 13
          }, void 0), u$1("tbody", {
            children: currentPageData.map((item, index) => {
              const productImage = getProductImage(item.product, productData);
              const productHandle = getProductHandle(item.product, productData);
              return u$1("tr", {
                className: "comparison-chart__table-row",
                children: [u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: getProductName(item.product, index, productData)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 380,
                  columnNumber: 21
                }, void 0), u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: u$1("div", {
                    className: "comparison-chart__product-image",
                    children: productImage ? u$1("img", {
                      src: productImage.url,
                      alt: productImage.altText || "Product image",
                      style: {
                        width: "50px",
                        height: "50px",
                        objectFit: "cover"
                      }
                    }, void 0, false, {
                      fileName: _jsxFileName$9,
                      lineNumber: 386,
                      columnNumber: 27
                    }, void 0) : u$1("svg", {
                      className: "comparison-chart__image-icon",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      children: u$1("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 002 2v12a2 2 0 002 2z"
                      }, void 0, false, {
                        fileName: _jsxFileName$9,
                        lineNumber: 393,
                        columnNumber: 29
                      }, void 0)
                    }, void 0, false, {
                      fileName: _jsxFileName$9,
                      lineNumber: 392,
                      columnNumber: 27
                    }, void 0)
                  }, void 0, false, {
                    fileName: _jsxFileName$9,
                    lineNumber: 384,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 383,
                  columnNumber: 21
                }, void 0), u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: productHandle ? u$1("a", {
                    href: `/products/${productHandle}`,
                    className: "comparison-chart__shop-button",
                    children: "Shop"
                  }, void 0, false, {
                    fileName: _jsxFileName$9,
                    lineNumber: 400,
                    columnNumber: 25
                  }, void 0) : u$1("button", {
                    className: "comparison-chart__shop-button",
                    disabled: true,
                    children: "Shop"
                  }, void 0, false, {
                    fileName: _jsxFileName$9,
                    lineNumber: 407,
                    columnNumber: 25
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 398,
                  columnNumber: 21
                }, void 0), isColumnVisible("lowest_frequency") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.lowest_frequency || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 413,
                  columnNumber: 23
                }, void 0), isColumnVisible("thickness") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.thickness || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 418,
                  columnNumber: 23
                }, void 0), isColumnVisible("fire_rated") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.fire_rated)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 423,
                  columnNumber: 23
                }, void 0), isColumnVisible("absorber") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.absorber)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 428,
                  columnNumber: 23
                }, void 0), isColumnVisible("bass_control") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.bass_control)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 433,
                  columnNumber: 23
                }, void 0), isColumnVisible("backing_type") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.backing_type || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 438,
                  columnNumber: 23
                }, void 0), isColumnVisible("custom_sizes") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.custom_sizes)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 443,
                  columnNumber: 23
                }, void 0), isColumnVisible("diffuser") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.diffuser || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 448,
                  columnNumber: 23
                }, void 0), isColumnVisible("fits_in_corners") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.fits_in_corners)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 453,
                  columnNumber: 23
                }, void 0), isColumnVisible("free_standing") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.free_standing || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 458,
                  columnNumber: 23
                }, void 0), isColumnVisible("mounting_hardware") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.mounting_hardware || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 463,
                  columnNumber: 23
                }, void 0), isColumnVisible("stocked_fabrics") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.stocked_fabrics || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 468,
                  columnNumber: 23
                }, void 0), isColumnVisible("variety_of_sizes") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.variety_of_sizes)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 473,
                  columnNumber: 23
                }, void 0), isColumnVisible("wall_mountable") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.wall_mountable)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 478,
                  columnNumber: 23
                }, void 0)]
              }, index, true, {
                fileName: _jsxFileName$9,
                lineNumber: 379,
                columnNumber: 19
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 373,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$9,
          lineNumber: 305,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$9,
        lineNumber: 304,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__mobile-table",
        children: u$1("div", {
          className: "comparison-chart__mobile-table-wrapper",
          children: [u$1("div", {
            className: "comparison-chart__mobile-header",
            children: [u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Products"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 494,
              columnNumber: 15
            }, void 0), u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Image"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 495,
              columnNumber: 15
            }, void 0), u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Name"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 496,
              columnNumber: 15
            }, void 0), isColumnVisible("lowest_frequency") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Lowest Freq."
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 498,
              columnNumber: 17
            }, void 0), isColumnVisible("thickness") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Thickness"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 501,
              columnNumber: 17
            }, void 0), isColumnVisible("fire_rated") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Fire Rated"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 504,
              columnNumber: 17
            }, void 0), isColumnVisible("absorber") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Absorber"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 507,
              columnNumber: 17
            }, void 0), isColumnVisible("bass_control") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Bass Control"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 510,
              columnNumber: 17
            }, void 0), isColumnVisible("backing_type") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Backing Type"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 513,
              columnNumber: 17
            }, void 0), isColumnVisible("custom_sizes") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Custom Sizes"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 516,
              columnNumber: 17
            }, void 0), isColumnVisible("diffuser") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Diffuser"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 519,
              columnNumber: 17
            }, void 0), isColumnVisible("fits_in_corners") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Fits in Corners"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 522,
              columnNumber: 17
            }, void 0), isColumnVisible("free_standing") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Free Standing"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 525,
              columnNumber: 17
            }, void 0), isColumnVisible("mounting_hardware") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Mounting Hardware"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 528,
              columnNumber: 17
            }, void 0), isColumnVisible("stocked_fabrics") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Stocked Fabrics"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 531,
              columnNumber: 17
            }, void 0), isColumnVisible("variety_of_sizes") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Variety of Sizes"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 534,
              columnNumber: 17
            }, void 0), isColumnVisible("wall_mountable") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Wall Mountable"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 537,
              columnNumber: 17
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$9,
            lineNumber: 493,
            columnNumber: 13
          }, void 0), currentPageData.map((item, index) => {
            var _a;
            const productImage = getProductImage(item.product, productData);
            const productHandle = getProductHandle(item.product, productData);
            return u$1("div", {
              className: "comparison-chart__mobile-row",
              children: [u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: getProductName(item.product, index, productData)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 548,
                columnNumber: 19
              }, void 0), u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: u$1("div", {
                  className: "comparison-chart__mobile-product-image",
                  children: productImage ? u$1("img", {
                    src: productImage.url,
                    alt: productImage.altText || "Product image",
                    style: {
                      width: "32px",
                      height: "32px",
                      objectFit: "cover"
                    }
                  }, void 0, false, {
                    fileName: _jsxFileName$9,
                    lineNumber: 554,
                    columnNumber: 25
                  }, void 0) : u$1("svg", {
                    className: "comparison-chart__mobile-image-icon",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: u$1("path", {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 002 2v12a2 2 0 002 2z"
                    }, void 0, false, {
                      fileName: _jsxFileName$9,
                      lineNumber: 561,
                      columnNumber: 27
                    }, void 0)
                  }, void 0, false, {
                    fileName: _jsxFileName$9,
                    lineNumber: 560,
                    columnNumber: 25
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 552,
                  columnNumber: 21
                }, void 0)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 551,
                columnNumber: 19
              }, void 0), u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: productHandle ? u$1("a", {
                  href: `/products/${productHandle}`,
                  className: "comparison-chart__mobile-shop-button",
                  children: "Shop"
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 568,
                  columnNumber: 23
                }, void 0) : u$1("button", {
                  className: "comparison-chart__mobile-shop-button",
                  disabled: true,
                  children: "Shop"
                }, void 0, false, {
                  fileName: _jsxFileName$9,
                  lineNumber: 575,
                  columnNumber: 23
                }, void 0)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 566,
                columnNumber: 19
              }, void 0), isColumnVisible("lowest_frequency") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: ((_a = item.lowest_frequency) == null ? void 0 : _a.replace(" Hz", "")) || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 581,
                columnNumber: 21
              }, void 0), isColumnVisible("thickness") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.thickness || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 586,
                columnNumber: 21
              }, void 0), isColumnVisible("fire_rated") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.fire_rated)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 591,
                columnNumber: 21
              }, void 0), isColumnVisible("absorber") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.absorber)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 596,
                columnNumber: 21
              }, void 0), isColumnVisible("bass_control") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.bass_control)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 601,
                columnNumber: 21
              }, void 0), isColumnVisible("backing_type") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.backing_type || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 606,
                columnNumber: 21
              }, void 0), isColumnVisible("custom_sizes") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.custom_sizes)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 611,
                columnNumber: 21
              }, void 0), isColumnVisible("diffuser") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.diffuser || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 616,
                columnNumber: 21
              }, void 0), isColumnVisible("fits_in_corners") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.fits_in_corners)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 621,
                columnNumber: 21
              }, void 0), isColumnVisible("free_standing") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.free_standing || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 626,
                columnNumber: 21
              }, void 0), isColumnVisible("mounting_hardware") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.mounting_hardware || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 631,
                columnNumber: 21
              }, void 0), isColumnVisible("stocked_fabrics") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.stocked_fabrics || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 636,
                columnNumber: 21
              }, void 0), isColumnVisible("variety_of_sizes") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.variety_of_sizes)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 641,
                columnNumber: 21
              }, void 0), isColumnVisible("wall_mountable") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.wall_mountable)
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 646,
                columnNumber: 21
              }, void 0)]
            }, index, true, {
              fileName: _jsxFileName$9,
              lineNumber: 547,
              columnNumber: 17
            }, void 0);
          })]
        }, void 0, true, {
          fileName: _jsxFileName$9,
          lineNumber: 491,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$9,
        lineNumber: 490,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$9,
      lineNumber: 296,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "comparison-chart__pagination",
      children: [u$1("div", {
        className: "comparison-chart__pagination-info",
        children: sortedData.length > 0 ? `Showing ${startIndex + 1} to ${Math.min(endIndex, sortedData.length)} of ${sortedData.length} entries` : "No entries found"
      }, void 0, false, {
        fileName: _jsxFileName$9,
        lineNumber: 659,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__pagination-controls",
        children: totalPages > 1 && u$1(k$1, {
          children: [u$1("button", {
            className: "comparison-chart__pagination-button",
            onClick: goToPreviousPage,
            disabled: currentPage === 1,
            children: "Previous"
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 670,
            columnNumber: 15
          }, void 0), u$1("button", {
            className: "comparison-chart__pagination-button",
            onClick: goToNextPage,
            disabled: currentPage === totalPages,
            children: "Next"
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 677,
            columnNumber: 15
          }, void 0)]
        }, void 0, true)
      }, void 0, false, {
        fileName: _jsxFileName$9,
        lineNumber: 667,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$9,
      lineNumber: 658,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$9,
    lineNumber: 265,
    columnNumber: 5
  }, void 0);
};
register(ComparisonTool, "comparison-tool", ["initialData", "sectionId"]);
var _jsxFileName$8 = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/DownloadsWidget.tsx";
function DownloadsWidget({
  title = "Downloads",
  items = "[]"
}) {
  const [downloadingItems, setDownloadingItems] = t$3(d(/* @__PURE__ */ new Set()), "downloadingItems");
  let parsedItems = [];
  try {
    parsedItems = JSON.parse(items);
  } catch (error) {
    console.error("Error parsing download items:", error);
  }
  const handleDownload = async (item) => {
    const itemKey = `${item.file_url}-${item.title}`;
    setDownloadingItems((prev) => new Set(prev).add(itemKey));
    try {
      const response = await fetch(item.file_url);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = item.title || "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      setTimeout(() => {
        setDownloadingItems((prev) => {
          const newSet = new Set(prev);
          newSet.delete(itemKey);
          return newSet;
        });
      }, 500);
    } catch (error) {
      console.error("Download failed:", error);
      setDownloadingItems((prev) => {
        const newSet = new Set(prev);
        newSet.delete(itemKey);
        return newSet;
      });
    }
  };
  const splitItemsIntoRows = (items2, isDesktop) => {
    const rows = [];
    const itemsPerFirstRow = isDesktop ? 3 : 2;
    if (items2.length === 0) return rows;
    rows.push(items2.slice(0, itemsPerFirstRow));
    let remainingItems = items2.slice(itemsPerFirstRow);
    while (remainingItems.length > 0) {
      if (isDesktop) {
        const nextRowSize = remainingItems.length >= 3 ? 3 : remainingItems.length;
        rows.push(remainingItems.slice(0, nextRowSize));
        remainingItems = remainingItems.slice(nextRowSize);
      } else {
        const nextRowSize = remainingItems.length >= 2 ? 2 : 1;
        rows.push(remainingItems.slice(0, nextRowSize));
        remainingItems = remainingItems.slice(nextRowSize);
      }
    }
    return rows;
  };
  const getGridColClass = (itemCount) => {
    switch (itemCount) {
      case 1:
        return "tw-grid-cols-1";
      case 2:
        return "tw-grid-cols-2";
      case 3:
        return "tw-grid-cols-3";
      default:
        return "tw-grid-cols-3";
    }
  };
  const renderDownloadButton = (item, index) => {
    const itemKey = `${item.file_url}-${item.title}`;
    const isDownloading = downloadingItems.has(itemKey);
    return u$1("button", {
      className: "tw-flex tw-flex-col tw-items-center tw-gap-3 tw-p-0 tw-bg-transparent tw-border-none tw-cursor-pointer tw-transition-transform hover:tw-transform hover:tw-scale-105 tw-w-full tw-max-w-[136px]",
      onClick: () => handleDownload(item),
      disabled: isDownloading,
      children: [u$1("div", {
        className: "tw-w-[75px] tw-h-[75px] md:tw-w-[85px] md:tw-h-[85px] tw-flex tw-items-center tw-justify-center",
        children: item.icon ? u$1("img", {
          src: item.icon,
          alt: `${item.title} icon`,
          className: "tw-w-full tw-h-full tw-object-contain"
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 120,
          columnNumber: 13
        }, this) : u$1("div", {
          className: "tw-w-full tw-h-full tw-bg-gray-200 tw-rounded-lg tw-flex tw-items-center tw-justify-center",
          children: u$1("svg", {
            className: "tw-w-10 tw-h-10 md:tw-w-12 md:tw-h-12 tw-text-gray-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 133,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 127,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 126,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$8,
        lineNumber: 118,
        columnNumber: 9
      }, this), u$1("div", {
        className: "tw-flex tw-items-center tw-gap-1 tw-justify-center tw-whitespace-break-spaces tw-min-h-[3rem] tw-flex-1",
        children: [u$1("div", {
          className: "tw-w-4 tw-h-4 md:tw-w-5 md:tw-h-5 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0",
          children: isDownloading ? u$1("svg", {
            className: "tw-animate-spin tw-w-4 tw-h-4 md:tw-w-5 md:tw-h-5 tw-text-[#0b0e11] tw-opacity-50",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [u$1("circle", {
              className: "tw-opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              strokeWidth: "4"
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 154,
              columnNumber: 17
            }, this), u$1("path", {
              className: "tw-opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 162,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$8,
            lineNumber: 149,
            columnNumber: 15
          }, this) : u$1("svg", {
            className: "tw-w-4 tw-h-4 md:tw-w-5 md:tw-h-5 tw-text-[#0b0e11] tw-opacity-50",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            children: u$1("path", {
              d: "M17.3438 11.25V16.25C17.3438 16.3743 17.2944 16.4935 17.2065 16.5815C17.1185 16.6694 16.9993 16.7188 16.875 16.7188H3.125C3.00068 16.7188 2.88145 16.6694 2.79354 16.5815C2.70564 16.4935 2.65625 16.3743 2.65625 16.25V11.25C2.65625 11.1257 2.70564 11.0065 2.79354 10.9185C2.88145 10.8306 3.00068 10.7812 3.125 10.7812C3.24932 10.7812 3.36855 10.8306 3.45646 10.9185C3.54436 11.0065 3.59375 11.1257 3.59375 11.25V15.7812H16.4062V11.25C16.4062 11.1257 16.4556 11.0065 16.5435 10.9185C16.6315 10.8306 16.7507 10.7812 16.875 10.7812C16.9993 10.7812 17.1185 10.8306 17.2065 10.9185C17.2944 11.0065 17.3438 11.1257 17.3438 11.25ZM9.66875 11.5813C9.75664 11.669 9.87578 11.7183 10 11.7183C10.1242 11.7183 10.2434 11.669 10.3313 11.5813L13.4563 8.45625C13.5391 8.36739 13.5841 8.24986 13.582 8.12842C13.5798 8.00699 13.5306 7.89112 13.4448 7.80524C13.3589 7.71935 13.243 7.67016 13.1216 7.66802C13.0001 7.66587 12.8826 7.71095 12.7937 7.79375L10.4688 10.118V2.5C10.4688 2.37568 10.4194 2.25645 10.3315 2.16854C10.2435 2.08064 10.1243 2.03125 10 2.03125C9.87568 2.03125 9.75645 2.08064 9.66854 2.16854C9.58064 2.25645 9.53125 2.37568 9.53125 2.5V10.118L7.20625 7.79375C7.11739 7.71095 6.99986 7.66587 6.87842 7.66802C6.75699 7.67016 6.64112 7.71935 6.55524 7.80524C6.46935 7.89112 6.42016 8.00699 6.41802 8.12842C6.41587 8.24986 6.46095 8.36739 6.54375 8.45625L9.66875 11.5813Z"
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 174,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 169,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 147,
          columnNumber: 11
        }, this), u$1("p", {
          className: "tw-text-sm md:tw-text-base tw-font-light tw-text-[#0b0e11] tw-tracking-[0.02em] tw-leading-relaxed tw-text-center tw-break-words",
          style: {
            fontFamily: "'Lexend', sans-serif"
          },
          children: isDownloading ? "Downloading..." : item.title
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 180,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$8,
        lineNumber: 145,
        columnNumber: 9
      }, this)]
    }, index, true, {
      fileName: _jsxFileName$8,
      lineNumber: 111,
      columnNumber: 7
    }, this);
  };
  const renderDownloadsGrid = () => {
    const desktopRows = splitItemsIntoRows(parsedItems, true);
    const mobileRows = splitItemsIntoRows(parsedItems, false);
    return u$1("div", {
      className: "tw-flex tw-flex-col tw-gap-10 tw-flex-1 tw-content-start",
      children: [u$1("div", {
        className: "tw-hidden sm:tw-flex tw-flex-col tw-gap-10",
        children: desktopRows.map((row, rowIndex) => {
          const isLastRow = rowIndex === desktopRows.length - 1;
          const isIncompleteRow = row.length < 3;
          if (isLastRow && isIncompleteRow) {
            return u$1("div", {
              className: "tw-flex tw-justify-center tw-gap-10",
              children: row.map((item, itemIndex) => renderDownloadButton(item, rowIndex * 3 + itemIndex))
            }, `desktop-row-${rowIndex}`, false, {
              fileName: _jsxFileName$8,
              lineNumber: 203,
              columnNumber: 17
            }, this);
          }
          return u$1("div", {
            className: `tw-grid ${getGridColClass(row.length)} tw-gap-10 tw-justify-items-center`,
            children: row.map((item, itemIndex) => renderDownloadButton(item, rowIndex * 3 + itemIndex))
          }, `desktop-row-${rowIndex}`, false, {
            fileName: _jsxFileName$8,
            lineNumber: 213,
            columnNumber: 15
          }, this);
        })
      }, void 0, false, {
        fileName: _jsxFileName$8,
        lineNumber: 196,
        columnNumber: 9
      }, this), u$1("div", {
        className: "tw-flex tw-flex-col tw-gap-10 sm:tw-hidden",
        children: mobileRows.map((row, rowIndex) => {
          const isLastRow = rowIndex === mobileRows.length - 1;
          const isIncompleteRow = row.length < 2;
          if (isLastRow && isIncompleteRow) {
            return u$1("div", {
              className: "tw-flex tw-justify-center tw-gap-10",
              children: row.map((item, itemIndex) => renderDownloadButton(item, rowIndex * 2 + itemIndex))
            }, `mobile-row-${rowIndex}`, false, {
              fileName: _jsxFileName$8,
              lineNumber: 231,
              columnNumber: 17
            }, this);
          }
          return u$1("div", {
            className: `tw-grid ${getGridColClass(row.length)} tw-gap-10 tw-justify-items-center`,
            children: row.map((item, itemIndex) => renderDownloadButton(item, rowIndex * 2 + itemIndex))
          }, `mobile-row-${rowIndex}`, false, {
            fileName: _jsxFileName$8,
            lineNumber: 241,
            columnNumber: 15
          }, this);
        })
      }, void 0, false, {
        fileName: _jsxFileName$8,
        lineNumber: 224,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$8,
      lineNumber: 194,
      columnNumber: 7
    }, this);
  };
  if (!parsedItems.length) {
    return u$1("div", {
      className: "tw-bg-[#f3f6f6] tw-rounded-xl tw-px-5 lg:tw-px-8 tw-py-6 tw-w-full tw-min-h-[400px] tw-flex tw-items-center tw-justify-center tw-h-full",
      children: u$1("div", {
        className: "tw-text-center tw-text-gray-500",
        children: "No downloads available"
      }, void 0, false, {
        fileName: _jsxFileName$8,
        lineNumber: 257,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$8,
      lineNumber: 256,
      columnNumber: 7
    }, this);
  }
  return u$1("div", {
    className: "tw-bg-[#f3f6f6] tw-rounded-xl tw-px-5 lg:tw-px-8 tw-py-6 tw-w-full tw-min-h-[400px] lg:tw-min-w-[37vw] tw-flex tw-flex-col tw-h-full",
    children: [u$1("div", {
      className: "tw-mb-14",
      children: u$1("h3", {
        className: "tw-text-2xl tw-font-semibold tw-text-[#0b0e11] tw-text-center tw-tracking-[-0.11em] tw-leading-tight",
        style: {
          fontFamily: "'Lexend Giga', sans-serif"
        },
        children: title
      }, void 0, false, {
        fileName: _jsxFileName$8,
        lineNumber: 268,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$8,
      lineNumber: 267,
      columnNumber: 7
    }, this), renderDownloadsGrid()]
  }, void 0, true, {
    fileName: _jsxFileName$8,
    lineNumber: 265,
    columnNumber: 5
  }, this);
}
register(DownloadsWidget, "downloads-widget");
const convertUnit = (value, toUnit) => {
  if (!value) return "";
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  if (toUnit === "inches") {
    return (num / 2.54).toFixed(0);
  } else {
    return (num * 2.54).toFixed(0);
  }
};
const getMinMax = (minHeight, maxHeight, minWidth, maxWidth, unit) => {
  const result = {};
  if (minHeight !== null && maxHeight !== null) {
    const minH = parseFloat(minHeight);
    const maxH = parseFloat(maxHeight);
    if (unit === "inches") {
      result.minHeight = minH / 2.54;
      result.maxHeight = maxH / 2.54;
    } else {
      result.minHeight = minH;
      result.maxHeight = maxH;
    }
  }
  if (minWidth !== null && maxWidth !== null) {
    const minW = parseFloat(minWidth);
    const maxW = parseFloat(maxWidth);
    if (unit === "inches") {
      result.minWidth = minW / 2.54;
      result.maxWidth = maxW / 2.54;
    } else {
      result.minWidth = minW;
      result.maxWidth = maxW;
    }
  }
  return result;
};
const convertToMillimeters = (value, currentUnit) => {
  if (!value) return null;
  const num = parseFloat(value);
  if (isNaN(num)) return null;
  if (currentUnit === "cm") {
    return num * 10;
  } else {
    return num * 25.4;
  }
};
const parseHelpContent = (helpContent) => {
  if (!helpContent) return {};
  try {
    const helpData = JSON.parse(helpContent);
    if (!helpData || !Array.isArray(helpData)) {
      return {};
    }
    return helpData.reduce((acc, item) => {
      if (item.option_target && item.tooltip_text) {
        acc[item.option_target.toLowerCase()] = item.tooltip_text;
      }
      return acc;
    }, {});
  } catch (error) {
    console.error("Failed to parse helpContent:", error);
    return {};
  }
};
const getTooltipText = (optionName, helpContentLookup, tooltipHandleMap = {}, excludePatterns = []) => {
  const normalizedOptionName = optionName.toLowerCase();
  for (const pattern of excludePatterns) {
    if (normalizedOptionName.includes(pattern.toLowerCase())) {
      return "";
    }
  }
  if (helpContentLookup[normalizedOptionName]) {
    return helpContentLookup[normalizedOptionName];
  }
  for (const [triggerWord, handle] of Object.entries(tooltipHandleMap)) {
    if (triggerWord && normalizedOptionName.includes(triggerWord.toLowerCase())) {
      if (handle && helpContentLookup[handle]) {
        return helpContentLookup[handle];
      }
    }
  }
  return "";
};
var _jsxFileName$7 = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/TooltipIcon.tsx";
const QUESTION_MARK_PATH = "M10.9375 14.875C10.9375 15.0604 10.8825 15.2417 10.7795 15.3958C10.6765 15.55 10.5301 15.6702 10.3588 15.7411C10.1875 15.8121 9.99896 15.8307 9.81711 15.7945C9.63525 15.7583 9.4682 15.669 9.33709 15.5379C9.20598 15.4068 9.11669 15.2398 9.08052 15.0579C9.04434 14.876 9.06291 14.6875 9.13387 14.5162C9.20482 14.3449 9.32499 14.1985 9.47916 14.0955C9.63333 13.9925 9.81458 13.9375 10 13.9375C10.2486 13.9375 10.4871 14.0363 10.6629 14.2121C10.8387 14.3879 10.9375 14.6264 10.9375 14.875ZM10 4.9375C8.03125 4.9375 6.4375 6.36719 6.4375 8.125V8.5C6.4375 8.64918 6.49677 8.79226 6.60226 8.89775C6.70775 9.00324 6.85082 9.0625 7 9.0625C7.14919 9.0625 7.29226 9.00324 7.39775 8.89775C7.50324 8.79226 7.5625 8.64918 7.5625 8.5V8.125C7.5625 6.98781 8.65563 6.0625 10 6.0625C11.3444 6.0625 12.4375 6.98781 12.4375 8.125C12.4375 9.26219 11.3444 10.1875 10 10.1875C9.85082 10.1875 9.70775 10.2468 9.60226 10.3523C9.49677 10.4577 9.4375 10.6008 9.4375 10.75V11.5C9.4375 11.6492 9.49677 11.7923 9.60226 11.8977C9.70775 12.0032 9.85082 12.0625 10 12.0625C10.1492 12.0625 10.2923 12.0032 10.3978 11.8977C10.5032 11.7923 10.5625 11.6492 10.5625 11.5V11.2731C12.2603 11.0312 13.5625 9.71125 13.5625 8.125C13.5625 6.36719 11.9688 4.9375 10 4.9375ZM19.5625 10C19.5625 11.8913 19.0017 13.7401 17.9509 15.3126C16.9002 16.8852 15.4067 18.1108 13.6594 18.8346C11.9121 19.5584 9.9894 19.7477 8.13445 19.3788C6.27951 19.0098 4.57564 18.099 3.2383 16.7617C1.90096 15.4244 0.990216 13.7205 0.621245 11.8656C0.252274 10.0106 0.441643 8.08791 1.16541 6.34059C1.88917 4.59327 3.11482 3.09981 4.68736 2.04907C6.25991 0.998331 8.10872 0.4375 10 0.4375C12.5352 0.440477 14.9658 1.44891 16.7584 3.24158C18.5511 5.03425 19.5595 7.46478 19.5625 10ZM18.4375 10C18.4375 8.33122 17.9427 6.69992 17.0155 5.31238C16.0884 3.92484 14.7706 2.84338 13.2289 2.20477C11.6871 1.56615 9.99064 1.39906 8.35393 1.72462C6.71722 2.05019 5.2138 2.85378 4.03379 4.03379C2.85379 5.21379 2.05019 6.71721 1.72463 8.35393C1.39907 9.99064 1.56616 11.6871 2.20477 13.2289C2.84338 14.7706 3.92484 16.0884 5.31238 17.0155C6.69992 17.9426 8.33122 18.4375 10 18.4375C12.237 18.435 14.3817 17.5453 15.9635 15.9635C17.5453 14.3817 18.435 12.237 18.4375 10Z";
const TooltipIcon = ({
  tooltipText,
  iconClass = "help-content__icon"
}) => {
  if (!tooltipText) return null;
  const titleText = tooltipText.replace(/<[^>]*>/g, "").trim();
  return u$1("div", {
    className: `${iconClass} block cursor-help inline-block relative`,
    title: titleText,
    style: {
      width: "24px",
      height: "24px"
    },
    children: u$1("magnet-element", {
      className: "block",
      "data-magnet": "0",
      style: {
        width: "24px",
        height: "24px"
      },
      children: u$1("div", {
        className: "cursor-help inline-block relative",
        title: titleText,
        children: [u$1("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          children: u$1("path", {
            d: QUESTION_MARK_PATH,
            fill: "#051719"
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 23,
            columnNumber: 13
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$7,
          lineNumber: 22,
          columnNumber: 11
        }, void 0), u$1("span", {
          className: "tooltip opacity-0 text-xs rounded-full z-10",
          dangerouslySetInnerHTML: {
            __html: tooltipText
          }
        }, void 0, false, {
          fileName: _jsxFileName$7,
          lineNumber: 25,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$7,
        lineNumber: 21,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$7,
      lineNumber: 20,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName$7,
    lineNumber: 14,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$6 = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/SecondarySwatches/SecondarySwatches.tsx";
const SecondarySwatches = ({
  swatchValues = null,
  productFormId = null,
  optionName = null,
  preSelect = null,
  relatedOptions = null,
  relatedOptionsName = null,
  helpContent = null,
  tooltipHandleMap = null,
  roomlePatternMapping = null,
  roomleFinishMapping = null,
  primaryAttrName = null,
  secondaryAttrName = null,
  swatchValueTranslations = null,
  shopLocale = null
}) => {
  const [productData, setProductData] = t$3(d({}), "productData");
  const [loadingProducts, setLoadingProducts] = t$3(d(false), "loadingProducts");
  const [selectedSwatches, setSelectedSwatches] = t$3(d(/* @__PURE__ */ new Set()), "selectedSwatches");
  const [selectedRelatedOptions, setSelectedRelatedOptions] = t$3(d(/* @__PURE__ */ new Set()), "selectedRelatedOptions");
  const [relatedOptionsBaseSwatch, setRelatedOptionsBaseSwatch] = t$3(d(""), "relatedOptionsBaseSwatch");
  const [selectedValueText, setSelectedValueText] = t$3(d(""), "selectedValueText");
  const [selectedRelatedText, setSelectedRelatedText] = t$3(d(""), "selectedRelatedText");
  const [componentId] = t$3(d(() => `secondary-swatches-${Math.random().toString(36).substr(2, 9)}`), "componentId");
  const [hasPreSelected, setHasPreSelected] = t$3(d(false), "hasPreSelected");
  const [disabledSwatches, setDisabledSwatches] = t$3(d(/* @__PURE__ */ new Set()), "disabledSwatches");
  const [disabledRelatedOptions, setDisabledRelatedOptions] = t$3(d(/* @__PURE__ */ new Set()), "disabledRelatedOptions");
  const [selectedStanding, setSelectedStanding] = t$3(d(null), "selectedStanding");
  const translationsArray = t$3(T$1(() => {
    if (!swatchValueTranslations) return [];
    try {
      const parsed = JSON.parse(swatchValueTranslations);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }, [swatchValueTranslations]), "translationsArray: SwatchValueTranslation[]");
  const getTranslatedValue = (value) => {
    if (!value || (translationsArray == null ? void 0 : translationsArray.length) === 0) return value;
    const normalizedValue = value.toLowerCase();
    const translation = translationsArray == null ? void 0 : translationsArray.find((t2) => {
      var _a;
      return ((_a = t2.english_swatch_value) == null ? void 0 : _a.toLowerCase()) === normalizedValue;
    });
    if (!translation) return value;
    const locale = (shopLocale == null ? void 0 : shopLocale.toLowerCase()) || "en";
    switch (locale) {
      case "fr":
        return translation.french_translation || value;
      case "de":
        return translation.german_translation || value;
      case "it":
        return translation.italian_translation || value;
      case "es":
        return translation.spanish_translation || value;
      case "en":
      default:
        return value;
    }
  };
  const toEnglishDisplayValue = (value) => {
    if (!value || !(translationsArray == null ? void 0 : translationsArray.length)) return value;
    const lower = value.toLowerCase();
    for (const t2 of translationsArray) {
      const candidates = [t2.french_translation, t2.german_translation, t2.italian_translation, t2.spanish_translation];
      for (const candidate of candidates) {
        if (candidate && candidate.toLowerCase() === lower) {
          return t2.english_swatch_value;
        }
      }
    }
    return value;
  };
  const swatchValuesArray = t$3(T$1(() => {
    if (!swatchValues) return [];
    return JSON.parse(swatchValues);
  }, [swatchValues]), "swatchValuesArray: SecondarySwatchItem[]");
  const relatedOptionsArray = relatedOptions ? JSON.parse(relatedOptions) : [];
  const patternMapping = roomlePatternMapping ? JSON.parse(roomlePatternMapping) : {};
  const finishMapping = roomleFinishMapping ? JSON.parse(roomleFinishMapping) : {};
  const isPatternOption = optionName && (["pattern", "muster", "motif", "wzór", "model", "motivo", "front", "devant", "delantero", "przód"].some((term) => optionName.toLowerCase().includes(term.toLowerCase())) || optionName.toLowerCase().includes("panel-") && ["pattern", "muster", "motif", "wzór", "model", "motivo", "front", "devant", "delantero", "przód"].some((term) => optionName.toLowerCase().includes(term.toLowerCase())));
  const isFinishRelatedOption = relatedOptionsName && (["finish", "oberfläche", "oberflache", "finition", "wykończenie", "finisaj", "finitura", "superficie", "finalizar", "wykończenie"].some((term) => relatedOptionsName.toLowerCase().includes(term.toLowerCase())) || relatedOptionsName.toLowerCase().includes("panel-") && ["finish", "oberfläche", "oberflache", "finition", "wykończenie", "finisaj", "finitura", "superficie", "finalizar", "wykończenie"].some((term) => relatedOptionsName.toLowerCase().includes(term.toLowerCase())));
  const helpContentLookup = t$3(T$1(() => parseHelpContent(helpContent), [helpContent]), "helpContentLookup");
  const parsedTooltipHandleMap = t$3(T$1(() => {
    if (!tooltipHandleMap) return {};
    try {
      return JSON.parse(tooltipHandleMap);
    } catch {
      return {};
    }
  }, [tooltipHandleMap]), "parsedTooltipHandleMap");
  const getExtrasKey = (extras) => {
    if (!extras) return "";
    return Array.isArray(extras) ? extras[0] || "" : extras;
  };
  const hasValidExtras = (swatch) => {
    if (swatch.handle && swatch.handle.toLowerCase() === "none") return true;
    if (!swatch.extras) return false;
    if (typeof swatch.extras === "string") {
      return swatch.extras.includes("Product/");
    }
    if (Array.isArray(swatch.extras) && swatch.extras.length > 0) {
      const firstExtra = swatch.extras[0];
      return typeof firstExtra === "string" && firstExtra.includes("Product/");
    }
    return false;
  };
  const getRoomlePatternValue = (productTitle) => {
    if (!isPatternOption || !patternMapping) return "";
    if (patternMapping[productTitle]) {
      return patternMapping[productTitle];
    }
    const sortedPatterns = Object.entries(patternMapping).sort(([a2], [b2]) => b2.length - a2.length);
    for (const [patternName, roomleValue] of sortedPatterns) {
      if (productTitle.toLowerCase().includes(patternName.toLowerCase())) {
        return roomleValue;
      }
    }
    return "";
  };
  const getRoomleFinishValue = (optionName2) => {
    if (!isFinishRelatedOption || !finishMapping) return "";
    if (finishMapping[optionName2]) {
      return finishMapping[optionName2];
    }
    for (const [finishName, roomleValue] of Object.entries(finishMapping)) {
      if (optionName2.toLowerCase().includes(finishName.toLowerCase())) {
        return roomleValue;
      }
    }
    return "";
  };
  const isNoPlatePattern = (product) => {
    if (!(product == null ? void 0 : product.title)) return false;
    const englishName = toEnglishDisplayValue(formatName(product.title)).toLowerCase();
    return englishName.includes("no plate") || englishName.includes("fabric only");
  };
  const isNoFinishOption = (option) => {
    return getRoomleFinishValue(option.name || "") === "";
  };
  const isBackplateOnlyPattern = (product) => {
    if (!isPatternOption || !(product == null ? void 0 : product.title)) return false;
    const englishName = toEnglishDisplayValue(formatName(product.title)).toLowerCase();
    return englishName.includes("backplate only");
  };
  const isWallMountStanding = (selectedStanding == null ? void 0 : selectedStanding.toLowerCase()) === "wallmount";
  const isFreestandStanding = (selectedStanding == null ? void 0 : selectedStanding.toLowerCase()) === "freestand";
  const isPatternBlockedByStanding = (product) => {
    if (isWallMountStanding && isBackplateOnlyPattern(product)) return true;
    if (isFreestandStanding && isNoPlatePattern(product)) return true;
    return false;
  };
  const getSelectedStandingValue = () => {
    const labels = document.querySelectorAll("[data-roomle-standing]");
    for (const label of Array.from(labels)) {
      const forId = label.getAttribute("for");
      const input = forId ? document.getElementById(forId) : null;
      if (input == null ? void 0 : input.checked) {
        return label.getAttribute("data-roomle-standing");
      }
    }
    return null;
  };
  const shouldPreSelect = preSelect === "true";
  const filteredSwatchValues = swatchValuesArray.filter(hasValidExtras);
  const groupedSwatches = optionName ? {
    [optionName]: filteredSwatchValues
  } : {
    "accessories": filteredSwatchValues
  };
  const groupedRelatedOptions = relatedOptions && relatedOptionsName ? {
    [relatedOptionsName]: relatedOptionsArray
  } : {};
  const getSwatchId = (optionName2, swatch, index) => {
    const extrasKey = getExtrasKey(swatch.extras);
    if (extrasKey) {
      const productId = extrasKey.split("/").pop() || "";
      return productId || index.toString();
    }
    return index.toString();
  };
  const getRelatedOptionId = (optionName2, option, index) => {
    return `related-${option.name || index}`;
  };
  const getTooltipText$1 = (optionName2) => {
    return getTooltipText(optionName2, helpContentLookup, parsedTooltipHandleMap, ["sound frequency"]);
  };
  const hasAvailableVariants = (productKey) => {
    const product = productData[productKey];
    if (!product || !product.variants || !product.variants.nodes) {
      return false;
    }
    return product.variants.nodes.some((variant) => variant.availableForSale);
  };
  const isSwatchDisabled = (swatchId) => {
    return disabledSwatches.has(swatchId);
  };
  const isRelatedOptionDisabled = (optionId) => {
    return disabledRelatedOptions.has(optionId);
  };
  const hasAvailableVariantsForRelatedOption = (relatedOptionName, baseProductKey) => {
    const baseProduct = productData[baseProductKey];
    if (!baseProduct || !baseProduct.variants || !baseProduct.variants.nodes) {
      return false;
    }
    let hasMatch = baseProduct.variants.nodes.some((variant) => {
      var _a;
      const hasRelatedOption = (_a = variant.selectedOptions) == null ? void 0 : _a.some((option) => option.value.toLowerCase() === relatedOptionName.toLowerCase());
      return hasRelatedOption && variant.availableForSale;
    });
    if (hasMatch) return true;
    const translationMap = {
      "buche": ["beech", "blonde", "blond"],
      "walnuss": ["walnut", "nut"],
      "graue ulme": ["gray elm", "grey elm", "elm"],
      "weiß": ["white"],
      "schwarz": ["black"],
      "black": ["black", "schwarz"]
    };
    const normalizedOptionName = relatedOptionName.toLowerCase();
    const possibleMatches = translationMap[normalizedOptionName] || [];
    return baseProduct.variants.nodes.some((variant) => {
      var _a;
      const hasRelatedOption = (_a = variant.selectedOptions) == null ? void 0 : _a.some((option) => {
        const optionValue = option.value.toLowerCase();
        return possibleMatches.some((match) => optionValue.includes(match.toLowerCase()) || match.toLowerCase().includes(optionValue));
      });
      return hasRelatedOption && variant.availableForSale;
    });
  };
  const getSelectedValueText = () => {
    if (selectedSwatches.size === 0) return "";
    const selectedSwatchId = Array.from(selectedSwatches)[0];
    for (const [optionName2, swatches] of Object.entries(groupedSwatches)) {
      for (let index = 0; index < swatches.length; index++) {
        const swatch = swatches[index];
        const swatchId = getSwatchId(optionName2, swatch, index);
        if (swatchId === selectedSwatchId) {
          const extrasKey = getExtrasKey(swatch.extras);
          const product = productData[extrasKey];
          return (product == null ? void 0 : product.title) || "";
        }
      }
    }
    return "";
  };
  const getSelectedRelatedText = () => {
    if (selectedRelatedOptions.size === 0) return "";
    const selectedOptionId = Array.from(selectedRelatedOptions)[0];
    for (const [optionName2, options] of Object.entries(groupedRelatedOptions)) {
      for (let index = 0; index < options.length; index++) {
        const option = options[index];
        const optionId = getRelatedOptionId(optionName2, option, index);
        if (optionId === selectedOptionId) {
          return option.name || "";
        }
      }
    }
    return "";
  };
  const updateLineItemProperty = (formId, propertyName, value) => {
    const productForms = [document.getElementById(formId), document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    productForms.forEach((form) => {
      const existingInputs = form == null ? void 0 : form.querySelectorAll(`input[name="properties[${propertyName}]"]`);
      existingInputs == null ? void 0 : existingInputs.forEach((input) => input.remove());
      if (value) {
        const propertyInput = document.createElement("input");
        propertyInput.type = "hidden";
        propertyInput.name = `properties[${propertyName}]`;
        propertyInput.value = formatName(value);
        form == null ? void 0 : form.appendChild(propertyInput);
      }
    });
  };
  const toggleSwatchSelection = (swatchId, optionGroupName) => {
    let selectedProduct = null;
    let previousProduct = null;
    const previousSwatchId = Array.from(selectedSwatches)[0];
    if (previousSwatchId) {
      for (const [optName, swatches] of Object.entries(groupedSwatches)) {
        for (let index = 0; index < swatches.length; index++) {
          const swatch = swatches[index];
          const loopSwatchId = getSwatchId(optName, swatch, index);
          if (loopSwatchId === previousSwatchId) {
            const extrasKey = getExtrasKey(swatch.extras);
            previousProduct = productData[extrasKey];
            break;
          }
        }
        if (previousProduct) break;
      }
    }
    for (const [optName, swatches] of Object.entries(groupedSwatches)) {
      for (let index = 0; index < swatches.length; index++) {
        const swatch = swatches[index];
        const loopSwatchId = getSwatchId(optName, swatch, index);
        if (loopSwatchId === swatchId) {
          const extrasKey = getExtrasKey(swatch.extras);
          selectedProduct = productData[extrasKey];
          break;
        }
      }
      if (selectedProduct) break;
    }
    setSelectedSwatches((prev) => {
      const newSelected = new Set(prev);
      if (newSelected.has(swatchId)) {
        return newSelected;
      } else {
        newSelected.clear();
        newSelected.add(swatchId);
        if (relatedOptionsArray.length > 0) {
          setRelatedOptionsBaseSwatch(swatchId);
          const isNoPlateSelected = isNoPlatePattern(selectedProduct);
          const wasNoPlateSelected = isNoPlatePattern(previousProduct);
          if (isNoPlateSelected) {
            for (const [optName, options] of Object.entries(groupedRelatedOptions)) {
              for (let index = 0; index < options.length; index++) {
                const option = options[index];
                if (isNoFinishOption(option)) {
                  const noFinishOptionId = getRelatedOptionId(optName, option, index);
                  setSelectedRelatedOptions(/* @__PURE__ */ new Set([noFinishOptionId]));
                  if (isFinishRelatedOption && option.name) {
                    const roomleFinishValue = getRoomleFinishValue(option.name);
                    if (roomleFinishValue) {
                      const roomleEvent = new CustomEvent("roomle-finish-update", {
                        detail: {
                          parameterName: "finish",
                          value: roomleFinishValue
                        },
                        bubbles: true
                      });
                      document.dispatchEvent(roomleEvent);
                    }
                  }
                  break;
                }
              }
            }
          } else if (wasNoPlateSelected && !isNoPlateSelected) {
            let newSwatchProductKey = "";
            for (const [optName, swatches] of Object.entries(groupedSwatches)) {
              for (let index = 0; index < swatches.length; index++) {
                const swatch = swatches[index];
                const loopSwatchId = getSwatchId(optName, swatch, index);
                if (loopSwatchId === swatchId) {
                  newSwatchProductKey = getExtrasKey(swatch.extras);
                  break;
                }
              }
              if (newSwatchProductKey) break;
            }
            const currentRelatedOptionId = Array.from(selectedRelatedOptions)[0];
            let currentSelectionIsValid = false;
            let currentSelectionIsNoFinish = false;
            if (currentRelatedOptionId) {
              for (const [optName, options] of Object.entries(groupedRelatedOptions)) {
                for (let index = 0; index < options.length; index++) {
                  const option = options[index];
                  const optionId = getRelatedOptionId(optName, option, index);
                  if (optionId === currentRelatedOptionId) {
                    currentSelectionIsNoFinish = isNoFinishOption(option);
                    if (!currentSelectionIsNoFinish && option.name && newSwatchProductKey) {
                      currentSelectionIsValid = hasAvailableVariantsForRelatedOption(option.name, newSwatchProductKey);
                    }
                    break;
                  }
                }
              }
            }
            if (currentSelectionIsNoFinish || !currentSelectionIsValid) {
              let foundOption = false;
              for (const [optName, options] of Object.entries(groupedRelatedOptions)) {
                for (let index = 0; index < options.length; index++) {
                  const option = options[index];
                  const optionId = getRelatedOptionId(optName, option, index);
                  const isNoFinish = isNoFinishOption(option);
                  const isAvailable = option.name && newSwatchProductKey ? hasAvailableVariantsForRelatedOption(option.name, newSwatchProductKey) : true;
                  if (!isNoFinish && isAvailable) {
                    setSelectedRelatedOptions(/* @__PURE__ */ new Set([optionId]));
                    if (isFinishRelatedOption && option.name) {
                      const roomleFinishValue = getRoomleFinishValue(option.name);
                      if (roomleFinishValue) {
                        const roomleEvent = new CustomEvent("roomle-finish-update", {
                          detail: {
                            parameterName: "finish",
                            value: roomleFinishValue
                          },
                          bubbles: true
                        });
                        document.dispatchEvent(roomleEvent);
                      }
                    }
                    foundOption = true;
                    break;
                  }
                }
                if (foundOption) break;
              }
            }
          }
        }
      }
      return newSelected;
    });
  };
  const toggleRelatedOptionSelection = (optionId, optionGroupName) => {
    setSelectedRelatedOptions((prev) => {
      const newSelected = new Set(prev);
      if (newSelected.has(optionId)) {
        return newSelected;
      } else {
        newSelected.clear();
        newSelected.add(optionId);
        if (isFinishRelatedOption) {
          for (const [groupName, options] of Object.entries(groupedRelatedOptions)) {
            for (let index = 0; index < options.length; index++) {
              const option = options[index];
              const currentOptionId = getRelatedOptionId(groupName, option, index);
              if (currentOptionId === optionId && option.name) {
                const roomleFinishValue = getRoomleFinishValue(option.name);
                if (roomleFinishValue) {
                  const roomleEvent = new CustomEvent("roomle-finish-update", {
                    detail: {
                      parameterName: "finish",
                      value: roomleFinishValue
                    },
                    bubbles: true
                  });
                  document.dispatchEvent(roomleEvent);
                }
                break;
              }
            }
          }
        }
      }
      return newSelected;
    });
  };
  const formatName = (name) => {
    if (name.includes(": ")) {
      return name.split(": ")[1];
    }
    return name;
  };
  y(() => {
    if (filteredSwatchValues.length > 0) {
      fetchAllProductData(filteredSwatchValues, setProductData, setLoadingProducts);
    } else {
      setLoadingProducts(false);
    }
  }, [swatchValues]);
  y(() => {
    if (Object.keys(productData).length > 0) {
      const newDisabledSwatches = /* @__PURE__ */ new Set();
      for (const [optionName2, swatches] of Object.entries(groupedSwatches)) {
        swatches.forEach((swatch, index) => {
          const extrasKey = getExtrasKey(swatch.extras);
          const swatchId = getSwatchId(optionName2, swatch, index);
          const product = productData[extrasKey];
          if (extrasKey && !hasAvailableVariants(extrasKey)) {
            newDisabledSwatches.add(swatchId);
          } else if (isPatternBlockedByStanding(product)) {
            newDisabledSwatches.add(swatchId);
          }
        });
      }
      setDisabledSwatches(newDisabledSwatches);
    }
  }, [productData, groupedSwatches, isWallMountStanding, isFreestandStanding]);
  y(() => {
    const updateStanding = () => setSelectedStanding(getSelectedStandingValue());
    updateStanding();
    document.addEventListener("change", updateStanding);
    return () => document.removeEventListener("change", updateStanding);
  }, []);
  y(() => {
    if (Object.keys(productData).length === 0) return;
    const currentSwatchId = Array.from(selectedSwatches)[0];
    if (!currentSwatchId) return;
    let currentProduct = null;
    for (const [optName, swatches] of Object.entries(groupedSwatches)) {
      for (let index = 0; index < swatches.length; index++) {
        const swatch = swatches[index];
        if (getSwatchId(optName, swatch, index) === currentSwatchId) {
          currentProduct = productData[getExtrasKey(swatch.extras)];
          break;
        }
      }
      if (currentProduct) break;
    }
    if (!isPatternBlockedByStanding(currentProduct)) return;
    const currentIsNoPlates = isNoPlatePattern(currentProduct) || isBackplateOnlyPattern(currentProduct);
    if (currentIsNoPlates) {
      for (const [optName, swatches] of Object.entries(groupedSwatches)) {
        for (let index = 0; index < swatches.length; index++) {
          const swatch = swatches[index];
          const extrasKey = getExtrasKey(swatch.extras);
          const product = productData[extrasKey];
          const isAvailable = extrasKey ? hasAvailableVariants(extrasKey) : true;
          const targetIsNoPlates = isNoPlatePattern(product) || isBackplateOnlyPattern(product);
          if (isAvailable && !isPatternBlockedByStanding(product) && targetIsNoPlates) {
            toggleSwatchSelection(getSwatchId(optName, swatch, index));
            return;
          }
        }
      }
    }
    for (const [optName, swatches] of Object.entries(groupedSwatches)) {
      for (let index = 0; index < swatches.length; index++) {
        const swatch = swatches[index];
        const extrasKey = getExtrasKey(swatch.extras);
        const product = productData[extrasKey];
        const isAvailable = extrasKey ? hasAvailableVariants(extrasKey) : true;
        if (isAvailable && !isPatternBlockedByStanding(product)) {
          toggleSwatchSelection(getSwatchId(optName, swatch, index));
          if (isPatternOption && (product == null ? void 0 : product.title)) {
            document.dispatchEvent(new CustomEvent("roomle-finish-update", {
              detail: {
                parameterName: "pattern",
                value: getRoomlePatternValue(product.title)
              },
              bubbles: true
            }));
          }
          return;
        }
      }
    }
  }, [isWallMountStanding, isFreestandStanding, productData, selectedSwatches, groupedSwatches]);
  y(() => {
    if (Object.keys(productData).length > 0 && relatedOptionsBaseSwatch && relatedOptionsArray.length > 0) {
      const newDisabledRelatedOptions = /* @__PURE__ */ new Set();
      let baseProductKey = "";
      for (const [optionName2, swatches] of Object.entries(groupedSwatches)) {
        for (let index = 0; index < swatches.length; index++) {
          const swatch = swatches[index];
          const swatchId = getSwatchId(optionName2, swatch, index);
          if (swatchId === relatedOptionsBaseSwatch) {
            baseProductKey = getExtrasKey(swatch.extras);
            break;
          }
        }
        if (baseProductKey) break;
      }
      if (baseProductKey) {
        const noPlateSelected = isNoPlatePattern(productData[baseProductKey]);
        for (const [optionName2, options] of Object.entries(groupedRelatedOptions)) {
          options.forEach((option, index) => {
            const optionId = getRelatedOptionId(optionName2, option, index);
            const isNoFinish = isNoFinishOption(option);
            if (noPlateSelected) {
              if (!isNoFinish) {
                newDisabledRelatedOptions.add(optionId);
              }
            } else if (isNoFinish) {
              newDisabledRelatedOptions.add(optionId);
            } else if (option.name && !hasAvailableVariantsForRelatedOption(option.name, baseProductKey)) {
              newDisabledRelatedOptions.add(optionId);
            }
          });
        }
      }
      setDisabledRelatedOptions(newDisabledRelatedOptions);
    } else {
      setDisabledRelatedOptions(/* @__PURE__ */ new Set());
    }
  }, [productData, relatedOptionsBaseSwatch, groupedSwatches, groupedRelatedOptions, relatedOptionsArray]);
  y(() => {
    if (shouldPreSelect && !hasPreSelected && filteredSwatchValues.length > 0 && Object.keys(productData).length > 0 && !loadingProducts) {
      const firstOptionGroup = Object.keys(groupedSwatches)[0];
      const swatches = groupedSwatches[firstOptionGroup];
      if (swatches && firstOptionGroup) {
        let firstAvailableSwatch = null;
        let firstAvailableIndex = -1;
        for (let i2 = 0; i2 < swatches.length; i2++) {
          const swatch = swatches[i2];
          const swatchId = getSwatchId(firstOptionGroup, swatch, i2);
          if (!isSwatchDisabled(swatchId)) {
            firstAvailableSwatch = swatch;
            firstAvailableIndex = i2;
            break;
          }
        }
        if (firstAvailableSwatch && firstAvailableIndex >= 0) {
          const firstSwatchId = getSwatchId(firstOptionGroup, firstAvailableSwatch, firstAvailableIndex);
          setSelectedSwatches(/* @__PURE__ */ new Set([firstSwatchId]));
          if (relatedOptionsArray.length > 0) {
            setRelatedOptionsBaseSwatch(firstSwatchId);
          }
          setHasPreSelected(true);
        }
      }
    }
  }, [shouldPreSelect, hasPreSelected, filteredSwatchValues, productData, loadingProducts, groupedSwatches, relatedOptionsArray, disabledSwatches]);
  y(() => {
    if (shouldPreSelect && !hasPreSelected && relatedOptionsArray.length > 0 && Object.keys(groupedRelatedOptions).length > 0) {
      const firstRelatedOptionGroup = Object.keys(groupedRelatedOptions)[0];
      const relatedOptions2 = groupedRelatedOptions[firstRelatedOptionGroup];
      if (relatedOptions2 && firstRelatedOptionGroup) {
        let firstAvailableRelatedOption = null;
        let firstAvailableIndex = -1;
        for (let i2 = 0; i2 < relatedOptions2.length; i2++) {
          const relatedOption = relatedOptions2[i2];
          const relatedOptionId = getRelatedOptionId(firstRelatedOptionGroup, relatedOption, i2);
          if (!isRelatedOptionDisabled(relatedOptionId)) {
            firstAvailableRelatedOption = relatedOption;
            firstAvailableIndex = i2;
            break;
          }
        }
        if (firstAvailableRelatedOption && firstAvailableIndex >= 0) {
          const firstRelatedOptionId = getRelatedOptionId(firstRelatedOptionGroup, firstAvailableRelatedOption, firstAvailableIndex);
          setSelectedRelatedOptions(/* @__PURE__ */ new Set([firstRelatedOptionId]));
        }
      }
    }
  }, [shouldPreSelect, hasPreSelected, relatedOptionsArray, groupedRelatedOptions, disabledRelatedOptions]);
  y(() => {
    const newSelectedText = getSelectedValueText();
    setSelectedValueText(newSelectedText);
    if (productFormId && primaryAttrName) {
      updateLineItemProperty(productFormId, primaryAttrName, newSelectedText);
    }
  }, [selectedSwatches, productData, productFormId, primaryAttrName]);
  y(() => {
    const newSelectedRelatedText = getSelectedRelatedText();
    setSelectedRelatedText(newSelectedRelatedText);
    if (productFormId && secondaryAttrName) {
      updateLineItemProperty(productFormId, secondaryAttrName, newSelectedRelatedText);
    }
  }, [selectedRelatedOptions, productFormId, secondaryAttrName]);
  y(() => {
    return () => {
      if (productFormId && primaryAttrName) {
        if (optionName) {
          updateLineItemProperty(productFormId, primaryAttrName, "");
        }
        if (relatedOptionsName && secondaryAttrName) {
          updateLineItemProperty(productFormId, secondaryAttrName, "");
        }
      }
    };
  }, []);
  return u$1("div", {
    className: "secondary-swatches",
    children: u$1("div", {
      className: "secondary-swatches__content",
      children: loadingProducts ? u$1("p", {
        className: "secondary-swatches__loading",
        children: "Loading product data..."
      }, void 0, false, {
        fileName: _jsxFileName$6,
        lineNumber: 861,
        columnNumber: 11
      }, void 0) : u$1("div", {
        className: "secondary-swatches__options",
        children: [Object.keys(groupedSwatches).length > 0 ? Object.entries(groupedSwatches).map(([optionName2, swatches]) => u$1("fieldset", {
          className: "secondary-swatches__option-group variant-input-wrapper border-0",
          children: [u$1("legend", {
            className: "sr-only",
            children: optionName2
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 867,
            columnNumber: 19
          }, void 0), u$1("div", {
            className: "form__label flex items-center justify-between gap-2 w-full",
            children: [u$1("div", {
              className: "flex gap-2",
              children: [u$1("span", {
                className: "form__label-pretext",
                children: [optionName2, ":"]
              }, void 0, true, {
                fileName: _jsxFileName$6,
                lineNumber: 870,
                columnNumber: 23
              }, void 0), u$1("span", {
                className: "font-medium form__label-text",
                id: `${componentId}-${optionName2}-selected`,
                children: getTranslatedValue(formatName(selectedValueText))
              }, void 0, false, {
                fileName: _jsxFileName$6,
                lineNumber: 873,
                columnNumber: 23
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$6,
              lineNumber: 869,
              columnNumber: 21
            }, void 0), getTooltipText$1(optionName2) && u$1(TooltipIcon, {
              tooltipText: getTooltipText$1(optionName2)
            }, void 0, false, {
              fileName: _jsxFileName$6,
              lineNumber: 878,
              columnNumber: 23
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$6,
            lineNumber: 868,
            columnNumber: 19
          }, void 0), u$1("ul", {
            className: "swatches swatches--rounded flex items-start flex-wrap gap-4",
            children: swatches.map((swatch, index) => {
              const extrasKey = getExtrasKey(swatch.extras);
              const product = productData[extrasKey];
              const swatchId = getSwatchId(optionName2, swatch, index);
              const isSelected = selectedSwatches.has(swatchId);
              const isDisabled = isSwatchDisabled(swatchId);
              const isNoneSwatch = swatch.handle && swatch.handle.toLowerCase() === "none";
              return u$1("li", {
                children: u$1("div", {
                  className: "block",
                  children: product || isNoneSwatch ? u$1("div", {
                    className: `label-swatch swatches--round-slight inline-block text-sm font-medium leading-none relative px-3 py-2 border border-gray-300 rounded ${isSelected ? "selected cursor-default" : "cursor-pointer"} ${isDisabled ? "disabled" : ""}`,
                    title: getTranslatedValue(isNoneSwatch ? swatch.name || "" : formatName(product.title)),
                    onClick: () => !isSelected && !isDisabled && toggleSwatchSelection(swatchId),
                    ...isPatternOption && product && {
                      "data-roomle-pattern": getRoomlePatternValue(product.title)
                    },
                    children: getTranslatedValue(isNoneSwatch ? swatch.name || "" : formatName(product.title))
                  }, void 0, false, {
                    fileName: _jsxFileName$6,
                    lineNumber: 894,
                    columnNumber: 31
                  }, void 0) : u$1("span", {
                    className: "secondary-swatch__placeholder text-sm",
                    children: "Loading..."
                  }, void 0, false, {
                    fileName: _jsxFileName$6,
                    lineNumber: 903,
                    columnNumber: 31
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$6,
                  lineNumber: 892,
                  columnNumber: 27
                }, void 0)
              }, `${optionName2}-${index}`, false, {
                fileName: _jsxFileName$6,
                lineNumber: 891,
                columnNumber: 25
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 881,
            columnNumber: 19
          }, void 0)]
        }, optionName2, true, {
          fileName: _jsxFileName$6,
          lineNumber: 866,
          columnNumber: 17
        }, void 0)) : u$1("p", {
          className: "secondary-swatches__placeholder",
          children: ["Swatch values: ", filteredSwatchValues.length > 0 ? filteredSwatchValues.length + " items" : "None provided"]
        }, void 0, true, {
          fileName: _jsxFileName$6,
          lineNumber: 913,
          columnNumber: 15
        }, void 0), Object.keys(groupedRelatedOptions).length > 0 && Object.entries(groupedRelatedOptions).map(([optionName2, options]) => u$1("fieldset", {
          className: "secondary-swatches__option-group variant-input-wrapper border-0 mt-4",
          children: [u$1("legend", {
            className: "sr-only",
            children: optionName2
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 921,
            columnNumber: 19
          }, void 0), u$1("div", {
            className: "form__label flex items-center justify-between gap-2 w-full",
            children: [u$1("div", {
              className: "flex gap-2",
              children: [u$1("span", {
                className: "form__label-pretext",
                children: [optionName2, ":"]
              }, void 0, true, {
                fileName: _jsxFileName$6,
                lineNumber: 924,
                columnNumber: 23
              }, void 0), u$1("span", {
                className: "font-medium form__label-text",
                id: `${componentId}-related-${optionName2}-selected`,
                children: getTranslatedValue(selectedRelatedText)
              }, void 0, false, {
                fileName: _jsxFileName$6,
                lineNumber: 927,
                columnNumber: 23
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$6,
              lineNumber: 923,
              columnNumber: 21
            }, void 0), getTooltipText$1(optionName2) && u$1(TooltipIcon, {
              tooltipText: getTooltipText$1(optionName2)
            }, void 0, false, {
              fileName: _jsxFileName$6,
              lineNumber: 932,
              columnNumber: 23
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$6,
            lineNumber: 922,
            columnNumber: 19
          }, void 0), u$1("ul", {
            className: "swatches swatches--rounded flex items-start flex-wrap gap-4",
            children: options.map((option, index) => {
              const optionId = getRelatedOptionId(optionName2, option, index);
              const isSelected = selectedRelatedOptions.has(optionId);
              const isDisabled = isRelatedOptionDisabled(optionId);
              return u$1("li", {
                children: u$1("div", {
                  className: "block",
                  children: u$1("div", {
                    className: `label-swatch swatches--round-slight inline-block text-sm font-medium leading-none relative px-3 py-2 border border-gray-300 rounded ${isSelected ? "selected cursor-default" : "cursor-pointer"} ${isDisabled ? "disabled" : ""}`,
                    title: getTranslatedValue(option.name || ""),
                    onClick: () => !isSelected && !isDisabled && toggleRelatedOptionSelection(optionId),
                    ...isFinishRelatedOption && {
                      "data-roomle-finish": getRoomleFinishValue(option.name || "")
                    },
                    children: getTranslatedValue(option.name || "")
                  }, void 0, false, {
                    fileName: _jsxFileName$6,
                    lineNumber: 943,
                    columnNumber: 29
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$6,
                  lineNumber: 942,
                  columnNumber: 27
                }, void 0)
              }, `related-${optionName2}-${index}`, false, {
                fileName: _jsxFileName$6,
                lineNumber: 941,
                columnNumber: 25
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 935,
            columnNumber: 19
          }, void 0)]
        }, `related-${optionName2}`, true, {
          fileName: _jsxFileName$6,
          lineNumber: 920,
          columnNumber: 17
        }, void 0))]
      }, void 0, true, {
        fileName: _jsxFileName$6,
        lineNumber: 863,
        columnNumber: 11
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$6,
      lineNumber: 859,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName$6,
    lineNumber: 858,
    columnNumber: 5
  }, void 0);
};
register(SecondarySwatches, "secondary-swatches", ["swatchValues", "productFormId", "optionName", "preSelect", "relatedOptions", "relatedOptionsName", "roomlePatternMapping", "roomleFinishMapping", "helpContent", "tooltipHandleMap", "swatchValueTranslations", "shopLocale"]);
const _RoomleSwatchHandler = class _RoomleSwatchHandler {
  constructor() {
    this.roomleViewer = null;
    this.isInitialized = false;
    this.init();
  }
  static getInstance() {
    if (!_RoomleSwatchHandler.instance) {
      _RoomleSwatchHandler.instance = new _RoomleSwatchHandler();
    }
    return _RoomleSwatchHandler.instance;
  }
  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    document.addEventListener("roomle-custom-size-update", (event) => {
      const {
        parameterName,
        value
      } = event.detail;
      this.handleCustomSizeUpdate(parameterName, value);
    });
    document.addEventListener("roomle-finish-update", async (event) => {
      const customEvent = event;
      const {
        parameterName,
        value
      } = customEvent.detail;
      try {
        await this.updateRoomleParameter(parameterName, value);
      } catch (error) {
        console.error("❌ Error in roomle-finish-update handler:", error);
      }
    });
    document.addEventListener("click", (event) => {
      const target = event.target;
      let currentElement = target;
      let roomleFabric = null;
      let roomleFrequency = null;
      let roomleShape = null;
      let roomlePattern = null;
      let roomleFinish = null;
      let roomleSize = null;
      let roomleStanding = null;
      let roomleElement = null;
      let roomleEndCaps = null;
      let roomleFreestanding = null;
      let roomleStackHeight = null;
      for (let i2 = 0; i2 < 5 && currentElement; i2++) {
        roomleFabric = currentElement.getAttribute("data-roomle-fabric") || currentElement.getAttribute("data-roomle-color");
        roomleFrequency = currentElement.getAttribute("data-roomle-frequency");
        roomleShape = currentElement.getAttribute("data-roomle-shape");
        roomlePattern = currentElement.getAttribute("data-roomle-pattern");
        roomleFinish = currentElement.getAttribute("data-roomle-finish");
        roomleSize = currentElement.getAttribute("data-roomle-custom-size");
        roomleStanding = currentElement.getAttribute("data-roomle-standing");
        roomleEndCaps = currentElement.getAttribute("data-roomle-endcaps");
        roomleFreestanding = currentElement.getAttribute("data-roomle-freeStanding");
        roomleStackHeight = currentElement.getAttribute("data-roomle-stackheight");
        if (roomleFabric || roomleFrequency || roomleShape || roomlePattern || roomleFinish || roomleSize || roomleStanding || roomleEndCaps || roomleFreestanding || roomleStackHeight) {
          roomleElement = currentElement;
          break;
        }
        currentElement = currentElement.parentElement;
      }
      if (roomleFabric && roomleElement) {
        this.handleSwatchClick(roomleFabric, roomleElement, "fabric");
      } else if (roomleFrequency && roomleElement) {
        this.handleSwatchClick(roomleFrequency, roomleElement, "frequency");
      } else if (roomleShape && roomleElement) {
        this.handleSwatchClick(roomleShape, roomleElement, "shape");
      } else if (roomlePattern && roomleElement) {
        this.handleSwatchClick(roomlePattern, roomleElement, "pattern");
      } else if (roomleFinish && roomleElement) {
        this.handleSwatchClick(roomleFinish, roomleElement, "finish");
      } else if (roomleSize && roomleElement) {
        this.handleSwatchClick(roomleSize, roomleElement, "customSize");
      } else if (roomleStanding && roomleElement) {
        this.handleSwatchClick(roomleStanding, roomleElement, "standing");
      } else if (roomleFreestanding && roomleElement) {
        this.handleSwatchClick(roomleFreestanding, roomleElement, "freeStanding");
      } else if (roomleStackHeight && roomleElement) {
        this.handleSwatchClick(roomleStackHeight, roomleElement, "stackHeight");
      }
    });
    document.addEventListener("change", (event) => {
      const target = event.target;
      if (target.type === "radio" && target.form) {
        const label = document.querySelector(`label[for="${target.id}"]`);
        if (label) {
          const roomleFabric = label.getAttribute("data-roomle-fabric") || label.getAttribute("data-roomle-color");
          const roomleFrequency = label.getAttribute("data-roomle-frequency");
          const roomleShape = label.getAttribute("data-roomle-shape");
          const roomlePattern = label.getAttribute("data-roomle-pattern");
          const roomleFinish = label.getAttribute("data-roomle-finish");
          const roomleSize = label.getAttribute("data-roomle-custom-size");
          const roomleStanding = label.getAttribute("data-roomle-standing");
          const roomleEndCaps = label.getAttribute("data-roomle-endcaps");
          const roomleFreestanding = label.getAttribute("data-roomle-freeStanding");
          const roomleStackHeight = label.getAttribute("data-roomle-stackheight");
          if (roomleFabric) {
            this.handleSwatchClick(roomleFabric, label, "fabric");
          } else if (roomleFrequency) {
            this.handleSwatchClick(roomleFrequency, label, "frequency");
          } else if (roomleShape) {
            this.handleSwatchClick(roomleShape, label, "shape");
          } else if (roomlePattern) {
            this.handleSwatchClick(roomlePattern, label, "pattern");
          } else if (roomleFinish) {
            this.handleSwatchClick(roomleFinish, label, "finish");
          } else if (roomleSize) {
            this.handleSwatchClick(roomleSize, label, "customSize");
          } else if (roomleStanding) {
            this.handleSwatchClick(roomleStanding, label, "standing");
          } else if (roomleEndCaps) {
            this.handleSwatchClick(roomleEndCaps, label, "endCaps");
          } else if (roomleFreestanding) {
            this.handleSwatchClick(roomleFreestanding, label, "freeStanding");
          } else if (roomleStackHeight) {
            this.handleSwatchClick(roomleStackHeight, label, "stackHeight");
          }
        }
      }
    });
  }
  async handleSwatchClick(roomleValue, element, parameterType) {
    try {
      if (!this.roomleViewer) {
        this.roomleViewer = document.querySelector("roomle-viewer");
      }
      if (!this.roomleViewer) {
        console.warn("RoomleViewer not found in DOM");
        return;
      }
      await this.updateRoomleParameter(parameterType, roomleValue);
    } catch (error) {
      console.error("Error updating Roomle parameter:", error);
    }
  }
  async handleCustomSizeUpdate(parameterName, value) {
    try {
      if (!this.roomleViewer) {
        this.roomleViewer = document.querySelector("roomle-viewer");
      }
      if (!this.roomleViewer) {
        console.warn("RoomleViewer not found in DOM");
        return;
      }
      await this.updateRoomleParameter(parameterName, value);
    } catch (error) {
      console.error("Error updating Roomle custom size parameter:", error);
    }
  }
  async updateRoomleParameter(parameterName, value) {
    if (!this.roomleViewer) {
      this.roomleViewer = document.querySelector("roomle-viewer");
      if (!this.roomleViewer) {
        console.error("❌ No roomle-viewer element found in DOM");
        return;
      }
    }
    if (typeof this.roomleViewer.updateRoomleParameter === "function") {
      try {
        await this.roomleViewer.updateRoomleParameter(parameterName, value);
      } catch (error) {
        console.error("❌ Error in updateRoomleParameter:", error);
      }
      return;
    }
    const updateEvent = new CustomEvent("roomle-update-parameter", {
      detail: {
        parameterName,
        value
      },
      bubbles: true
    });
    this.roomleViewer.dispatchEvent(updateEvent);
    if (this.roomleViewer._componentInstance) {
      const component = this.roomleViewer._componentInstance;
      if (component && typeof component.updateParameter === "function") {
        try {
          await component.updateParameter(parameterName, value);
        } catch (error) {
          console.error("❌ Error in component.updateParameter:", error);
        }
      }
    }
  }
};
_RoomleSwatchHandler.instance = null;
let RoomleSwatchHandler = _RoomleSwatchHandler;
const initRoomleSwatchHandler = () => {
  return RoomleSwatchHandler.getInstance();
};
const setupRoomleDebugFunctions = (configuratorInstance, ref, parameters, currentValues, getSelectedSwatchValues, isLoading, error, updateParameterForAllComponents, forceStandingParameterRefresh) => {
  window.debugRoomleParameters = async () => {
    var _a, _b, _c, _d;
    console.group("🔧 Roomle Parameters Debug");
    try {
      const roomleViewer = document.querySelector("roomle-viewer");
      if (!roomleViewer) {
        console.error("❌ No Roomle viewer found in DOM");
        return;
      }
      if (!configuratorInstance) {
        console.error("❌ Configurator not initialized");
        return;
      }
      const parameterAPI = configuratorInstance.configurator;
      console.log("📋 Configurator API:", parameterAPI);
      try {
        const currentConfig = await configuratorInstance.getCurrentConfiguration();
        console.log("⚙️ Current Configuration:", currentConfig);
      } catch (err) {
        console.warn("⚠️ Could not get current configuration:", err);
      }
      try {
        const allParameters = await ((_b = (_a = ref.current) == null ? void 0 : _a.getParameters) == null ? void 0 : _b.call(_a));
        if (allParameters && allParameters.length > 0) {
          console.group("📊 All Available Parameters (" + allParameters.length + " total)");
          const paramGroups = {};
          allParameters.forEach((param) => {
            const group = param.type || "unknown";
            if (!paramGroups[group]) paramGroups[group] = [];
            paramGroups[group].push(param);
          });
          Object.entries(paramGroups).forEach(([type, params]) => {
            console.group(`📁 ${type.toUpperCase()} Parameters (${params.length})`);
            params.forEach((param) => {
              console.log(`🔹 ${param.key}:`, {
                value: param.value || param.currentValue,
                type: param.type,
                label: param.label,
                options: param.possibleValues || param.options,
                min: param.min,
                max: param.max,
                full: param
              });
            });
            console.groupEnd();
          });
          console.groupEnd();
        } else {
          console.warn("⚠️ No parameters found or parameters array is empty");
        }
      } catch (err) {
        console.error("❌ Error getting all parameters:", err);
      }
      try {
        if (typeof parameterAPI.getParametersOfRootComponent === "function") {
          const rootParams = await parameterAPI.getParametersOfRootComponent();
          console.group("🌿 Root Component Parameters (" + rootParams.length + ")");
          rootParams.forEach((param, index) => {
            console.log(`${index + 1}. ${param.key}:`, param);
          });
          console.groupEnd();
        }
      } catch (err) {
        console.warn("⚠️ Could not get root parameters:", err);
      }
      try {
        if (typeof parameterAPI.getParametersOfPlanObject === "function") {
          const planParams = await parameterAPI.getParametersOfPlanObject();
          if (planParams && planParams.length > 0) {
            console.group("📐 Plan Object Parameters (" + planParams.length + ")");
            planParams.forEach((param, index) => {
              console.log(`${index + 1}. ${param.key}:`, param);
            });
            console.groupEnd();
          }
        }
      } catch (err) {
        console.debug("ℹ️ No plan object parameters (this is normal for simple products)");
      }
      try {
        if (typeof parameterAPI.getPartList === "function") {
          const partList = await parameterAPI.getPartList();
          if (partList && partList.length > 0) {
            console.group("🧩 Component Parts (" + partList.length + ")");
            for (const [index, part] of partList.entries()) {
              console.log(`${index + 1}. ${part.name || part.id}:`, part);
              if (part.runtimeId && typeof parameterAPI.getParametersOfComponent === "function") {
                try {
                  const componentParams = await parameterAPI.getParametersOfComponent(part.runtimeId);
                  if (componentParams && componentParams.length > 0) {
                    console.group(`  📋 Parameters for ${part.name || part.id}`);
                    componentParams.forEach((param) => {
                      console.log(`    🔸 ${param.key}:`, param);
                    });
                    console.groupEnd();
                  }
                } catch (err) {
                  console.debug(`    ℹ️ Could not get parameters for component ${part.runtimeId}`);
                }
              }
            }
            console.groupEnd();
          }
        }
      } catch (err) {
        console.warn("⚠️ Could not get part list:", err);
      }
      console.group("🎨 Current Swatch Values");
      const swatchValues = getSelectedSwatchValues();
      if (Object.keys(swatchValues).length > 0) {
        Object.entries(swatchValues).forEach(([key, value]) => {
          const isStructural = ["standing", "mounting", "feet", "base", "support", "frame", "structure"].includes(key.toLowerCase());
          console.log(`🎯 ${key}: "${value}"${isStructural ? " (🔧 structural)" : ""}`);
        });
      } else {
        console.log("ℹ️ No swatch values currently selected");
      }
      console.groupEnd();
      console.group("🔧 Structural Parameter Analysis");
      try {
        const allParametersForAnalysis = await ((_d = (_c = ref.current) == null ? void 0 : _c.getParameters) == null ? void 0 : _d.call(_c)) || [];
        const structuralParams = allParametersForAnalysis == null ? void 0 : allParametersForAnalysis.filter((param) => {
          var _a2;
          return ["standing", "mounting", "feet", "base", "support", "frame", "structure"].includes((_a2 = param.key) == null ? void 0 : _a2.toLowerCase());
        });
        if (structuralParams && structuralParams.length > 0) {
          console.log("📋 Found structural parameters:");
          structuralParams.forEach((param) => {
            console.log(`🔧 ${param.key}:`, {
              currentValue: param.value || param.currentValue,
              validValues: param.validValues || param.possibleValues,
              type: param.type,
              source: param.source,
              label: param.label
            });
          });
          console.group("🔄 Available Refresh Methods");
          const refreshMethods = ["updateScene", "refreshScene", "rebuild", "rebuildScene", "updateVisuals", "refresh", "rebuildGeometry", "updateGeometry", "forceRebuild", "resetScene", "reloadConfiguration"];
          refreshMethods.forEach((method) => {
            const available = typeof parameterAPI[method] === "function";
            console.log(`${available ? "✅" : "❌"} ${method}`);
          });
          console.groupEnd();
        } else {
          console.log("ℹ️ No structural parameters detected");
        }
      } catch (err) {
        console.warn("⚠️ Could not analyze structural parameters:", err);
      }
      console.groupEnd();
      console.group("📊 Component State");
      console.log("🔄 Current Values:", currentValues);
      console.log("📋 Stored Parameters:", parameters);
      console.log("🏗️ Configurator Instance:", configuratorInstance);
      console.log("⚡ Is Loading:", isLoading);
      console.log("🚫 Error:", error);
      console.groupEnd();
      console.log("✅ Debug complete! All available parameter information has been logged above.");
    } catch (err) {
      console.error("❌ Error in debugRoomleParameters:", err);
    }
    console.groupEnd();
  };
  window.debugStandingParameter = async () => {
    console.group("🦵 Standing Parameter Debug");
    try {
      if (!configuratorInstance) {
        console.error("❌ Configurator not initialized");
        return;
      }
      const parameterAPI = configuratorInstance.configurator;
      try {
        const currentConfig = await configuratorInstance.getCurrentConfiguration();
        console.log("⚙️ Current Configuration:", currentConfig);
      } catch (err) {
        console.warn("⚠️ Could not get configuration:", err);
      }
      console.group("🔍 Standing Parameter Search");
      try {
        const planParams = await parameterAPI.getParametersOfPlanObject();
        const standingPlanParam = planParams == null ? void 0 : planParams.find((p2) => p2.key === "standing");
        if (standingPlanParam) {
          console.log("📐 Found standing parameter in plan object:", standingPlanParam);
        } else {
          console.log("ℹ️ No standing parameter in plan object");
        }
      } catch (err) {
        console.debug("ℹ️ No plan object or plan parameters");
      }
      try {
        const rootParams = await parameterAPI.getParametersOfRootComponent();
        const standingRootParam = rootParams == null ? void 0 : rootParams.find((p2) => p2.key === "standing");
        if (standingRootParam) {
          console.log("🌿 Found standing parameter in root component:", standingRootParam);
        } else {
          console.log("ℹ️ No standing parameter in root component");
        }
      } catch (err) {
        console.warn("⚠️ Could not get root parameters:", err);
      }
      console.groupEnd();
      console.group("🧪 Test Standing Parameter Updates");
      const testUpdate = async (value) => {
        console.log(`
🔄 Testing update to "${value}"`);
        const expectedBehavior = value.toLowerCase() === "freestand" ? "(should ADD feet with aggressive refresh)" : "(should REMOVE feet with original logic - no additional refresh)";
        console.log(`🎯 Expected behavior: ${expectedBehavior}`);
        try {
          await updateParameterForAllComponents(parameterAPI, "standing", value);
          await new Promise((resolve) => setTimeout(resolve, 500));
          try {
            const planParams = await parameterAPI.getParametersOfPlanObject();
            const standingParam = planParams == null ? void 0 : planParams.find((p2) => p2.key === "standing");
            if (standingParam) {
              console.log(`✅ Plan object standing value after update: "${standingParam.value}"`);
            }
          } catch (err) {
            try {
              const rootParams = await parameterAPI.getParametersOfRootComponent();
              const standingParam = rootParams == null ? void 0 : rootParams.find((p2) => p2.key === "standing");
              if (standingParam) {
                console.log(`✅ Root component standing value after update: "${standingParam.value}"`);
              }
            } catch (rootErr) {
              console.warn("⚠️ Could not verify parameter value after update");
            }
          }
        } catch (err) {
          console.error(`❌ Failed to update standing to "${value}":`, err);
        }
      };
      console.log("📝 Instructions: This will test switching between freestand and wallmount");
      console.log("🎯 Watch the 3D model to see if feet appear/disappear correctly");
      console.log("🔧 Use these commands to test:");
      console.log("  window.testStandingFreestand() - Switch to freestand");
      console.log("  window.testStandingWallmount() - Switch to wallmount");
      window.testStandingFreestand = () => testUpdate("freestand");
      window.testStandingWallmount = () => testUpdate("wallmount");
      window.testAggressiveRefresh = async () => {
        console.log("🚀 Testing aggressive refresh for standing parameter...");
        try {
          await forceStandingParameterRefresh(parameterAPI, "freestand");
          console.log("✅ Aggressive refresh test completed");
        } catch (err) {
          console.error("❌ Aggressive refresh test failed:", err);
        }
      };
      console.log("  window.testAggressiveRefresh() - Test aggressive geometry refresh");
      console.groupEnd();
    } catch (err) {
      console.error("❌ Error in debugStandingParameter:", err);
    }
    console.groupEnd();
  };
};
const cleanupRoomleDebugFunctions = () => {
  delete window.debugRoomleParameters;
  delete window.debugStandingParameter;
  delete window.testStandingFreestand;
  delete window.testStandingWallmount;
  delete window.testAggressiveRefresh;
};
const getRoomleUIConfig = () => ({
  locale: "en",
  showHints: false,
  showShare: false,
  showPrice: false,
  showBranding: false,
  showConfiguration: false,
  showSettings: false,
  showAR: false,
  showFullscreen: false,
  showHelp: false,
  hideInteractionPopup: true,
  buttons: {
    savedraft: false,
    requestproduct: false,
    startconfigure: false,
    "2dview": false,
    "3dview": false,
    add_measurement_line: false,
    add_room: false,
    add_to_basket: false,
    addons: false,
    ar: false,
    close_view: false,
    configure_in_room: false,
    dimensions: false,
    export3d: false,
    firstperson: false,
    fullscreen: false,
    help_center: false,
    load_product: false,
    multiselect: false,
    partlist: false,
    partlist_planner: false,
    partlist_print: false,
    pauseconfigure: false,
    productlist: false,
    redo: false,
    renderimage: false,
    requestplan: false,
    resetcamera: false,
    rotate: false,
    snapping: false,
    startPlanner: false,
    swap_product: false,
    undo: false,
    view_mode: false
  },
  notifications: {
    "first-person-controls": false,
    interaction: {
      "add-element": false,
      "confirm-ghosts": false,
      "parameters-changed": false,
      "root-element": false
    },
    "load-idb-config": false,
    "stop-configure-hint": false
  },
  interactionsCollapsed: true,
  elements: {
    bottom_bar: false,
    moc: true,
    interaction_notes: false,
    parameter_groups: false,
    partlist_bounds: false
  },
  roomDesignerActive: false
});
var _jsxFileName$5 = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/Roomle/RoomleViewerDebugPanel.tsx";
const cell = {
  border: "1px solid #ddd",
  padding: "4px 8px",
  textAlign: "left",
  verticalAlign: "top",
  fontSize: "12px"
};
const th = {
  ...cell,
  background: "#f2f2f2",
  fontWeight: 700
};
const mono = {
  fontFamily: "monospace",
  fontSize: "12px",
  wordBreak: "break-all"
};
const RoomleViewerDebugPanel = ({
  configuratorInstance,
  parameters,
  currentValues,
  getSelectedSwatchValues,
  updateParameter,
  productId,
  catalogId,
  configuratorId
}) => {
  const [isMinimized, setIsMinimized] = t$3(d(false), "isMinimized");
  const [liveParams, setLiveParams] = t$3(d(null), "liveParams");
  const [currentConfig, setCurrentConfig] = t$3(d(null), "currentConfig");
  const [isFetching, setIsFetching] = t$3(d(false), "isFetching");
  const [manualKey, setManualKey] = t$3(d(""), "manualKey");
  const [manualValue, setManualValue] = t$3(d(""), "manualValue");
  const [manualStatus, setManualStatus] = t$3(d(null), "manualStatus");
  const swatchValues = getSelectedSwatchValues();
  const fetchLiveParams = q$1(async () => {
    if (!configuratorInstance) return;
    setIsFetching(true);
    try {
      const parameterAPI = configuratorInstance.configurator;
      const all = [];
      if (typeof (parameterAPI == null ? void 0 : parameterAPI.getParametersOfRootComponent) === "function") {
        const root = await parameterAPI.getParametersOfRootComponent();
        root.forEach((p2) => all.push({
          ...p2,
          _source: "root"
        }));
      }
      if (typeof (parameterAPI == null ? void 0 : parameterAPI.getParametersOfPlanObject) === "function") {
        try {
          const plan = await parameterAPI.getParametersOfPlanObject();
          plan == null ? void 0 : plan.forEach((p2) => {
            if (!all.find((x2) => x2.key === p2.key)) all.push({
              ...p2,
              _source: "plan"
            });
          });
        } catch (_2) {
        }
      }
      if (typeof (parameterAPI == null ? void 0 : parameterAPI.getPartList) === "function") {
        try {
          const parts = await parameterAPI.getPartList();
          for (const part of parts ?? []) {
            if (part.runtimeId && typeof parameterAPI.getParametersOfComponent === "function") {
              try {
                const cp = await parameterAPI.getParametersOfComponent(part.runtimeId);
                cp == null ? void 0 : cp.forEach((p2) => {
                  if (!all.find((x2) => x2.key === p2.key)) all.push({
                    ...p2,
                    _source: `component:${part.name ?? part.runtimeId}`
                  });
                });
              } catch (_2) {
              }
            }
          }
        } catch (_2) {
        }
      }
      setLiveParams(all);
      try {
        const cfg = await configuratorInstance.getCurrentConfiguration();
        setCurrentConfig(typeof cfg === "string" ? cfg : JSON.stringify(cfg, null, 2));
      } catch (_2) {
        setCurrentConfig(null);
      }
    } finally {
      setIsFetching(false);
    }
  }, [configuratorInstance]);
  const handleManualUpdate = async () => {
    if (!manualKey || !manualValue) return;
    setManualStatus("Updating…");
    try {
      await updateParameter(manualKey.trim(), manualValue.trim());
      setManualStatus(`✅ Set ${manualKey} = ${manualValue}`);
    } catch (err) {
      setManualStatus(`❌ Failed: ${err}`);
    }
  };
  const displayParams = liveParams ?? parameters;
  return u$1("div", {
    style: {
      position: "fixed",
      bottom: "16px",
      left: "16px",
      zIndex: 99999,
      width: isMinimized ? "auto" : "700px",
      maxHeight: isMinimized ? "auto" : "50vh",
      background: "#fff",
      border: "2px solid #333",
      borderRadius: "8px",
      boxShadow: "0 4px 24px rgba(0,0,0,0.3)",
      display: "flex",
      flexDirection: "column",
      fontSize: "13px",
      color: "#111"
    },
    children: [u$1("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 12px",
        background: "#1a1a2e",
        color: "#fff",
        borderRadius: isMinimized ? "6px" : "6px 6px 0 0",
        cursor: "pointer",
        userSelect: "none"
      },
      onClick: () => setIsMinimized((v2) => !v2),
      children: [u$1("span", {
        style: {
          fontWeight: 700,
          fontFamily: "monospace"
        },
        children: ["🔧 Roomle Debug ", isMinimized ? "▲" : "▼"]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 126,
        columnNumber: 9
      }, void 0), u$1("span", {
        style: {
          fontSize: "11px",
          opacity: 0.7
        },
        children: configuratorInstance ? "✅ ready" : "⏳ loading"
      }, void 0, false, {
        fileName: _jsxFileName$5,
        lineNumber: 129,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$5,
      lineNumber: 112,
      columnNumber: 7
    }, void 0), !isMinimized && u$1("div", {
      style: {
        overflow: "auto",
        padding: "12px",
        display: "flex",
        flexDirection: "column",
        gap: "16px"
      },
      children: [u$1("div", {
        style: {
          background: "#f0f4ff",
          border: "1px solid #c0d0ff",
          borderRadius: "4px",
          padding: "8px 10px"
        },
        children: [u$1("div", {
          style: {
            ...mono,
            fontSize: "11px",
            color: "#555",
            marginBottom: "2px"
          },
          children: "loaded product"
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 139,
          columnNumber: 13
        }, void 0), u$1("div", {
          style: {
            ...mono,
            fontWeight: 700,
            fontSize: "13px"
          },
          children: [catalogId, ":", productId]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 140,
          columnNumber: 13
        }, void 0), u$1("div", {
          style: {
            ...mono,
            fontSize: "11px",
            color: "#777",
            marginTop: "2px"
          },
          children: ["configurator: ", configuratorId]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 141,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 138,
        columnNumber: 11
      }, void 0), u$1("div", {
        style: {
          display: "flex",
          gap: "8px",
          alignItems: "center"
        },
        children: [u$1("button", {
          onClick: fetchLiveParams,
          disabled: isFetching || !configuratorInstance,
          style: {
            padding: "6px 14px",
            cursor: "pointer",
            fontWeight: 600
          },
          children: isFetching ? "Fetching…" : "Fetch live params"
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 146,
          columnNumber: 13
        }, void 0), liveParams && u$1("span", {
          style: {
            ...mono,
            color: "#555"
          },
          children: [liveParams.length, " param(s) found"]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 154,
          columnNumber: 15
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 145,
        columnNumber: 11
      }, void 0), displayParams.length > 0 && u$1("div", {
        children: [u$1("h4", {
          style: {
            margin: "0 0 6px",
            fontSize: "13px"
          },
          children: ["Parameters ", liveParams ? "(live)" : "(initial snapshot)"]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 161,
          columnNumber: 15
        }, void 0), u$1("table", {
          style: {
            borderCollapse: "collapse",
            width: "100%"
          },
          children: [u$1("thead", {
            children: u$1("tr", {
              children: [u$1("th", {
                style: th,
                children: "key"
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 167,
                columnNumber: 21
              }, void 0), u$1("th", {
                style: th,
                children: "value"
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 168,
                columnNumber: 21
              }, void 0), u$1("th", {
                style: th,
                children: "source"
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 169,
                columnNumber: 21
              }, void 0), u$1("th", {
                style: th,
                children: "possible values"
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 170,
                columnNumber: 21
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$5,
              lineNumber: 166,
              columnNumber: 19
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 165,
            columnNumber: 17
          }, void 0), u$1("tbody", {
            children: displayParams.map((p2, i2) => {
              var _a;
              return u$1("tr", {
                style: {
                  background: i2 % 2 === 0 ? "#fafafa" : "#fff"
                },
                children: [u$1("td", {
                  style: {
                    ...cell,
                    ...mono
                  },
                  children: p2.key
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 176,
                  columnNumber: 23
                }, void 0), u$1("td", {
                  style: {
                    ...cell,
                    ...mono,
                    fontWeight: 600,
                    color: "#0066cc"
                  },
                  children: p2.value ?? p2.currentValue ?? "—"
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 177,
                  columnNumber: 23
                }, void 0), u$1("td", {
                  style: {
                    ...cell,
                    ...mono,
                    color: "#888",
                    fontSize: "11px"
                  },
                  children: p2._source ?? (currentValues[p2.key] ? "state" : "—")
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 180,
                  columnNumber: 23
                }, void 0), u$1("td", {
                  style: {
                    ...cell,
                    fontSize: "11px"
                  },
                  children: ((_a = p2.possibleValues ?? p2.validValues ?? p2.options) == null ? void 0 : _a.map((v2) => typeof v2 === "object" ? v2.key ?? v2.value ?? JSON.stringify(v2) : v2).join(", ")) ?? "—"
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 183,
                  columnNumber: 23
                }, void 0)]
              }, i2, true, {
                fileName: _jsxFileName$5,
                lineNumber: 175,
                columnNumber: 21
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 173,
            columnNumber: 17
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 164,
          columnNumber: 15
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 160,
        columnNumber: 13
      }, void 0), u$1("div", {
        children: [u$1("h4", {
          style: {
            margin: "0 0 6px",
            fontSize: "13px"
          },
          children: "DOM swatch values"
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 197,
          columnNumber: 13
        }, void 0), Object.keys(swatchValues).length > 0 ? u$1("table", {
          style: {
            borderCollapse: "collapse",
            width: "100%"
          },
          children: [u$1("thead", {
            children: u$1("tr", {
              children: [u$1("th", {
                style: th,
                children: "key"
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 202,
                columnNumber: 21
              }, void 0), u$1("th", {
                style: th,
                children: "value"
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 203,
                columnNumber: 21
              }, void 0), u$1("th", {
                style: th,
                children: "in currentValues?"
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 204,
                columnNumber: 21
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$5,
              lineNumber: 201,
              columnNumber: 19
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 200,
            columnNumber: 17
          }, void 0), u$1("tbody", {
            children: Object.entries(swatchValues).map(([k2, v2], i2) => u$1("tr", {
              style: {
                background: i2 % 2 === 0 ? "#fafafa" : "#fff"
              },
              children: [u$1("td", {
                style: {
                  ...cell,
                  ...mono
                },
                children: k2
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 210,
                columnNumber: 23
              }, void 0), u$1("td", {
                style: {
                  ...cell,
                  ...mono,
                  color: "#0066cc"
                },
                children: v2
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 211,
                columnNumber: 23
              }, void 0), u$1("td", {
                style: cell,
                children: currentValues[k2] === v2 ? "✅ match" : currentValues[k2] ? `⚠️ ${currentValues[k2]}` : "—"
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 212,
                columnNumber: 23
              }, void 0)]
            }, i2, true, {
              fileName: _jsxFileName$5,
              lineNumber: 209,
              columnNumber: 21
            }, void 0))
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 207,
            columnNumber: 17
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 199,
          columnNumber: 15
        }, void 0) : u$1("p", {
          style: {
            ...mono,
            color: "#888",
            margin: 0
          },
          children: "No swatch values selected"
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 220,
          columnNumber: 15
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 196,
        columnNumber: 11
      }, void 0), u$1("div", {
        children: [u$1("h4", {
          style: {
            margin: "0 0 6px",
            fontSize: "13px"
          },
          children: "Manual parameter update"
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 226,
          columnNumber: 13
        }, void 0), u$1("div", {
          style: {
            display: "flex",
            gap: "6px",
            flexWrap: "wrap"
          },
          children: [u$1("input", {
            type: "text",
            placeholder: "key (e.g. fabric)",
            value: manualKey,
            onInput: (e2) => setManualKey(e2.target.value),
            style: {
              ...mono,
              flex: "1",
              minWidth: "120px",
              padding: "4px 8px",
              border: "1px solid #ccc",
              borderRadius: "4px"
            }
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 228,
            columnNumber: 15
          }, void 0), u$1("input", {
            type: "text",
            placeholder: "value",
            value: manualValue,
            onInput: (e2) => setManualValue(e2.target.value),
            style: {
              ...mono,
              flex: "1",
              minWidth: "120px",
              padding: "4px 8px",
              border: "1px solid #ccc",
              borderRadius: "4px"
            }
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 235,
            columnNumber: 15
          }, void 0), u$1("button", {
            onClick: handleManualUpdate,
            disabled: !manualKey || !manualValue || !configuratorInstance,
            style: {
              padding: "4px 12px",
              cursor: "pointer"
            },
            children: "Set"
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 242,
            columnNumber: 15
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 227,
          columnNumber: 13
        }, void 0), manualStatus && u$1("p", {
          style: {
            ...mono,
            margin: "4px 0 0",
            fontSize: "11px"
          },
          children: manualStatus
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 251,
          columnNumber: 15
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 225,
        columnNumber: 11
      }, void 0), currentConfig && u$1("details", {
        children: [u$1("summary", {
          style: {
            cursor: "pointer",
            fontWeight: 600,
            fontSize: "13px"
          },
          children: "Current configuration JSON"
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 258,
          columnNumber: 15
        }, void 0), u$1("pre", {
          style: {
            ...mono,
            background: "#f7f7f7",
            padding: "8px",
            overflow: "auto",
            maxHeight: "200px",
            marginTop: "6px",
            borderRadius: "4px"
          },
          children: currentConfig
        }, void 0, false, {
          fileName: _jsxFileName$5,
          lineNumber: 261,
          columnNumber: 15
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 257,
        columnNumber: 13
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$5,
      lineNumber: 135,
      columnNumber: 9
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$5,
    lineNumber: 93,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$4 = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/Roomle/RoomleViewer.tsx";
const RoomleViewer = D(({
  productId = "",
  configuratorId = "gikacoustics",
  catalogId = "gik"
}, ref) => {
  const containerRef = t$3(A$1(null), "containerRef");
  const viewerRef = t$3(A$1(null), "viewerRef");
  const [isLoading, setIsLoading] = t$3(d(true), "isLoading");
  const [error, setError] = t$3(d(null), "error");
  const [configuratorInstance, setConfiguratorInstance] = t$3(d(null), "configuratorInstance");
  const [parameters, setParameters] = t$3(d([]), "parameters");
  const [currentValues, setCurrentValues] = t$3(d({}), "currentValues");
  const isDebugMode = new URLSearchParams(window.location.search).get("roomleDebug") === "true";
  y(() => {
    initRoomleSwatchHandler();
  }, []);
  y(() => {
    const calculateStickyTop = () => {
      const topbar = document.querySelector(".topbar");
      const headerSection = document.querySelector(".header-section");
      let totalHeight = 0;
      if (topbar) {
        totalHeight += topbar.offsetHeight;
      }
      if (headerSection) {
        totalHeight += headerSection.offsetHeight;
      }
      if (viewerRef.current) {
        const galleryContainer = viewerRef.current.closest(".product__gallery-container");
        if (galleryContainer) {
          galleryContainer.style.setProperty("--roomle-sticky-top", `${totalHeight}px`);
        }
      }
    };
    calculateStickyTop();
    window.addEventListener("resize", calculateStickyTop);
    return () => {
      window.removeEventListener("resize", calculateStickyTop);
    };
  }, []);
  y(() => {
    const handleResponsivePosition = () => {
      var _a;
      const isMobile = window.innerWidth < 1024;
      const customElement = (_a = viewerRef.current) == null ? void 0 : _a.closest("roomle-viewer");
      const mobilePlaceholder = document.getElementById("roomle-viewer-mobile-placeholder");
      const desktopContainer = document.querySelector(".product__gallery-container");
      if (!customElement) {
        console.warn("⚠️ Could not find roomle-viewer custom element");
        return;
      }
      if (isMobile && mobilePlaceholder && customElement.parentElement !== mobilePlaceholder) {
        mobilePlaceholder.appendChild(customElement);
      } else if (!isMobile && desktopContainer && customElement.parentElement !== desktopContainer) {
        desktopContainer.insertBefore(customElement, desktopContainer.firstChild);
      }
    };
    const timer = setTimeout(() => {
      handleResponsivePosition();
    }, 100);
    const resizeHandler = () => {
      handleResponsivePosition();
    };
    window.addEventListener("resize", resizeHandler);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);
  const forceSceneRefresh = async (parameterAPI, isStructuralParameter = false) => {
    try {
      const refreshMethods = ["updateScene", "refreshScene", "rebuild", "rebuildScene", "updateVisuals", "refresh"];
      for (const method of refreshMethods) {
        if (typeof parameterAPI[method] === "function") {
          try {
            await parameterAPI[method]();
          } catch (err) {
            console.debug(`⚠️ ${method} not available or failed:`, err);
          }
        }
      }
      if (isStructuralParameter) {
        const structuralRefreshMethods = ["rebuildGeometry", "updateGeometry", "forceRebuild", "resetScene", "reloadConfiguration"];
        for (const method of structuralRefreshMethods) {
          if (typeof parameterAPI[method] === "function") {
            try {
              await parameterAPI[method]();
            } catch (err) {
              console.debug(`⚠️ Structural method ${method} not available:`, err);
            }
          }
        }
        await new Promise((resolve) => setTimeout(resolve, 150));
      }
    } catch (err) {
      console.warn("Error during scene refresh:", err);
    }
  };
  const forceStandingParameterRefresh = async (parameterAPI, value) => {
    var _a;
    try {
      const aggressiveRefreshSequence = [{
        method: "updateScene",
        delay: 50
      }, {
        method: "rebuild",
        delay: 100
      }, {
        method: "rebuildGeometry",
        delay: 100
      }, {
        method: "updateVisuals",
        delay: 50
      }, {
        method: "refreshScene",
        delay: 100
      }, {
        method: "rebuildScene",
        delay: 150
      }, {
        method: "updateGeometry",
        delay: 100
      }, {
        method: "forceRebuild",
        delay: 150
      }, {
        method: "resetScene",
        delay: 200
      }];
      for (const {
        method,
        delay
      } of aggressiveRefreshSequence) {
        if (typeof parameterAPI[method] === "function") {
          try {
            await parameterAPI[method]();
            await new Promise((resolve) => setTimeout(resolve, delay));
          } catch (err) {
            console.debug(`⚠️ ${method} failed:`, err);
          }
        }
      }
      if (value.toLowerCase() === "freestand") {
        try {
          const currentConfig = await parameterAPI.getCurrentConfiguration();
          if (configuratorInstance && typeof ((_a = configuratorInstance.ui) == null ? void 0 : _a.loadConfiguration) === "function") {
            await new Promise((resolve) => setTimeout(resolve, 100));
            await configuratorInstance.ui.loadConfiguration(currentConfig);
          }
        } catch (reloadErr) {
          console.debug("ℹ️ Configuration reload not available or failed:", reloadErr);
        }
      }
      try {
        const planParams = await parameterAPI.getParametersOfPlanObject();
        const standingParam = planParams == null ? void 0 : planParams.find((p2) => p2.key.toLowerCase() === "standing");
        if (standingParam && standingParam.value !== value) {
          await parameterAPI.setParameterOfPlanObject(standingParam, value);
          await parameterAPI.updateScene();
        }
      } catch (reapplyErr) {
        console.debug("ℹ️ Parameter re-application failed:", reapplyErr);
      }
      await new Promise((resolve) => setTimeout(resolve, 200));
    } catch (err) {
      console.warn("Error during standing parameter refresh:", err);
    }
  };
  const updateParameterForAllComponents = async (parameterAPI, parameterKey, value) => {
    try {
      const structuralParameters = ["standing", "mounting", "feet", "base", "support", "frame", "structure", "freestanding"];
      const isStructuralParameter = structuralParameters.includes(parameterKey.toLowerCase());
      const isStandingParameter = parameterKey.toLowerCase() === "standing";
      let hasNestedComponents = false;
      let parameterUpdated = false;
      let updateMethod = "";
      try {
        const currentConfigRaw = await parameterAPI.getCurrentConfiguration();
        const currentConfig = typeof currentConfigRaw === "string" ? JSON.parse(currentConfigRaw) : currentConfigRaw;
        hasNestedComponents = currentConfig && currentConfig.children && currentConfig.children.length > 0;
      } catch (err) {
        hasNestedComponents = false;
      }
      if (hasNestedComponents || isStandingParameter) {
        try {
          const planParams = await parameterAPI.getParametersOfPlanObject();
          const planParam = planParams == null ? void 0 : planParams.find((p2) => p2.key.toLowerCase() === parameterKey.toLowerCase());
          if (planParam && typeof parameterAPI.setParameterOfPlanObject === "function") {
            await parameterAPI.setParameterOfPlanObject(planParam, value);
            parameterUpdated = true;
            updateMethod = "plan object";
          }
        } catch (planErr) {
          console.debug("Plan parameter update failed, trying root component:", planErr);
        }
      }
      if (!parameterUpdated || !hasNestedComponents) {
        try {
          const rootParams = await parameterAPI.getParametersOfRootComponent();
          const rootParam = rootParams == null ? void 0 : rootParams.find((p2) => p2.key.toLowerCase() === parameterKey.toLowerCase());
          if (rootParam && typeof parameterAPI.setParameterOfRootComponent === "function") {
            await parameterAPI.setParameterOfRootComponent(rootParam, value);
            parameterUpdated = true;
            updateMethod = parameterUpdated ? `${updateMethod} + root` : "root component";
          }
        } catch (rootErr) {
          console.warn("Root parameter update failed:", rootErr);
        }
      }
      if (parameterUpdated && isStructuralParameter) {
        if (isStandingParameter) {
          await forceStandingParameterRefresh(parameterAPI, value);
        } else {
          await forceSceneRefresh(parameterAPI, isStructuralParameter);
        }
      } else if (parameterUpdated && !isStandingParameter) {
        await forceSceneRefresh(parameterAPI, false);
      }
      if (!parameterUpdated) {
        if (isStructuralParameter) {
          if (isStandingParameter) {
            await forceStandingParameterRefresh(parameterAPI, value);
          } else {
            await forceSceneRefresh(parameterAPI, true);
          }
        }
      }
    } catch (err) {
      console.error("Error updating parameter:", err);
      throw err;
    }
  };
  F(ref, () => ({
    updateParameter: async (parameterName, value) => {
      if (!configuratorInstance) {
        throw new Error("Configurator not initialized");
      }
      try {
        const parameterAPI = configuratorInstance.configurator;
        await updateParameterForAllComponents(parameterAPI, parameterName, value);
      } catch (err) {
        console.error("Error updating parameter:", err);
        throw err;
      }
    },
    getParameters: async () => {
      if (!configuratorInstance) {
        throw new Error("Configurator not initialized");
      }
      const parameterAPI = configuratorInstance.configurator;
      const allParams = [];
      if (typeof parameterAPI.getParametersOfRootComponent === "function") {
        const rootParams = await parameterAPI.getParametersOfRootComponent();
        allParams.push(...rootParams);
      }
      if (typeof parameterAPI.getPartList === "function") {
        const partList = await parameterAPI.getPartList();
        for (const part of partList) {
          if (part.runtimeId && typeof parameterAPI.getParametersOfComponent === "function") {
            try {
              const componentParams = await parameterAPI.getParametersOfComponent(part.runtimeId);
              allParams.push(...componentParams);
            } catch (err) {
              console.debug(`Couldn't get parameters for component ${part.runtimeId}:`, err);
            }
          }
        }
      }
      return allParams;
    },
    getConfiguration: async () => {
      if (!configuratorInstance) {
        throw new Error("Configurator not initialized");
      }
      return await configuratorInstance.getCurrentConfiguration();
    }
  }), [configuratorInstance]);
  const getSelectedSwatchValues = () => {
    const swatchValues = {};
    const checkedInputs = document.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
    checkedInputs.forEach((input) => {
      const inputElement = input;
      let label = null;
      if (inputElement.id) {
        label = document.querySelector(`label[for="${inputElement.id}"]`);
      }
      if (!label && inputElement.parentElement) {
        label = inputElement.parentElement.querySelector("label");
        if (!label) {
          const parent = inputElement.parentElement;
          label = parent.tagName.toLowerCase() === "label" ? parent : null;
        }
      }
      if (label) {
        const roomleFabric = label.getAttribute("data-roomle-fabric");
        const roomleColor = label.getAttribute("data-roomle-color");
        const roomleFrequency = label.getAttribute("data-roomle-frequency");
        const roomleShape = label.getAttribute("data-roomle-shape");
        const roomlePattern = label.getAttribute("data-roomle-pattern");
        const roomleFinish = label.getAttribute("data-roomle-finish");
        const roomleStanding = label.getAttribute("data-roomle-standing");
        const roomleEndCaps = label.getAttribute("data-roomle-endCaps");
        const roomleFreestanding = label.getAttribute("data-roomle-freeStanding");
        const roomleStackHeight = label.getAttribute("data-roomle-stackheight");
        if (roomleFabric) swatchValues["fabric"] = roomleFabric;
        if (roomleColor) swatchValues["fabric"] = roomleColor;
        if (roomleFrequency) swatchValues["frequency"] = roomleFrequency;
        if (roomleShape) swatchValues["shape"] = roomleShape;
        if (roomlePattern) swatchValues["pattern"] = roomlePattern;
        if (roomleFinish) swatchValues["finish"] = roomleFinish;
        if (roomleStanding) swatchValues["standing"] = roomleStanding;
        if (roomleEndCaps) swatchValues["endCaps"] = roomleEndCaps;
        if (roomleFreestanding) swatchValues["freeStanding"] = roomleFreestanding;
        if (roomleStackHeight) swatchValues["stackHeight"] = roomleStackHeight;
      }
    });
    const selectedSecondarySwatches = document.querySelectorAll(".selected[data-roomle-pattern], .selected[data-roomle-finish], .selected[data-roomle-standing], .selected[data-roomle-endCaps], .selected[data-roomle-freeStanding]");
    selectedSecondarySwatches.forEach((element) => {
      const swatchElement = element;
      const roomlePattern = swatchElement.getAttribute("data-roomle-pattern");
      const roomleFinish = swatchElement.getAttribute("data-roomle-finish");
      const roomleEndCaps = swatchElement.getAttribute("data-roomle-endCaps");
      if (roomlePattern) swatchValues["pattern"] = roomlePattern;
      if (roomleFinish) swatchValues["finish"] = roomleFinish;
      if (roomleEndCaps) swatchValues["endCaps"] = roomleEndCaps;
    });
    return swatchValues;
  };
  const updateParameter = async (parameterKey, value) => {
    if (!configuratorInstance) {
      return;
    }
    try {
      const parameterAPI = configuratorInstance.configurator;
      if (parameterAPI) {
        await updateParameterForAllComponents(parameterAPI, parameterKey, value);
        setCurrentValues((prev) => ({
          ...prev,
          [parameterKey]: value
        }));
      }
    } catch (err) {
      console.error("Error updating parameter:", err);
    }
  };
  y(() => {
    if (!productId || !configuratorId || !containerRef.current) {
      return;
    }
    if (configuratorInstance) {
      return;
    }
    const createViewer = async () => {
      setIsLoading(true);
      setError(null);
      try {
        if (containerRef.current) {
          containerRef.current.innerHTML = "";
        }
        const uiInitData = getRoomleUIConfig();
        const configurator = await u.createConfigurator(configuratorId, containerRef.current, uiInitData);
        await configurator.ui.loadObject(`${catalogId}:${productId}`);
        setConfiguratorInstance(configurator);
        setIsLoading(false);
        setTimeout(async () => {
          if (configurator) {
            try {
              const parameterAPI = configurator.configurator;
              if (parameterAPI && typeof parameterAPI.getParametersOfRootComponent === "function") {
                const params = await parameterAPI.getParametersOfRootComponent();
                setParameters(params);
                const initialValues = {};
                params.forEach((param) => {
                  initialValues[param.key] = param.value || param.currentValue || "";
                });
                const selectedSwatchValues = getSelectedSwatchValues();
                const mergedValues = {
                  ...initialValues,
                  ...selectedSwatchValues
                };
                setCurrentValues(mergedValues);
                for (const [parameterName, value] of Object.entries(selectedSwatchValues)) {
                  if (value) {
                    try {
                      await updateParameterForAllComponents(parameterAPI, parameterName, value);
                    } catch (err) {
                      console.warn(`Failed to set parameter ${parameterName} to ${value}:`, err);
                    }
                  }
                }
                if (typeof parameterAPI.updateScene === "function") {
                  await parameterAPI.updateScene();
                }
              }
            } catch (err) {
              console.error("Error loading parameters:", err);
            }
          }
        }, 100);
      } catch (err) {
        setError("Failed to load 3D viewer");
        setIsLoading(false);
      }
    };
    createViewer();
    return () => {
      var _a;
      if (configuratorInstance) {
        try {
          (_a = configuratorInstance.destroy) == null ? void 0 : _a.call(configuratorInstance);
        } catch (err) {
          console.error("Error destroying configurator:", err);
        }
        setConfiguratorInstance(null);
        setParameters([]);
        setCurrentValues({});
      }
    };
  }, [productId, configuratorId]);
  y(() => {
    if (!containerRef.current) return;
    const handleParameterUpdate = (event) => {
      const {
        parameterName,
        value
      } = event.detail;
      updateParameter(parameterName, value);
    };
    const container = containerRef.current;
    container.addEventListener("roomle-update-parameter", handleParameterUpdate);
    const element = container.closest("roomle-viewer");
    if (element) {
      element.updateRoomleParameter = async (parameterName, value) => {
        await updateParameter(parameterName, value);
      };
      element.getRoomleParameters = async () => {
        return parameters;
      };
    }
    setupRoomleDebugFunctions(configuratorInstance, ref, parameters, currentValues, getSelectedSwatchValues, isLoading, error, updateParameterForAllComponents, forceStandingParameterRefresh);
    return () => {
      container.removeEventListener("roomle-update-parameter", handleParameterUpdate);
      if (element) {
        delete element.updateRoomleParameter;
        delete element.getRoomleParameters;
      }
      cleanupRoomleDebugFunctions();
    };
  }, [configuratorInstance, parameters, currentValues, getSelectedSwatchValues, isLoading, error]);
  return u$1("div", {
    ref: viewerRef,
    className: "roomle-viewer",
    children: [error && u$1("div", {
      className: "roomle-viewer__error",
      role: "alert",
      children: error
    }, void 0, false, {
      fileName: _jsxFileName$4,
      lineNumber: 571,
      columnNumber: 9
    }, void 0), u$1("div", {
      ref: containerRef,
      className: "roomle-viewer__container",
      children: isLoading && u$1("div", {
        className: "roomle-viewer__loading",
        children: "Loading 3D viewer..."
      }, void 0, false, {
        fileName: _jsxFileName$4,
        lineNumber: 580,
        columnNumber: 11
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$4,
      lineNumber: 575,
      columnNumber: 7
    }, void 0), isDebugMode && u$1(RoomleViewerDebugPanel, {
      configuratorInstance,
      parameters,
      currentValues,
      getSelectedSwatchValues,
      updateParameter,
      productId,
      catalogId,
      configuratorId
    }, void 0, false, {
      fileName: _jsxFileName$4,
      lineNumber: 586,
      columnNumber: 9
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$4,
    lineNumber: 566,
    columnNumber: 5
  }, void 0);
});
register(RoomleViewer, "roomle-viewer");
var _jsxFileName$3 = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/SecondarySwatches/CustomSize.tsx";
const CustomSize = ({
  optionName = null,
  maxHeight = null,
  minHeight = null,
  maxWidth = null,
  minWidth = null,
  defaultUnit = "imperial",
  // Translation props
  description = null,
  heightLabel = null,
  widthLabel = null,
  cmButton = "cm",
  inchesButton = "inches",
  validationInvalid = null,
  validationHeightTooLow = null,
  validationHeightTooHigh = null,
  validationWidthTooLow = null,
  validationWidthTooHigh = null,
  heightAttrName = null,
  widthAttrName = null,
  customTrigger = null,
  optionSlug = null
}) => {
  const [unit, setUnit] = t$3(d(defaultUnit === "metric" ? "cm" : "inches"), "unit");
  const [height, setHeight] = t$3(d(""), "height");
  const [width, setWidth] = t$3(d(""), "width");
  const [heightError, setHeightError] = t$3(d(null), "heightError");
  const [widthError, setWidthError] = t$3(d(null), "widthError");
  const [isVisible, setIsVisible] = t$3(d(false), "isVisible");
  const handleUnitToggle = (newUnit) => {
    if (newUnit === unit) return;
    if (height) {
      setHeight(convertUnit(height, newUnit));
    }
    if (width) {
      setWidth(convertUnit(width, newUnit));
    }
    setUnit(newUnit);
    setHeightError(null);
    setWidthError(null);
  };
  const validateHeightInputWithProps = (value) => {
    if (!value) return null;
    const num = parseFloat(value);
    if (isNaN(num)) {
      return validationInvalid || "Please enter a valid number";
    }
    const currentUnitLabel = unit === "cm" ? "cm" : "inches";
    if (dimensions.minHeight !== void 0 && num < dimensions.minHeight) {
      return (validationHeightTooLow == null ? void 0 : validationHeightTooLow.replace(/{{ min }}/g, dimensions.minHeight.toFixed(0)).replace(/{{ unit }}/g, currentUnitLabel)) || `Height must be at least ${dimensions.minHeight.toFixed(0)}${currentUnitLabel}`;
    }
    if (dimensions.maxHeight !== void 0 && num > dimensions.maxHeight) {
      return (validationHeightTooHigh == null ? void 0 : validationHeightTooHigh.replace(/{{ max }}/g, dimensions.maxHeight.toFixed(0)).replace(/{{ unit }}/g, currentUnitLabel)) || `Height must not exceed ${dimensions.maxHeight.toFixed(0)}${currentUnitLabel}`;
    }
    return null;
  };
  const validateWidthInputWithProps = (value) => {
    if (!value) return null;
    const num = parseFloat(value);
    if (isNaN(num)) {
      return validationInvalid || "Please enter a valid number";
    }
    const currentUnitLabel = unit === "cm" ? "cm" : "inches";
    if (dimensions.minWidth !== void 0 && num < dimensions.minWidth) {
      return (validationWidthTooLow == null ? void 0 : validationWidthTooLow.replace(/{{ min }}/g, dimensions.minWidth.toFixed(0)).replace(/{{ unit }}/g, currentUnitLabel)) || `Width must be at least ${dimensions.minWidth.toFixed(0)}${currentUnitLabel}`;
    }
    if (dimensions.maxWidth !== void 0 && num > dimensions.maxWidth) {
      return (validationWidthTooHigh == null ? void 0 : validationWidthTooHigh.replace(/{{ max }}/g, dimensions.maxWidth.toFixed(0)).replace(/{{ unit }}/g, currentUnitLabel)) || `Width must not exceed ${dimensions.maxWidth.toFixed(0)}${currentUnitLabel}`;
    }
    return null;
  };
  const handleHeightInputChange = (value) => {
    setHeight(value);
    const validationError = validateHeightInputWithProps(value);
    setHeightError(validationError);
  };
  const handleWidthInputChange = (value) => {
    setWidth(value);
    const validationError = validateWidthInputWithProps(value);
    setWidthError(validationError);
  };
  const updateFormInput = () => {
    const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    const unitLabel2 = unit === "cm" ? cmButton : inchesButton;
    productForms.forEach((cartForm) => {
      if (heightAttrName) {
        const existingHeightInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${heightAttrName}]"]`);
        existingHeightInputs == null ? void 0 : existingHeightInputs.forEach((input) => input.remove());
        if (isVisible && height && !heightError) {
          const heightInput = document.createElement("input");
          heightInput.type = "hidden";
          heightInput.name = `properties[${heightAttrName}]`;
          heightInput.value = `${height} ${unitLabel2}`;
          cartForm == null ? void 0 : cartForm.appendChild(heightInput);
        }
      }
      if (widthAttrName) {
        const existingWidthInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${widthAttrName}]"]`);
        existingWidthInputs == null ? void 0 : existingWidthInputs.forEach((input) => input.remove());
        if (isVisible && width && !widthError) {
          const widthInput = document.createElement("input");
          widthInput.type = "hidden";
          widthInput.name = `properties[${widthAttrName}]`;
          widthInput.value = `${width} ${unitLabel2}`;
          cartForm == null ? void 0 : cartForm.appendChild(widthInput);
        }
      }
    });
  };
  const updateRoomleParameters = () => {
    if (!isVisible) return;
    if (height && minHeight !== null && maxHeight !== null && !heightError) {
      const heightInMm = convertToMillimeters(height, unit);
      if (heightInMm !== null) {
        const heightEvent = new CustomEvent("roomle-custom-size-update", {
          detail: {
            parameterName: "height",
            value: heightInMm.toFixed(0),
            originalValue: height,
            unit
          },
          bubbles: true
        });
        document.dispatchEvent(heightEvent);
      }
    }
    if (width && minWidth !== null && maxWidth !== null && !widthError) {
      const widthInMm = convertToMillimeters(width, unit);
      if (widthInMm !== null) {
        const widthEvent = new CustomEvent("roomle-custom-size-update", {
          detail: {
            parameterName: "width",
            value: widthInMm.toFixed(0),
            originalValue: width,
            unit
          },
          bubbles: true
        });
        document.dispatchEvent(widthEvent);
      }
    }
  };
  const dimensions = getMinMax(minHeight, maxHeight, minWidth, maxWidth, unit);
  const unitLabel = unit === "cm" ? "cm" : "inches";
  const shouldRenderHeight = dimensions.minHeight !== void 0 && dimensions.maxHeight !== void 0;
  const shouldRenderWidth = dimensions.minWidth !== void 0 && dimensions.maxWidth !== void 0;
  const normalizeSlug = (text) => {
    return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
  };
  const checkVisibility = () => {
    var _a;
    if (!optionName) return false;
    const slug = optionSlug || normalizeSlug(optionName);
    const fieldset = document.querySelector(`[data-option-slug="${slug}"]`);
    if (!fieldset) return false;
    const selectedInput = fieldset.querySelector("input:checked, select option[selected]");
    if (!selectedInput) return false;
    const selectedValue = selectedInput.value || ((_a = selectedInput.textContent) == null ? void 0 : _a.trim()) || "";
    const trigger = (customTrigger || "custom").toLowerCase();
    return selectedValue.toLowerCase().includes(trigger);
  };
  const updateVisibility = () => {
    const shouldBeVisible = checkVisibility();
    setIsVisible(shouldBeVisible);
  };
  y(() => {
    var _a, _b, _c;
    updateVisibility();
    const handleOptionChange = () => {
      updateVisibility();
    };
    const variantSelects = document.querySelector("variant-selects");
    if (variantSelects) {
      variantSelects.addEventListener("change", handleOptionChange);
    }
    if (((_b = (_a = window.theme) == null ? void 0 : _a.pubsub) == null ? void 0 : _b.subscribe) && ((_c = window.theme.pubsub.PUB_SUB_EVENTS) == null ? void 0 : _c.optionValueSelectionChange)) {
      const unsubscriber = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, handleOptionChange);
      return () => {
        if (variantSelects) {
          variantSelects.removeEventListener("change", handleOptionChange);
        }
        if (unsubscriber) {
          unsubscriber();
        }
      };
    }
    return () => {
      if (variantSelects) {
        variantSelects.removeEventListener("change", handleOptionChange);
      }
    };
  }, [optionName]);
  y(() => {
    if (isVisible) {
      updateFormInput();
      updateRoomleParameters();
    } else {
      const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
      productForms.forEach((cartForm) => {
        if (heightAttrName) {
          const heightInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${heightAttrName}]"]`);
          heightInputs == null ? void 0 : heightInputs.forEach((input) => input.remove());
        }
        if (widthAttrName) {
          const widthInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${widthAttrName}]"]`);
          widthInputs == null ? void 0 : widthInputs.forEach((input) => input.remove());
        }
      });
    }
  }, [height, width, unit, shouldRenderHeight, shouldRenderWidth, isVisible, heightError, widthError, heightAttrName, widthAttrName]);
  y(() => {
    return () => {
      const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
      productForms.forEach((cartForm) => {
        if (heightAttrName) {
          const heightInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${heightAttrName}]"]`);
          heightInputs == null ? void 0 : heightInputs.forEach((input) => input.remove());
        }
        if (widthAttrName) {
          const widthInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${widthAttrName}]"]`);
          widthInputs == null ? void 0 : widthInputs.forEach((input) => input.remove());
        }
      });
    };
  }, [heightAttrName, widthAttrName]);
  if (!shouldRenderHeight && !shouldRenderWidth || !isVisible) {
    return null;
  }
  return u$1("div", {
    className: "custom-size-component",
    children: [u$1("div", {
      className: "custom-size-component__description",
      children: description ? description.replace(/{{ optionName }}/g, optionName || "") : `Enter your custom dimensions for "${optionName}"`
    }, void 0, false, {
      fileName: _jsxFileName$3,
      lineNumber: 371,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "custom-size-component__form",
      children: [u$1("div", {
        className: "custom-size-component__unit-toggle",
        children: [u$1("button", {
          type: "button",
          onClick: () => handleUnitToggle("cm"),
          className: `custom-size-component__unit-btn ${unit === "cm" ? "active" : ""}`,
          children: cmButton || "cm"
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 377,
          columnNumber: 11
        }, void 0), u$1("button", {
          type: "button",
          onClick: () => handleUnitToggle("inches"),
          className: `custom-size-component__unit-btn ${unit === "inches" ? "active" : ""}`,
          children: inchesButton || "inches"
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 384,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$3,
        lineNumber: 376,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "custom-size-component__inputs",
        children: [shouldRenderHeight && u$1("div", {
          className: "custom-size-component__input-group",
          children: [u$1("label", {
            className: "custom-size-component__label",
            children: heightLabel ? heightLabel.replace(/{{ unit }}/g, unit === "cm" ? cmButton : inchesButton) : `Height (${unitLabel})`
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 396,
            columnNumber: 15
          }, void 0), u$1("input", {
            type: "number",
            value: height,
            onInput: (e2) => handleHeightInputChange(e2.target.value),
            placeholder: `${dimensions.minHeight.toFixed(0)} - ${dimensions.maxHeight.toFixed(0)}`,
            className: `custom-size-component__input ${heightError ? "error" : ""}`,
            min: dimensions.minHeight,
            max: dimensions.maxHeight,
            step: "1"
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 399,
            columnNumber: 15
          }, void 0), heightError && u$1("span", {
            className: "custom-size-component__error",
            children: heightError
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 410,
            columnNumber: 17
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$3,
          lineNumber: 395,
          columnNumber: 13
        }, void 0), shouldRenderWidth && u$1("div", {
          className: "custom-size-component__input-group",
          children: [u$1("label", {
            className: "custom-size-component__label",
            children: widthLabel ? widthLabel.replace(/{{ unit }}/g, unitLabel) : `Width (${unitLabel})`
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 417,
            columnNumber: 15
          }, void 0), u$1("input", {
            type: "number",
            value: width,
            onInput: (e2) => handleWidthInputChange(e2.target.value),
            placeholder: `${dimensions.minWidth.toFixed(0)} - ${dimensions.maxWidth.toFixed(0)}`,
            className: `custom-size-component__input ${widthError ? "error" : ""}`,
            min: dimensions.minWidth,
            max: dimensions.maxWidth,
            step: "1"
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 420,
            columnNumber: 15
          }, void 0), widthError && u$1("span", {
            className: "custom-size-component__error",
            children: widthError
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 431,
            columnNumber: 17
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$3,
          lineNumber: 416,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$3,
        lineNumber: 393,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$3,
      lineNumber: 375,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$3,
    lineNumber: 370,
    columnNumber: 5
  }, void 0);
};
register(CustomSize, "custom-size", ["optionName", "productFormId", "optionValues", "sectionId", "productId", "maxHeight", "minHeight", "maxWidth", "minWidth", "description", "heightLabel", "widthLabel", "cmButton", "inchesButton", "validationInvalid", "validationHeightTooLow", "validationHeightTooHigh", "validationWidthTooLow", "validationWidthTooHigh", "heightAttrName", "widthAttrName", "customTrigger", "optionSlug"]);
var _jsxFileName$2 = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/SecondarySwatches/CustomFrequency.tsx";
const CustomFrequency = ({
  optionName = null,
  minFrequency = "40",
  maxFrequency = "150",
  placeholder = null,
  label = null,
  range = null,
  validationRequired = null,
  validationInvalid = null,
  validationTooLow = null,
  validationTooHigh = null,
  frequencyAttrName = null
}) => {
  const [frequency, setFrequency] = t$3(d(""), "frequency");
  const [frequencyError, setFrequencyError] = t$3(d(null), "frequencyError");
  const [isVisible, setIsVisible] = t$3(d(false), "isVisible");
  const minFreq = parseInt(minFrequency || "40", 10);
  const maxFreq = parseInt(maxFrequency || "150", 10);
  const validateFrequencyInput = (value) => {
    if (!value) {
      return validationRequired || "Frequency is required";
    }
    const numValue = parseFloat(value);
    if (isNaN(numValue)) {
      return validationInvalid || "Please enter a valid number";
    }
    if (numValue < minFreq) {
      return (validationTooLow == null ? void 0 : validationTooLow.replace(/{{ minFreq }}/g, minFreq.toString())) || `Frequency must be at least ${minFreq} Hz`;
    }
    if (numValue > maxFreq) {
      return (validationTooHigh == null ? void 0 : validationTooHigh.replace(/{{ maxFreq }}/g, maxFreq.toString())) || `Frequency cannot exceed ${maxFreq} Hz`;
    }
    return null;
  };
  const handleFrequencyInputChange = (value) => {
    setFrequency(value);
    const validationError = validateFrequencyInput(value);
    setFrequencyError(validationError);
  };
  const updateFormInput = () => {
    const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    productForms.forEach((cartForm) => {
      let customFrequencyInput = cartForm == null ? void 0 : cartForm.querySelector(`input[name="properties[${frequencyAttrName}]"]`);
      if (!isVisible) {
        if (customFrequencyInput) {
          customFrequencyInput.remove();
        }
        return;
      }
      if (!customFrequencyInput) {
        customFrequencyInput = document.createElement("input");
        customFrequencyInput.type = "hidden";
        customFrequencyInput.name = `properties[${frequencyAttrName}]`;
        cartForm == null ? void 0 : cartForm.appendChild(customFrequencyInput);
      }
      if (!frequencyError && frequency) {
        customFrequencyInput.value = `${frequency}Hz`;
      } else {
        customFrequencyInput.value = "";
      }
    });
  };
  const updateRoomleParameters = () => {
    if (!isVisible || !frequency || frequencyError) return;
    const frequencyEvent = new CustomEvent("roomle-custom-frequency-update", {
      detail: {
        parameterName: "frequency",
        value: frequency,
        unit: "Hz"
      },
      bubbles: true
    });
    document.dispatchEvent(frequencyEvent);
  };
  const normalizeSlug = (text) => {
    return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
  };
  const checkVisibility = () => {
    var _a;
    if (!optionName) return false;
    const slug = normalizeSlug(optionName);
    const fieldset = document.querySelector(`[data-option-slug="${slug}"]`);
    if (!fieldset) return false;
    const selectedInput = fieldset.querySelector("input:checked, select option[selected]");
    if (!selectedInput) return false;
    const selectedValue = selectedInput.value || ((_a = selectedInput.textContent) == null ? void 0 : _a.trim()) || "";
    const lowerValue = selectedValue.toLowerCase();
    return lowerValue.includes("custom") || lowerValue.includes("personnal") || lowerValue.includes("personali") || lowerValue.includes("benutz");
  };
  const updateVisibility = () => {
    const shouldBeVisible = checkVisibility();
    setIsVisible(shouldBeVisible);
    if (shouldBeVisible && !frequency) {
      setFrequency("");
      setFrequencyError(null);
    }
  };
  y(() => {
    var _a, _b, _c;
    updateVisibility();
    const handleOptionChange = () => {
      updateVisibility();
    };
    const variantSelects = document.querySelector("variant-selects");
    if (variantSelects) {
      variantSelects.addEventListener("change", handleOptionChange);
    }
    if (((_b = (_a = window.theme) == null ? void 0 : _a.pubsub) == null ? void 0 : _b.subscribe) && ((_c = window.theme.pubsub.PUB_SUB_EVENTS) == null ? void 0 : _c.optionValueSelectionChange)) {
      const unsubscriber = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, handleOptionChange);
      return () => {
        if (variantSelects) {
          variantSelects.removeEventListener("change", handleOptionChange);
        }
        if (unsubscriber) {
          unsubscriber();
        }
      };
    }
    return () => {
      if (variantSelects) {
        variantSelects.removeEventListener("change", handleOptionChange);
      }
    };
  }, [optionName]);
  y(() => {
    if (isVisible) {
      updateFormInput();
      updateRoomleParameters();
    } else {
      const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
      productForms.forEach((cartForm) => {
        const customFrequencyInput = cartForm == null ? void 0 : cartForm.querySelector(`input[name="properties[${frequencyAttrName}]"]`);
        if (customFrequencyInput) {
          customFrequencyInput.remove();
        }
      });
    }
  }, [frequency, isVisible, frequencyError]);
  y(() => {
    return () => {
      const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
      productForms.forEach((cartForm) => {
        const customFrequencyInput = cartForm == null ? void 0 : cartForm.querySelector(`input[name="properties[${frequencyAttrName}]"]`);
        if (customFrequencyInput) {
          customFrequencyInput.remove();
        }
      });
    };
  }, []);
  if (!isVisible) {
    return null;
  }
  return u$1("div", {
    className: "custom-frequency-component",
    children: [u$1("div", {
      className: "custom-frequency-component__description",
      children: placeholder || "Enter your custom tuning frequency"
    }, void 0, false, {
      fileName: _jsxFileName$2,
      lineNumber: 218,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "custom-frequency-component__form",
      children: [u$1("div", {
        className: "custom-frequency-component__input-group",
        children: [u$1("label", {
          className: "custom-frequency-component__label",
          children: label || "Frequency (Hz)"
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 224,
          columnNumber: 11
        }, void 0), u$1("div", {
          className: "custom-frequency-component__input-wrapper",
          children: [u$1("input", {
            type: "number",
            value: frequency,
            onInput: (e2) => handleFrequencyInputChange(e2.target.value),
            placeholder: `${minFreq} - ${maxFreq}`,
            className: `custom-frequency-component__input ${frequencyError ? "error" : ""}`,
            min: minFreq,
            max: maxFreq,
            step: "1"
          }, void 0, false, {
            fileName: _jsxFileName$2,
            lineNumber: 228,
            columnNumber: 13
          }, void 0), u$1("span", {
            className: "custom-frequency-component__input-suffix",
            children: "Hz"
          }, void 0, false, {
            fileName: _jsxFileName$2,
            lineNumber: 238,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$2,
          lineNumber: 227,
          columnNumber: 11
        }, void 0), frequencyError && u$1("span", {
          className: "custom-frequency-component__error",
          children: frequencyError
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 241,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$2,
        lineNumber: 223,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "custom-frequency-component__range-display",
        children: range ? range.replace(/{{ minFreq }}/g, minFreq.toString()).replace(/{{ maxFreq }}/g, maxFreq.toString()) : `Range: ${minFreq} Hz - ${maxFreq} Hz`
      }, void 0, false, {
        fileName: _jsxFileName$2,
        lineNumber: 245,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$2,
      lineNumber: 222,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$2,
    lineNumber: 217,
    columnNumber: 5
  }, void 0);
};
register(CustomFrequency, "custom-frequency", ["optionName", "minFrequency", "maxFrequency", "placeholder", "label", "range", "validationRequired", "validationInvalid", "validationTooLow", "validationTooHigh"]);
var _jsxFileName$1 = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/FlexRangeSwatches.tsx";
const FlexRangeSwatches = ({
  swatchValues = null,
  optionName = null,
  productFormId = null,
  flexrangeAttrName = null,
  swatchValueTranslations = null,
  shopLocale = null
}) => {
  const [selectedSwatch, setSelectedSwatch] = t$3(d(null), "selectedSwatch");
  const [componentId] = t$3(d(() => `flexrange-swatches-${Math.random().toString(36).substr(2, 9)}`), "componentId");
  const [hasPreSelected, setHasPreSelected] = t$3(d(false), "hasPreSelected");
  const swatchValuesArray = swatchValues ? JSON.parse(swatchValues) : [];
  const translationsArray = t$3(T$1(() => {
    if (!swatchValueTranslations) return [];
    try {
      return JSON.parse(swatchValueTranslations);
    } catch {
      return [];
    }
  }, [swatchValueTranslations]), "translationsArray: SwatchValueTranslation[]");
  const getTranslatedValue = (value) => {
    if (!value || (translationsArray == null ? void 0 : translationsArray.length) === 0) return value;
    const normalizedValue = value.toLowerCase();
    const translation = translationsArray == null ? void 0 : translationsArray.find((t2) => {
      var _a;
      return ((_a = t2.english_swatch_value) == null ? void 0 : _a.toLowerCase()) === normalizedValue;
    });
    if (!translation) return value;
    const locale = (shopLocale == null ? void 0 : shopLocale.toLowerCase()) || "en";
    switch (locale) {
      case "fr":
        return translation.french_translation || value;
      case "de":
        return translation.german_translation || value;
      case "it":
        return translation.italian_translation || value;
      case "es":
        return translation.spanish_translation || value;
      case "en":
      default:
        return value;
    }
  };
  const toggleSwatchSelection = (variant) => {
    setSelectedSwatch((prev) => prev === variant ? prev : variant);
  };
  const getSelectedText = () => {
    if (!selectedSwatch) return "";
    const selected = swatchValuesArray.find((swatch) => swatch.flexrange_variant === selectedSwatch);
    return (selected == null ? void 0 : selected.name) || "";
  };
  const updateLineItemProperty = (value) => {
    if (!productFormId) return;
    const productForms = [document.getElementById(productFormId), document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    productForms.forEach((form) => {
      const existingInputs = form == null ? void 0 : form.querySelectorAll(`input[name="properties[${flexrangeAttrName}]"]`);
      existingInputs == null ? void 0 : existingInputs.forEach((input) => input.remove());
      if (value) {
        const propertyInput = document.createElement("input");
        propertyInput.type = "hidden";
        propertyInput.name = `properties[${flexrangeAttrName}]`;
        propertyInput.value = value;
        form == null ? void 0 : form.appendChild(propertyInput);
      }
    });
  };
  y(() => {
    if (!hasPreSelected && swatchValuesArray.length > 0) {
      const firstSwatch = swatchValuesArray[0];
      if (firstSwatch == null ? void 0 : firstSwatch.flexrange_variant) {
        setSelectedSwatch(firstSwatch.flexrange_variant);
        setHasPreSelected(true);
      }
    }
  }, [swatchValuesArray, hasPreSelected]);
  y(() => {
    const selectedText = getSelectedText();
    updateLineItemProperty(selectedText);
  }, [selectedSwatch, productFormId]);
  y(() => {
    return () => {
      if (productFormId) {
        updateLineItemProperty("");
      }
    };
  }, []);
  return u$1("div", {
    className: "secondary-swatches",
    children: u$1("div", {
      className: "secondary-swatches__content",
      children: u$1("div", {
        className: "secondary-swatches__options",
        children: u$1("fieldset", {
          className: "secondary-swatches__option-group variant-input-wrapper border-0",
          children: [u$1("legend", {
            className: "sr-only",
            children: optionName || "FlexRange Technology"
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 138,
            columnNumber: 13
          }, void 0), u$1("div", {
            className: "form__label flex items-center justify-between gap-2 w-full",
            children: u$1("div", {
              className: "flex gap-2",
              children: [u$1("span", {
                className: "form__label-pretext",
                children: [optionName || "FlexRange Technology", ":"]
              }, void 0, true, {
                fileName: _jsxFileName$1,
                lineNumber: 141,
                columnNumber: 17
              }, void 0), u$1("span", {
                className: "font-medium form__label-text",
                id: `${componentId}-selected`,
                children: getTranslatedValue(getSelectedText())
              }, void 0, false, {
                fileName: _jsxFileName$1,
                lineNumber: 144,
                columnNumber: 17
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$1,
              lineNumber: 140,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 139,
            columnNumber: 13
          }, void 0), u$1("ul", {
            className: "swatches swatches--rounded flex items-start flex-wrap gap-4",
            children: swatchValuesArray.map((swatch, index) => {
              const isSelected = selectedSwatch === swatch.flexrange_variant;
              return u$1("li", {
                children: u$1("div", {
                  className: "block",
                  children: u$1("div", {
                    className: `label-swatch swatches--round-slight inline-block text-sm font-medium leading-none relative px-3 py-2 border border-gray-300 rounded ${isSelected ? "selected cursor-default" : "cursor-pointer"}`,
                    title: getTranslatedValue(swatch.name),
                    onClick: () => !isSelected && toggleSwatchSelection(swatch.flexrange_variant),
                    children: getTranslatedValue(swatch.name)
                  }, void 0, false, {
                    fileName: _jsxFileName$1,
                    lineNumber: 156,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$1,
                  lineNumber: 155,
                  columnNumber: 21
                }, void 0)
              }, `flexrange-${index}`, false, {
                fileName: _jsxFileName$1,
                lineNumber: 154,
                columnNumber: 19
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 149,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$1,
          lineNumber: 137,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$1,
        lineNumber: 136,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$1,
      lineNumber: 135,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName$1,
    lineNumber: 134,
    columnNumber: 5
  }, void 0);
};
register(FlexRangeSwatches, "flexrange-swatches", ["swatchValues", "optionName", "productFormId", "swatchValueTranslations", "shopLocale"]);
var _jsxFileName = "/Users/jkroswell/Documents/roswell/Repos/GIK2024_GIK/src/components/CustomColorSwatches.tsx";
const CustomColorSwatches = ({
  colorPattern = null,
  productFormId = null,
  optionName = null,
  colorAttrName = null,
  roomleColorMapping = null,
  helpContent = null
}) => {
  const [selectedSwatch, setSelectedSwatch] = t$3(d(null), "selectedSwatch");
  const [componentId] = t$3(d(() => `custom-color-swatches-${Math.random().toString(36).substr(2, 9)}`), "componentId");
  const [hasPreSelected, setHasPreSelected] = t$3(d(false), "hasPreSelected");
  const colorPatternArray = colorPattern ? JSON.parse(colorPattern) : [];
  const colorMapping = roomleColorMapping ? JSON.parse(roomleColorMapping) : {};
  const helpContentLookup = t$3(T$1(() => parseHelpContent(helpContent), [helpContent]), "helpContentLookup");
  const tooltipText = helpContentLookup["color"] || "";
  const getRoomleColorValue = (label) => {
    if (!colorMapping) return "";
    if (colorMapping[label]) {
      return colorMapping[label];
    }
    for (const [colorName, roomleValue] of Object.entries(colorMapping)) {
      if (label.toLowerCase().includes(colorName.toLowerCase())) {
        return roomleValue;
      }
    }
    return "";
  };
  const toggleSwatchSelection = (label) => {
    if (selectedSwatch === label) return;
    setSelectedSwatch(label);
    const roomleColorValue = getRoomleColorValue(label);
    if (roomleColorValue) {
      const roomleEvent = new CustomEvent("roomle-color-update", {
        detail: {
          parameterName: "color",
          value: roomleColorValue
        },
        bubbles: true
      });
      document.dispatchEvent(roomleEvent);
    }
  };
  const getSelectedText = () => {
    if (!selectedSwatch) return "";
    const selected = colorPatternArray.find((swatch) => swatch.label === selectedSwatch);
    return (selected == null ? void 0 : selected.label) || "";
  };
  const updateLineItemProperty = (value) => {
    if (!productFormId) return;
    const productForms = [document.getElementById(productFormId), document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    productForms.forEach((form) => {
      const existingInputs = form == null ? void 0 : form.querySelectorAll(`input[name="properties[${colorAttrName}]"]`);
      existingInputs == null ? void 0 : existingInputs.forEach((input) => input.remove());
      if (value) {
        const propertyInput = document.createElement("input");
        propertyInput.type = "hidden";
        propertyInput.name = `properties[${colorAttrName}]`;
        propertyInput.value = value;
        form == null ? void 0 : form.appendChild(propertyInput);
      }
    });
  };
  y(() => {
    if (!hasPreSelected && colorPatternArray.length > 0) {
      const firstSwatch = colorPatternArray[0];
      if (firstSwatch == null ? void 0 : firstSwatch.label) {
        setSelectedSwatch(firstSwatch.label);
        setHasPreSelected(true);
      }
    }
  }, [colorPatternArray, hasPreSelected]);
  y(() => {
    const selectedText = getSelectedText();
    updateLineItemProperty(selectedText);
  }, [selectedSwatch, productFormId]);
  y(() => {
    return () => {
      if (productFormId) {
        updateLineItemProperty("");
      }
    };
  }, []);
  return u$1("div", {
    className: "secondary-swatches custom-color-swatches",
    children: u$1("div", {
      className: "secondary-swatches__content",
      children: u$1("div", {
        className: "secondary-swatches__options",
        children: u$1("fieldset", {
          className: "secondary-swatches__option-group variant-input-wrapper border-0",
          children: [u$1("legend", {
            className: "sr-only",
            children: optionName || "Color"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 132,
            columnNumber: 13
          }, void 0), u$1("div", {
            className: "form__label flex items-center justify-between gap-2 w-full",
            children: [u$1("div", {
              className: "flex gap-2",
              children: [u$1("span", {
                className: "form__label-pretext",
                children: [optionName || "Color", ":"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 135,
                columnNumber: 17
              }, void 0), u$1("span", {
                className: "font-medium form__label-text",
                id: `${componentId}-selected`,
                children: getSelectedText()
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 138,
                columnNumber: 17
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 134,
              columnNumber: 15
            }, void 0), tooltipText && u$1(TooltipIcon, {
              tooltipText
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 142,
              columnNumber: 31
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 133,
            columnNumber: 13
          }, void 0), u$1("ul", {
            className: "swatches swatches--rounded flex items-start flex-wrap gap-4",
            children: colorPatternArray.map((swatch, index) => {
              const isSelected = selectedSwatch === swatch.label;
              const inputId = `${componentId}-${index}`;
              const roomleColorValue = getRoomleColorValue(swatch.label);
              return u$1("li", {
                children: u$1("magnet-element", {
                  className: "block",
                  children: [u$1("input", {
                    type: "radio",
                    className: `sr-only${isSelected ? " checked" : ""}`,
                    id: inputId,
                    name: `${componentId}-color`,
                    value: swatch.label,
                    checked: isSelected ? true : false,
                    onChange: () => toggleSwatchSelection(swatch.label)
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 154,
                    columnNumber: 23
                  }, void 0), u$1("label", {
                    htmlFor: inputId,
                    className: `color-swatch${swatch.image ? " with-image" : ""} inline-block cursor-pointer relative`,
                    title: swatch.label,
                    style: {
                      "--swatch-background": swatch.color,
                      ...swatch.image && {
                        "--swatch-background-image": `url(${swatch.image})`
                      }
                    },
                    ...roomleColorValue && {
                      "data-roomle-color": roomleColorValue
                    },
                    children: u$1("span", {
                      className: "tooltip opacity-0 pointer-events-none text-xs rounded-full z-10",
                      children: swatch.label
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 173,
                      columnNumber: 25
                    }, void 0)
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 163,
                    columnNumber: 23
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 153,
                  columnNumber: 21
                }, void 0)
              }, `color-${index}`, false, {
                fileName: _jsxFileName,
                lineNumber: 151,
                columnNumber: 19
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 144,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 131,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 128,
    columnNumber: 5
  }, void 0);
};
register(CustomColorSwatches, "custom-color-swatches", ["colorPattern", "productFormId", "optionName", "colorAttrName", "roomleColorMapping", "helpContent"]);
